"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7303],{

/***/ 33445:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Button__WEBPACK_IMPORTED_MODULE_0__.z; },
/* harmony export */   "l": function() { return /* reexport safe */ _Button__WEBPACK_IMPORTED_MODULE_0__.l; }
/* harmony export */ });
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62073);


/***/ }),

/***/ 16164:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Paper_Paper; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/matcha/components/Paper/Paper.views.tsx

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "etxif140"
} : 0)("background:", function (_ref) {
  var background = _ref.background;
  return background;
}, ";border-radius:", function (_ref2) {
  var borderRadius = _ref2.borderRadius;
  return borderRadius;
}, "px;border:", function (_ref3) {
  var border = _ref3.border;
  return border;
}, ";width:100%;height:100%;box-shadow:", function (_ref4) {
  var theme = _ref4.theme,
      elevation = _ref4.elevation;
  return theme.shadows[elevation];
}, ";" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/components/Paper/Paper.tsx


var _excluded = ["background", "borderRadius", "border", "elevation", "children"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var Paper = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var background = _ref.background,
      _ref$borderRadius = _ref.borderRadius,
      borderRadius = _ref$borderRadius === void 0 ? 10 : _ref$borderRadius,
      _ref$border = _ref.border,
      border = _ref$border === void 0 ? "none" : _ref$border,
      _ref$elevation = _ref.elevation,
      elevation = _ref$elevation === void 0 ? 0 : _ref$elevation,
      children = _ref.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, _objectSpread(_objectSpread({
    background: background || theme.palette.brand.boysenberry[100],
    borderRadius: borderRadius,
    border: border,
    elevation: elevation,
    ref: ref
  }, rest), {}, {
    children: children
  }));
});
/* harmony default export */ var Paper_Paper = (Paper);
;// CONCATENATED MODULE: ../../libs/matcha/components/Paper/index.ts


/***/ }),

/***/ 90629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ UtilityNav_UtilityNav; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../libs/utils/useMatchMedia/index.ts + 1 modules
var useMatchMedia = __webpack_require__(61093);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/UtilityNav/useUtilityNavDescriptions.tsx




var useUtilityNavDescriptions = function useUtilityNavDescriptions(descriptions) {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  var keys = (0,react.useMemo)(function () {
    if (!descriptions) return [];
    return Object.keys(descriptions);
  }, [descriptions]);
  var breakpointsKeys = Object.keys(theme.breakpoints.values);
  var sortedArrayOfKeys = (0,react.useMemo)(function () {
    return breakpointsKeys.filter(function (main) {
      return keys.some(function (key) {
        return key === main;
      });
    });
  }, [breakpointsKeys, keys]);

  var getNextKey = function getNextKey(key, index) {
    if (sortedArrayOfKeys[index - 1]) {
      var getIndexofCurrentKey = breakpointsKeys.indexOf(key);

      if (breakpointsKeys[getIndexofCurrentKey - 1] !== sortedArrayOfKeys[index - 1]) {
        return breakpointsKeys[breakpointsKeys.indexOf(key) - 1];
      }
    }

    return false;
  };

  var array = sortedArrayOfKeys.map(function (key, index) {
    var nextKey = getNextKey(key, index);
    var minWidth = sortedArrayOfKeys[index - 1] ? " and ".concat(theme.breakpoints.up(nextKey ? nextKey : key, false)) : "";
    var mediaString = "".concat(theme.breakpoints.down(key, false)).concat(minWidth);
    return (0,useMatchMedia/* default */.Z)(mediaString, true);
  });
  return descriptions[sortedArrayOfKeys[array.indexOf(true)]];
};

/* harmony default export */ var UtilityNav_useUtilityNavDescriptions = (useUtilityNavDescriptions);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
// EXTERNAL MODULE: ../../libs/matcha/components/ButtonText/index.ts
var ButtonText = __webpack_require__(74870);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/UtilityNav/UtilityNav.views.ts


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}



var StyledTypography = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e12rge5s2"
} : 0)( true ? {
  name: "ti75j2",
  styles: "margin:0"
} : 0);
var StyledButtonText = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ButtonText/* default */.Z,  true ? {
  target: "e12rge5s1"
} : 0)("padding-top:3px;margin:0 8px;font-size:", function (_ref) {
  var theme = _ref.theme;
  return theme.typography.buttonSmall;
}, ";&:after{height:1px;bottom:4px;}" + ( true ? "" : 0));
var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e12rge5s0"
} : 0)("width:100%;text-align:center;background:", function (_ref2) {
  var background = _ref2.background;
  return background;
}, ";padding:7px 17px;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("xs");
}, "{padding:17px 40px;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/UtilityNav/UtilityNav.tsx


var _excluded = ["announcement", "tokens"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var UtilityNavBase = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var announcement = _ref.announcement,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var utilityNavDescriptions = "";

  if (typeof (announcement === null || announcement === void 0 ? void 0 : announcement.description) === "string") {
    utilityNavDescriptions = announcement.description;
  } else if (announcement !== null && announcement !== void 0 && announcement.description) {
    utilityNavDescriptions = UtilityNav_useUtilityNavDescriptions(announcement.description);
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, _objectSpread(_objectSpread({}, rest), {}, {
    ref: ref,
    background: tokens.background,
    children: [utilityNavDescriptions && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledTypography, {
      variant: "buttonSmall",
      children: utilityNavDescriptions
    }), announcement && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledButtonText, {
      tokens: _objectSpread({}, tokens.buttonText),
      size: "small",
      href: announcement.ctaLink,
      hover: true,
      children: announcement.ctaTitle
    })]
  }));
});
var UtilityNav = (0,useDesignTokens/* withDesignTokens */.Y)(UtilityNavBase, function () {
  return {};
}, {
  twilioLight: function twilioLight(theme) {
    return {
      background: theme.palette.twilio.gray[10],
      buttonText: {
        textColor: theme.palette.twilio.gray[100],
        hoverColor: theme.palette.twilio.gray[100]
      }
    };
  },
  light: function light(theme) {
    return {
      background: theme.palette.twilio.gray[10],
      buttonText: {
        textColor: theme.palette.twilio.gray[100],
        hoverColor: theme.palette.twilio.gray[100]
      }
    };
  },
  dark: function dark(theme) {
    return {
      background: theme.palette.twilio.gray[10],
      buttonText: {
        textColor: theme.palette.twilio.gray[100],
        hoverColor: theme.palette.twilio.gray[100]
      }
    };
  }
});
/* harmony default export */ var UtilityNav_UtilityNav = (UtilityNav);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/UtilityNav/index.ts


/***/ }),

/***/ 87303:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Navigation_Navigation; }
});

// EXTERNAL MODULE: ../../libs/matcha/components/Media/index.ts + 2 modules
var Media = __webpack_require__(75091);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
// EXTERNAL MODULE: ../../libs/matcha/components/SegmentLogo/index.ts + 2 modules
var SegmentLogo = __webpack_require__(84672);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/components/ColumnTrack/index.ts + 2 modules
var ColumnTrack = __webpack_require__(85735);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/UtilityNav/index.ts + 3 modules
var UtilityNav = __webpack_require__(90629);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/useNavigation.tsx


var useNavigation = function useNavigation(value) {
  var _useState = (0,react.useState)(value),
      activeDropdown = _useState[0],
      setActiveDropdown = _useState[1];

  var getDropdownLinkProps = (0,react.useCallback)(function (id) {
    return {
      open: activeDropdown === id,
      onClick: function onClick() {
        return setActiveDropdown(activeDropdown === id ? undefined : id);
      },
      onClickAway: function onClickAway() {
        return setActiveDropdown(undefined);
      }
    };
  }, [activeDropdown]);
  return {
    activeDropdown: activeDropdown,
    setActiveDropdown: setActiveDropdown,
    getDropdownLinkProps: getDropdownLinkProps
  };
};

/* harmony default export */ var Navigation_useNavigation = (useNavigation);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/index.ts + 30 modules
var Navigation_MobileNavigation = __webpack_require__(86943);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation/MobileNavigation/Navbar/index.ts + 8 modules
var Navbar = __webpack_require__(90806);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
;// CONCATENATED MODULE: ../../libs/templates/Navigation/data/utility.ts
var utilityData = function utilityData(_ref) {
  var basePath = _ref.basePath,
      appUrl = _ref.appUrl;
  return {
    links: [{
      id: "support",
      title: "Support",
      links: [{
        title: "Help Center",
        url: "".concat(basePath, "/help/")
      }, {
        title: "Docs",
        url: "/docs/"
      }, {
        title: "API Status",
        url: "https://status.segment.com/"
      }, {
        title: "Contact Us",
        url: "".concat(basePath, "/contact/")
      }]
    }],
    signUpButton: {
      text: "Sign up",
      url: "".concat(appUrl, "/signup/")
    },
    demoButton: {
      text: "See how it works",
      url: "".concat(basePath, "/demo/")
    },
    loginButton: {
      text: "Log in",
      url: "".concat(appUrl, "/login/")
    }
  };
};

/* harmony default export */ var utility = (utilityData);
;// CONCATENATED MODULE: ../../libs/templates/Navigation/data/docs.ts
var docsData = function docsData(_ref) {
  var basePath = _ref.basePath;
  return {
    content: {
      title: "Docs",
      links: [{
        title: "Public API",
        url: "https://docs.segmentapis.com/"
      }, {
        title: "Javascript",
        url: "/docs/connections/sources/catalog/libraries/website/javascript/"
      }, {
        title: "iOS",
        url: "/docs/connections/sources/catalog/libraries/mobile/ios/"
      }, {
        title: "All SDKs",
        url: "/docs/connections/sources/catalog/"
      }, {
        title: "Recipes",
        url: "".concat(basePath, "/recipes/")
      }, {
        title: "API Status",
        url: "https://status.segment.com/"
      }, {
        title: "Integrations",
        url: "".concat(basePath, "/catalog/")
      }, {
        title: "Security",
        url: "".concat(basePath, "/trust-center/")
      }],
      highlightedLink: {
        title: "View All Docs",
        url: "/docs/"
      }
    },
    aside: {
      title: "Popular Topics",
      links: [{
        title: "Spec",
        description: "Guidance on capturing and formatting data",
        url: "/docs/connections/spec/"
      }, {
        title: "Sources",
        description: "Applications which send data into Twilio Segment",
        url: "/docs/connections/sources/"
      }, {
        title: "Destinations",
        description: "Tools or apps that Twilio Segment sends data to",
        url: "/docs/connections/destinations/"
      }, {
        title: "Release Notes",
        description: "Latest feature releases, product updates and more",
        url: "/release-notes/"
      }, {
        title: "Trust Center",
        description: "Customer engagement built on trust",
        url: "".concat(basePath, "/trust-center/")
      }]
    }
  };
};

/* harmony default export */ var docs = (docsData);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/Navigation/MobileNavigation/Links/Docs.tsx


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var Docs = function Docs(props) {
  var pageConfig = (0,page/* usePageConfig */.Gm)();

  var _docsData = docs(pageConfig),
      content = _docsData.content,
      aside = _docsData.aside;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_MobileNavigation/* PrimaryLink */.c2, _objectSpread(_objectSpread({
    title: content.title
  }, props), {}, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Navigation_MobileNavigation/* NavList */.$6, {
        children: [content.links.map(function (item) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_MobileNavigation/* NavItem */.LY, {
            role: "listitem",
            title: item.title,
            href: item.url
          }, item.title);
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_MobileNavigation/* NavItem */.LY, {
          role: "listitem",
          title: content.highlightedLink.title,
          href: content.highlightedLink.url
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_MobileNavigation/* Tray */.OE, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_MobileNavigation/* Heading */.X6, {
            children: aside.title
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_MobileNavigation/* NavList */.$6, {
            children: aside.links.map(function (item) {
              return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_MobileNavigation/* NavItem */.LY, {
                role: "listitem",
                title: item.title,
                description: item === null || item === void 0 ? void 0 : item.description,
                href: item.url
              }, item.title);
            })
          })]
        })
      })]
    })
  }));
};

/* harmony default export */ var Links_Docs = (Docs);
;// CONCATENATED MODULE: ../../libs/templates/Navigation/data/resources.ts
var resourcesData = function resourcesData(_ref) {
  var basePath = _ref.basePath;
  return {
    content: {
      title: "Resources",
      links: [{
        title: "Learn With Segment",
        id: "learn-with-segment"
      }, {
        title: "Get Started With Segment",
        id: "get-started-with-segment"
      }, {
        title: "Support",
        id: "support"
      }, {
        title: "Partners",
        id: "partners"
      }]
    },
    aside: [{
      title: "Learn With Segment",
      id: "learn-with-segment",
      links: [{
        title: "Resources",
        description: "Guides and books for your customer data journey",
        url: "".concat(basePath, "/resources/")
      }, {
        title: "Blog",
        description: "The latest on our product, industry and customer data practice",
        url: "https://segment.com/blog/"
      }, {
        title: "Growth Center",
        description: "Learn to implement high-performing growth strategies",
        url: "".concat(basePath, "/growth-center/")
      }, {
        title: "Data Hub",
        description: "Enhance your customer data management skills",
        url: "".concat(basePath, "/data-hub/")
      }, {
        title: "Case Studies",
        description: "Learn about the ways our customers use Segment",
        url: "".concat(basePath, "/customers/")
      }]
    }, {
      title: "Get Started With Segment",
      id: "get-started-with-segment",
      links: [{
        title: "Segment University",
        description: "Learn to implement and use Twilio Segment successfully",
        url: "https://university.segment.com/"
      }, {
        title: "Integrations",
        description: "Explore 450+ integrations to connect your tools",
        url: "".concat(basePath, "/catalog/")
      }, {
        title: "Professional Services",
        description: "Get expert guidance on your Twilio Segment journey",
        url: "".concat(basePath, "/services/")
      }, {
        title: "Recipes",
        description: "Step by step tutorials on using Segment integrations to achieve your goals",
        url: "".concat(basePath, "/recipes/")
      }, {
        title: "Docs",
        description: "Technical documentation for all things Twilio Segment",
        url: "/docs/"
      }]
    }, {
      title: "Support",
      id: "support",
      links: [{
        title: "Contact Us",
        description: "Connect with our support team for additional help",
        url: "".concat(basePath, "/contact/")
      }, {
        title: "Support Plans",
        description: "Dedicated support from our team of experts",
        url: "".concat(basePath, "/support-plans/")
      }]
    }, {
      title: "Partners",
      id: "partners",
      links: [{
        title: "Find a Partner",
        description: "Find a trusted solution partner",
        url: "https://segment.partnerpage.io/"
      }, {
        title: "Become a Partner",
        description: "Get your software and services in front of our user base",
        url: "".concat(basePath, "/partners/")
      }, {
        title: "Build on Twilio Segment",
        description: "Build an integration between your tool and Twilio Segment",
        url: "".concat(basePath, "/partners/developer-portal/")
      }]
    }]
  };
};

/* harmony default export */ var resources = (resourcesData);
;// CONCATENATED MODULE: ../../libs/templates/Navigation/MobileNavigation/Links/Resources.tsx


function Resources_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Resources_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Resources_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Resources_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var Resources = function Resources(props) {
  var pageConfig = (0,page/* usePageConfig */.Gm)();

  var _resourcesData = resources(pageConfig),
      content = _resourcesData.content,
      aside = _resourcesData.aside;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_MobileNavigation/* PrimaryLink */.c2, Resources_objectSpread(Resources_objectSpread({
    role: "menuitem",
    title: content.title
  }, props), {}, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_MobileNavigation/* NavList */.$6, {
        children: aside.slice(0, 3).map(function (item) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("li", {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_MobileNavigation/* Heading */.X6, {
              children: item.title
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_MobileNavigation/* NavList */.$6, {
              role: "menu",
              children: item.links.map(function (item) {
                return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_MobileNavigation/* NavItem */.LY, {
                  title: item.title,
                  description: item === null || item === void 0 ? void 0 : item.description,
                  href: item.url
                }, item.title);
              })
            })]
          }, item.id);
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_MobileNavigation/* Tray */.OE, {
        children: aside.slice(3, 4).map(function (item) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_MobileNavigation/* Heading */.X6, {
              children: item.title
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_MobileNavigation/* NavList */.$6, {
              role: "menu",
              children: item.links.map(function (item) {
                return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_MobileNavigation/* NavItem */.LY, {
                  title: item.title,
                  description: item === null || item === void 0 ? void 0 : item.description,
                  href: item.url
                }, item.title);
              })
            })]
          }, item.id);
        })
      })]
    })
  }));
};

/* harmony default export */ var Links_Resources = (Resources);
;// CONCATENATED MODULE: ../../libs/templates/Navigation/data/solutions.ts
var solutions_resourcesData = function resourcesData(_ref) {
  var basePath = _ref.basePath;
  return {
    content: {
      title: "Solutions",
      links: [{
        title: "Use Cases",
        description: "Build solutions to scale your business",
        id: "use-cases"
      }, {
        title: "Teams",
        description: "Empower all teams with customer data",
        id: "teams"
      }, {
        title: "Industry",
        description: "Customer data solutions that meet your industry\u2019s needs",
        id: "industry"
      }, {
        title: "Company Size",
        description: "Data solutions that scale as you grow",
        id: "company-size"
      }],
      additionalLinks: {
        title: "More Solutions",
        links: [{
          title: "CustomerAI",
          description: "Turn every customer interaction into a unique customer experience",
          url: "".concat(basePath, "/solutions/ai/")
        }, {
          title: "Case Studies",
          description: "Learn about the ways our customers use Segment",
          url: "".concat(basePath, "/customers/")
        }, {
          title: "Recipes",
          description: "Step by step tutorials on using Segment integrations to achieve your goals",
          url: "".concat(basePath, "/recipes/")
        }]
      }
    },
    aside: [{
      title: "Use Cases",
      id: "use-cases",
      links: [{
        title: "Customer Data Management",
        description: "Collection, compliance, and activation",
        url: "".concat(basePath, "/use-cases/customer-data-management-integration/")
      }, {
        title: "Single View of the Customer",
        description: "Identity-resolved, enriched, and real-time profiles",
        url: "".concat(basePath, "/use-cases/single-customer-view/")
      }, {
        title: "Audience Segmentation & Activation",
        description: "Build targeted audiences and orchestrate journeys",
        url: "".concat(basePath, "/use-cases/segmentation-audience-activation/")
      }, {
        title: "Customer Acquisition",
        description: "Cost-effectively acquire new customers",
        url: "".concat(basePath, "/use-cases/customer-acquisition-activation/")
      }, {
        title: "Customer LTV & Retention",
        description: "Improve customer loyalty and engagement",
        url: "".concat(basePath, "/use-cases/retain-customers-increase-ltv/")
      }, {
        title: "Insights & Analytics Enablement",
        description: "Make data-driven decisions",
        url: "".concat(basePath, "/use-cases/customer-insights/")
      }]
    }, {
      title: "Twilio Segment For...",
      id: "teams",
      links: [{
        title: "Marketing Teams",
        description: "Personalize multichannel experiences",
        url: "".concat(basePath, "/marketing/")
      }, {
        title: "Product Teams",
        description: "Inform your roadmap with customer data",
        url: "".concat(basePath, "/product/")
      }, {
        title: "Engineering Teams",
        description: "Collect and manage your data in a single platform",
        url: "".concat(basePath, "/engineering/")
      }]
    }, {
      title: "Industry",
      id: "industry",
      links: [{
        title: "Retail",
        description: "Create personalized shopping experiences",
        url: "".concat(basePath, "/industry/retail/")
      }, {
        title: "B2B",
        description: "Unify your buyer journey and act on intent signals",
        url: "".concat(basePath, "/industry/b2b/")
      }, {
        title: "Financial Services",
        description: "Collect clean and compliant customer data",
        url: "".concat(basePath, "/industry/financial-services/")
      }, {
        title: "Healthcare",
        description: "Transform care with HIPAA-eligible data",
        url: "".concat(basePath, "/industry/healthcare/")
      }, {
        title: "Marketplaces",
        description: "Increase loyalty with data-driven personalization",
        url: "".concat(basePath, "/industry/marketplaces/")
      }, {
        title: "Media",
        description: "Increase engagement from your audience",
        url: "".concat(basePath, "/industry/media/")
      }]
    }, {
      title: "Company Size",
      id: "company-size",
      links: [{
        title: "Startup",
        description: "Early-stage startups can receive Twilio Segment for free",
        url: "".concat(basePath, "/industry/startups/")
      }, {
        title: "Enterprise",
        description: "Data clarity across your organization",
        url: "".concat(basePath, "/industry/enterprise/")
      }]
    }, {
      title: "Partners",
      id: "partners",
      links: [{
        title: "Find a Partner",
        description: "Find a trusted solution partner",
        url: "https://segment.partnerpage.io/"
      }, {
        title: "Become a Partner",
        description: "Get your software and services in front of our user base",
        url: "".concat(basePath, "/partners/")
      }, {
        title: "Build on Twilio Segment",
        description: "Build an integration between your tool and Twilio Segment",
        url: "".concat(basePath, "/partners/developer-portal/")
      }]
    }]
  };
};

/* harmony default export */ var solutions = (solutions_resourcesData);
;// CONCATENATED MODULE: ../../libs/templates/Navigation/MobileNavigation/Links/Solutions.tsx


function Solutions_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Solutions_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Solutions_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Solutions_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var Solutions = function Solutions(props) {
  var pageConfig = (0,page/* usePageConfig */.Gm)();

  var _solutionsData = solutions(pageConfig),
      content = _solutionsData.content,
      aside = _solutionsData.aside;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_MobileNavigation/* PrimaryLink */.c2, Solutions_objectSpread(Solutions_objectSpread({
    role: "menuitem",
    title: content.title
  }, props), {}, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_MobileNavigation/* NavList */.$6, {
        children: aside.slice(0, 3).map(function (item) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("li", {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_MobileNavigation/* Heading */.X6, {
              children: item.title
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_MobileNavigation/* NavList */.$6, {
              role: "menu",
              children: item.links.map(function (item) {
                return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_MobileNavigation/* NavItem */.LY, {
                  title: item.title,
                  description: item === null || item === void 0 ? void 0 : item.description,
                  href: item.url
                }, item.title);
              })
            })]
          }, item.id);
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_MobileNavigation/* Tray */.OE, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_MobileNavigation/* Heading */.X6, {
            children: content.additionalLinks.title
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_MobileNavigation/* NavList */.$6, {
            role: "menu",
            children: content.additionalLinks.links.map(function (item) {
              return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_MobileNavigation/* NavItem */.LY, {
                title: item.title,
                description: item === null || item === void 0 ? void 0 : item.description,
                href: item.url
              }, item.title);
            })
          })]
        })
      })]
    })
  }));
};

/* harmony default export */ var Links_Solutions = (Solutions);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/utils/createIconsComponent.tsx + 1 modules
var createIconsComponent = __webpack_require__(37699);
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Segment/CatalogIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */


var CatalogIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9994 21.0133C20.0635 21.022 24.0376 22.2103 27.4391 24.4337C27.7178 24.6212 28.0948 24.555 28.2929 24.2838C30.0879 21.7273 31.0345 18.6717 30.999 15.5484C30.8486 7.59431 24.5644 1.1144 16.6169 0.718404C10.9205 0.480851 5.58234 3.4942 2.84337 8.49345C0.104394 13.4927 0.438732 19.6125 3.70603 24.2838C3.90407 24.555 4.2811 24.6212 4.55975 24.4337C7.96136 22.2104 11.9354 21.0222 15.9994 21.0133ZM15.062 5.07981C15.062 4.56218 15.4817 4.14255 15.9994 4.14255C16.5172 4.14255 16.9369 4.56218 16.9369 5.07981V6.95434C16.9369 7.47198 16.5172 7.89161 15.9994 7.89161C15.4817 7.89161 15.062 7.47198 15.062 6.95434V5.07981ZM5.37473 16.6394H7.24968C7.76743 16.6394 8.18716 16.2198 8.18716 15.7022C8.18716 15.1845 7.76743 14.7649 7.24968 14.7649H5.37473C4.85698 14.7649 4.43726 15.1845 4.43726 15.7022C4.43726 16.2198 4.85698 16.6394 5.37473 16.6394ZM10.4746 10.1785C10.2991 10.3547 10.0607 10.4537 9.81211 10.4537C9.56348 10.4537 9.32508 10.3547 9.14963 10.1785L7.82341 8.85387C7.46831 8.48594 7.47366 7.90136 7.83545 7.53999C8.19724 7.17863 8.78195 7.17383 9.14963 7.5292L10.4746 8.85262C10.6505 9.02841 10.7494 9.2669 10.7494 9.51558C10.7494 9.76426 10.6505 10.0027 10.4746 10.1785ZM13.1339 16.9388C13.5977 18.0525 14.6917 18.7728 15.8982 18.7589C16.6854 18.7665 17.4434 18.4613 18.0056 17.9104C18.9506 16.9668 23.7942 9.11131 24.3442 8.21903C24.4962 7.97257 24.4589 7.65404 24.2541 7.44932C24.0494 7.2446 23.7308 7.20732 23.4842 7.35924C22.5918 7.90911 14.7345 12.7516 13.7895 13.6952C12.9296 14.5414 12.6701 15.8251 13.1339 16.9388ZM24.7492 16.6394C24.2315 16.6394 23.8117 16.2198 23.8117 15.7022C23.8117 15.1845 24.2315 14.7649 24.7492 14.7649H26.6242C27.1419 14.7649 27.5616 15.1845 27.5616 15.7022C27.5616 16.2198 27.1419 16.6394 26.6242 16.6394H24.7492ZM5.96097 25.7621C8.96881 23.8762 12.449 22.8797 15.9994 22.8879C19.55 22.8798 23.0303 23.8767 26.0379 25.7634C26.2013 25.8684 26.3074 26.0425 26.326 26.2358C26.3445 26.4291 26.2733 26.6202 26.1329 26.7544C20.4047 32.0223 11.5942 32.0223 5.86597 26.7544C5.72552 26.62 5.65438 26.4287 5.6729 26.2352C5.69142 26.0418 5.79757 25.8674 5.96097 25.7621Z",
    fill: "#4A90E9"
  })
}), 'CatalogIcon', 'Segment');
/* harmony default export */ var Segment_CatalogIcon = ((/* unused pure expression or super */ null && (CatalogIcon)));
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Segment/ConnectionsIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */


var ConnectionsIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 3.70532C2 2.60075 2.89543 1.70532 4 1.70532H28C29.1046 1.70532 30 2.60075 30 3.70532V6.70532C30 7.80989 29.1046 8.70532 28 8.70532H16.8335C15.7289 8.70532 14.8335 9.60075 14.8335 10.7053V18.3719C14.8335 19.4765 13.938 20.3719 12.8334 20.3719H4C2.89543 20.3719 2 19.4765 2 18.3719V3.70532ZM17.1665 13.0388C17.1665 11.9342 18.062 11.0388 19.1666 11.0388H28C29.1046 11.0388 30 11.9342 30 13.0388V27.7054C30 28.8099 29.1046 29.7054 28 29.7054H4C2.89543 29.7054 2 28.8099 2 27.7054V24.7054C2 23.6008 2.89543 22.7054 4 22.7054H15.1665C16.2711 22.7054 17.1665 21.8099 17.1665 20.7054V13.0388Z",
    fill: "#50D4A0"
  })
}), 'ConnectionsIcon', 'Segment');
/* harmony default export */ var Segment_ConnectionsIcon = (ConnectionsIcon);
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Segment/DocumentationIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */


var DocumentationIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 20.831V7.68842C28.0026 6.70286 27.6152 5.75514 26.92 5.04676L22.92 1.10398C22.2119 0.406285 21.2545 0.00995131 20.2533 8.93997e-08H13.1734L13.1467 0C11.0333 0.00726786 9.326 1.70189 9.33337 3.78506V3.78507V5.25704C9.33337 5.98289 9.93032 6.5713 10.6667 6.5713H15.7733C16.9575 6.58091 18.0893 7.05364 18.92 7.88556L23.5466 12.354C23.8372 12.6341 24.0007 13.018 24 13.4186V22.1453C24 22.8711 24.5969 23.4595 25.3333 23.4595C26.8061 23.4595 28 22.2827 28 20.831ZM17.5466 9.00269L21.5466 12.9455L21.5999 12.9061C22.2943 13.6246 22.677 14.5817 22.6666 15.574V27.5995C22.6669 29.6645 20.988 31.3487 18.8933 31.3845H7.83999C5.71922 31.3845 4 29.6899 4 27.5995V11.6707C4.00735 9.58534 5.72442 7.8987 7.83999 7.89871H14.88C15.8817 7.90584 16.8401 8.3026 17.5466 9.00269Z",
    fill: "#53ADDF"
  })
}), 'DocumentationIcon', 'Segment');
/* harmony default export */ var Segment_DocumentationIcon = ((/* unused pure expression or super */ null && (DocumentationIcon)));
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Segment/EngageIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */



var EngageIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M16 23.98C20.4072 23.98 23.98 20.4072 23.98 16C23.98 11.5928 20.4072 8.02 16 8.02C11.5928 8.02 8.02 11.5928 8.02 16C8.02 20.4072 11.5928 23.98 16 23.98Z",
    fill: "#F22F46"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M14.27 27.88C12.2608 27.5865 10.3589 26.7879 8.74246 25.5591C7.12598 24.3303 5.84775 22.7114 5.02744 20.8539C4.20712 18.9965 3.87155 16.9612 4.05214 14.9388C4.23273 12.9163 4.92357 10.9727 6.05999 9.28999C6.18196 9.09913 6.23552 8.87252 6.2119 8.64725C6.18828 8.42198 6.08889 8.21141 5.92999 8.04999L4.49 6.60999C4.38734 6.51286 4.26527 6.43859 4.13181 6.39208C3.99836 6.34557 3.85657 6.32787 3.71578 6.34016C3.57499 6.35244 3.43841 6.39442 3.31503 6.46334C3.19165 6.53226 3.08428 6.62655 3 6.73999C1.05715 9.43744 0.00803418 12.6757 0 16V30.71C0 31.0521 0.13591 31.3802 0.377832 31.6221C0.619754 31.8641 0.94787 32 1.29 32H16C19.3188 32.0065 22.5565 30.975 25.26 29.05C25.3817 28.9661 25.4833 28.8563 25.5574 28.7285C25.6316 28.6006 25.6765 28.458 25.689 28.3107C25.7014 28.1634 25.681 28.0152 25.6293 27.8768C25.5776 27.7383 25.4959 27.6131 25.39 27.51L24 26.07C23.8386 25.9111 23.628 25.8117 23.4027 25.7881C23.1775 25.7645 22.9508 25.818 22.76 25.94C20.2728 27.627 17.2431 28.3193 14.27 27.88Z",
    fill: "#F22F46"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M17.73 4.12C19.7392 4.41351 21.641 5.21205 23.2575 6.44088C24.874 7.6697 26.1522 9.28862 26.9725 11.1461C27.7928 13.0035 28.1284 15.0387 27.9478 17.0612C27.7672 19.0837 27.0764 21.0273 25.94 22.71C25.8049 22.9054 25.7438 23.1425 25.7676 23.3789C25.7914 23.6153 25.8986 23.8354 26.07 24L27.51 25.44C27.6131 25.5459 27.7383 25.6276 27.8768 25.6793C28.0152 25.731 28.1634 25.7514 28.3107 25.739C28.458 25.7265 28.6007 25.6816 28.7285 25.6074C28.8563 25.5333 28.9661 25.4317 29.05 25.31C30.985 22.5927 32.017 19.3358 32 16V1.29C32 0.94787 31.8641 0.619754 31.6221 0.377832C31.3802 0.13591 31.0521 0 30.71 0H16C12.6757 0.00803418 9.43745 1.05715 6.74 3C6.61831 3.08387 6.51672 3.19366 6.44254 3.32149C6.36837 3.44932 6.32345 3.592 6.31102 3.73927C6.29858 3.88654 6.31895 4.03473 6.37065 4.17319C6.42234 4.31164 6.50409 4.43691 6.61 4.54L8.05 5.92999C8.21141 6.08889 8.42199 6.18828 8.64725 6.2119C8.87252 6.23552 9.09913 6.18196 9.28999 6.05999C11.7638 4.38533 14.7733 3.69358 17.73 4.12Z",
    fill: "#F22F46"
  })]
}), 'EngageIcon', 'Segment');
/* harmony default export */ var Segment_EngageIcon = (EngageIcon);
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Segment/EngineeringIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */



var EngineeringIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.4,
    d: "M13.3328 5.6672C13.3328 4.56263 14.2282 3.6672 15.3328 3.6672H16.6672C17.7718 3.6672 18.7052 2.65755 17.9523 1.84933C17.4654 1.32663 16.7709 1 16 1H2.666C1.194 1.0004 0 2.1944 0 3.6672V27.6676C0 29.1412 1.194 30.334 2.666 30.334H16C16.7707 30.334 17.465 30.0076 17.9519 29.4853C18.705 28.6773 17.7718 27.6676 16.6672 27.6676H15.3328C14.2282 27.6676 13.3328 26.7722 13.3328 25.6676V5.6672ZM10.6668 23.6676C10.6668 24.4039 10.0699 25.0008 9.3336 25.0008H3.9992C3.2629 25.0008 2.666 24.4039 2.666 23.6676C2.666 22.9313 3.26289 22.3344 3.9992 22.3344H9.3336C10.0699 22.3344 10.6668 22.9313 10.6668 23.6676ZM10.6668 18.3336C10.6668 19.0701 10.0697 19.6672 9.3332 19.6672H3.9996C3.26307 19.6672 2.666 19.0701 2.666 18.3336C2.666 17.5971 3.26307 17 3.9996 17H9.3332C10.0697 17 10.6668 17.5971 10.6668 18.3336ZM10.6668 13.0006C10.6668 13.737 10.0698 14.334 9.3334 14.334H3.9994C3.26298 14.334 2.666 13.737 2.666 13.0006C2.666 12.2642 3.26298 11.6672 3.9994 11.6672H9.3334C10.0698 11.6672 10.6668 12.2642 10.6668 13.0006ZM10.6668 7.667C10.6668 8.40364 10.0696 9.0008 9.333 9.0008H3.9998C3.26316 9.0008 2.666 8.40364 2.666 7.667C2.666 6.93036 3.26316 6.3332 3.9998 6.3332H9.333C10.0696 6.3332 10.6668 6.93036 10.6668 7.667Z",
    fill: "url(#EngineeringIcon_svg__paint0_linear)"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M28.132 5.29085C28.4924 5.10527 28.9007 5 29.3352 5C30.806 5 32 6.1952 32 7.6672C32 9.1416 30.806 10.3344 29.3352 10.3348C28.9013 10.3348 28.4935 10.2303 28.1335 10.0455C27.9541 9.95335 27.775 9.85328 27.5953 9.75277C26.9283 9.37991 26.2509 9.0012 25.5025 9.0012H17.3338C16.5972 9.0012 16 8.40404 16 7.6674C16 6.93076 16.5972 6.3336 17.3338 6.3336H25.5049C26.2544 6.3336 26.9328 5.954 27.6005 5.58037C27.7781 5.48102 27.9549 5.3821 28.132 5.29085Z",
    fill: "url(#EngineeringIcon_svg__paint1_linear)"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M28.1327 15.9579C28.4928 15.7728 28.9009 15.668 29.3352 15.668C30.806 15.668 32 16.8636 32 18.334C32 19.8084 30.806 21.0012 29.3352 21.0012C28.9013 21.0012 28.4935 20.8966 28.1335 20.7118C27.954 20.6197 27.775 20.5196 27.5952 20.4191C26.9283 20.0463 26.2509 19.6676 25.5025 19.6676H17.3336C16.5971 19.6676 16 19.0705 16 18.334C16 17.5974 16.5971 17.0004 17.3336 17.0004H25.5045C26.253 17.0004 26.9307 16.6216 27.5978 16.2488C27.7764 16.1489 27.9544 16.0495 28.1327 15.9579Z",
    fill: "url(#EngineeringIcon_svg__paint2_linear)"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M21.3344 21.0013C20.7472 21.0013 20.2084 21.1932 19.7708 21.516C19.2188 21.9231 18.6147 22.3349 17.9289 22.3349H17.3332C16.5969 22.3349 16 22.9318 16 23.6681C16 24.4044 16.5969 25.0013 17.3332 25.0013H17.9282C18.6144 25.0013 19.2186 25.4138 19.7709 25.821C20.2085 26.1436 20.7473 26.3349 21.3344 26.3349C22.8064 26.3349 24.0008 25.1421 24.0008 23.6677C24.0008 22.1965 22.8064 21.0013 21.3344 21.0013Z",
    fill: "url(#EngineeringIcon_svg__paint3_linear)"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M22.7988 10.6241C23.1591 10.4389 23.5672 10.334 24.0016 10.334C25.4728 10.334 26.6668 11.5296 26.6668 13C26.6668 14.4744 25.4728 15.6672 24.0016 15.6672C23.5677 15.6672 23.1599 15.5627 22.7999 15.3779C22.6204 15.2857 22.4414 15.1857 22.2616 15.0851C21.5947 14.7123 20.9173 14.3336 20.1689 14.3336H17.3336C16.5971 14.3336 16 13.7365 16 13C16 12.2635 16.5971 11.6664 17.3336 11.6664H20.1713C20.92 11.6664 21.5979 11.2875 22.2651 10.9145C22.4434 10.8148 22.6209 10.7156 22.7988 10.6241Z",
    fill: "url(#EngineeringIcon_svg__paint4_linear)"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("defs", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
      id: "EngineeringIcon_svg__paint0_linear",
      x1: 18.6672,
      y1: 0.999999,
      x2: 20.3556,
      y2: 29.1114,
      gradientUnits: "userSpaceOnUse",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
        stopColor: "#5E97EE"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
        offset: 1,
        stopColor: "#897AE3"
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
      id: "EngineeringIcon_svg__paint1_linear",
      x1: 32,
      y1: 5,
      x2: 33.0431,
      y2: 25.4663,
      gradientUnits: "userSpaceOnUse",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
        stopColor: "#5E97EE"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
        offset: 1,
        stopColor: "#897AE3"
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
      id: "EngineeringIcon_svg__paint2_linear",
      x1: 32,
      y1: 5,
      x2: 33.0431,
      y2: 25.4663,
      gradientUnits: "userSpaceOnUse",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
        stopColor: "#5E97EE"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
        offset: 1,
        stopColor: "#897AE3"
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
      id: "EngineeringIcon_svg__paint3_linear",
      x1: 32,
      y1: 5,
      x2: 33.0431,
      y2: 25.4663,
      gradientUnits: "userSpaceOnUse",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
        stopColor: "#5E97EE"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
        offset: 1,
        stopColor: "#897AE3"
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
      id: "EngineeringIcon_svg__paint4_linear",
      x1: 32,
      y1: 5,
      x2: 33.0431,
      y2: 25.4663,
      gradientUnits: "userSpaceOnUse",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
        stopColor: "#5E97EE"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
        offset: 1,
        stopColor: "#897AE3"
      })]
    })]
  })]
}), 'EngineeringIcon', 'Segment');
/* harmony default export */ var Segment_EngineeringIcon = ((/* unused pure expression or super */ null && (EngineeringIcon)));
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Segment/FunctionsIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */


var FunctionsIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 6C4.89543 6 4 6.89543 4 8V23.3548C4 24.4594 4.89543 25.3548 6 25.3548H26C27.1046 25.3548 28 24.4594 28 23.3548V8C28 6.89543 27.1046 6 26 6H6ZM8.4801 10.3377C8.88884 10.3377 9.26524 10.1153 9.46255 9.7572C9.57411 9.58358 9.63596 9.3827 9.64139 9.17638C9.63614 8.97003 9.57427 8.7691 9.46255 8.59556C9.26524 8.23748 8.88884 8.01509 8.4801 8.01509C8.07135 8.01509 7.69495 8.23748 7.49764 8.59556C7.38592 8.7691 7.32405 8.97003 7.31881 9.17638C7.32423 9.3827 7.38608 9.58358 7.49764 9.7572C7.69495 10.1153 8.07135 10.3377 8.4801 10.3377ZM13.3332 9.7572C13.1359 10.1153 12.7595 10.3377 12.3507 10.3377C11.942 10.3377 11.5656 10.1153 11.3683 9.7572C11.2567 9.58358 11.1949 9.3827 11.1894 9.17638C11.1947 8.97003 11.2566 8.7691 11.3683 8.59556C11.5656 8.23748 11.942 8.01509 12.3507 8.01509C12.7595 8.01509 13.1359 8.23748 13.3332 8.59556C13.4449 8.7691 13.5068 8.97003 13.512 9.17638C13.5066 9.3827 13.4447 9.58358 13.3332 9.7572ZM16.2218 10.3377C16.6305 10.3377 17.0069 10.1153 17.2042 9.75729C17.3158 9.5837 17.3776 9.38285 17.3831 9.17656C17.3819 9.01239 17.3454 8.85039 17.2762 8.70152C17.0899 8.28561 16.6775 8.01716 16.2218 8.01509C15.8141 8.01932 15.4396 8.24067 15.2393 8.59582C15.1276 8.76934 15.0657 8.97024 15.0605 9.17656C15.0659 9.38285 15.1278 9.5837 15.2393 9.75729C15.4366 10.1153 15.813 10.3377 16.2218 10.3377ZM11.7345 20.7057C12.1377 21.0949 12.7912 21.0949 13.1943 20.7057L15.7752 18.2127C16.1782 17.8233 16.1782 17.1921 15.7752 16.8027L13.1943 14.3098C12.7892 13.9319 12.1453 13.9373 11.7471 14.3219C11.3489 14.7066 11.3433 15.3285 11.7345 15.7198L13.4028 17.3312C13.4514 17.378 13.4787 17.4415 13.4787 17.5077C13.4787 17.574 13.4514 17.6375 13.4028 17.6842L11.7345 19.2957C11.3315 19.6851 11.3315 20.3163 11.7345 20.7057ZM22.787 21.7718H18.658C18.0879 21.7718 17.6257 21.4252 17.6257 20.9976C17.6257 20.57 18.0879 20.2234 18.658 20.2234H22.787C23.3571 20.2234 23.8193 20.57 23.8193 20.9976C23.8193 21.4252 23.3571 21.7718 22.787 21.7718Z",
    fill: "#8192F1"
  })
}), 'FunctionsIcon', 'Segment');
/* harmony default export */ var Segment_FunctionsIcon = ((/* unused pure expression or super */ null && (FunctionsIcon)));
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Segment/MarketingIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */



var MarketingIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M11.6247 14.164C11.1512 11.3232 13.1199 9 15.9999 9C18.8787 9 20.8475 11.3232 20.3739 14.164L19.6575 18.4648C19.3739 20.1708 17.7275 21.5639 15.9999 21.5639C14.2703 21.5639 12.6275 20.1708 12.3435 18.4648L11.6247 14.164Z",
    fill: "url(#MarketingIcon_svg__paint0_linear)"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M18.671 22.8502C19.5428 22.3636 20.5642 22.0772 21.5115 22.3928L24.9805 23.5485C25.9077 23.8585 26.6669 24.9116 26.6669 25.8896V27.667C26.6669 29.1397 25.473 30.3336 24.0003 30.3336H8.00006C6.52731 30.3336 5.3334 29.1397 5.3334 27.667V25.8896C5.3334 24.9116 6.0942 23.8581 7.021 23.5485L10.4888 22.3929C11.4361 22.0772 12.4576 22.3636 13.3295 22.8503C14.1385 23.3019 15.0517 23.5641 16.0002 23.5641C16.9487 23.5641 17.8619 23.3019 18.671 22.8502Z",
    fill: "url(#MarketingIcon_svg__paint1_linear)"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
    opacity: 0.4,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      d: "M13.9631 7.31417C14.5044 7.14756 14.9479 6.72276 15.0404 6.16398C15.5148 3.32279 13.546 1 10.6668 1C7.78641 1 5.81762 3.32319 6.29162 6.16398L7.01041 10.4648C7.02768 10.5689 7.05003 10.6719 7.07718 10.7733C7.55048 12.5421 9.58329 11.359 10.582 9.82437C10.7177 9.61591 10.8666 9.4155 11.0284 9.22437C11.7951 8.31936 12.814 7.66785 13.9631 7.31417Z",
      fill: "url(#MarketingIcon_svg__paint2_linear)"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      d: "M9.43914 20.6349C10.1763 20.3897 10.4967 19.5593 10.37 18.7928L10.1296 17.3512C9.94221 16.2273 9.01092 15.392 8.01006 14.8476C7.13312 14.3705 6.10284 14.0772 5.15573 14.3928L1.68759 15.5485C0.760397 15.8581 0 16.9113 0 17.8892V19.6666C0 21.1393 1.1939 22.3332 2.66666 22.3332H4.21834C4.81421 22.3332 5.37933 22.1056 5.91481 21.8442C6.06739 21.7697 6.22446 21.7049 6.38557 21.6508L9.43914 20.6349Z",
      fill: "url(#MarketingIcon_svg__paint3_linear)"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      d: "M21.3331 6.33332C19.8864 6.33332 20.0354 8.11976 20.9699 9.22411C22.1679 10.6381 22.6691 12.5573 22.3463 14.4921L21.6299 18.7929C21.6278 18.8069 21.6234 18.8206 21.619 18.8344C21.6134 18.8518 21.6274 18.8681 21.6457 18.8663C23.2554 18.7103 24.7243 17.3992 24.9907 15.7981L25.7067 11.4973C26.1807 8.65611 24.2119 6.33332 21.3331 6.33332Z",
      fill: "url(#MarketingIcon_svg__paint4_linear)"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      d: "M25.7463 19.3602C25.4735 19.2693 25.1749 19.3422 24.9536 19.5259C24.3689 20.0116 24.4061 21.2491 25.1272 21.4894L25.612 21.651C27.354 22.233 28.6668 24.0546 28.6668 25.8894V26C28.6668 26.9204 29.413 27.6665 30.3334 27.6665C31.2538 27.6665 32 26.9204 32 26V23.2226C32 22.2446 31.2412 21.1914 30.3136 20.8814L25.7463 19.3602Z",
      fill: "url(#MarketingIcon_svg__paint5_linear)"
    })]
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("defs", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
      id: "MarketingIcon_svg__paint0_linear",
      x1: 26.6669,
      y1: 9,
      x2: 27.45,
      y2: 29.4883,
      gradientUnits: "userSpaceOnUse",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
        stopColor: "#5E97EE"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
        offset: 1,
        stopColor: "#897AE3"
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
      id: "MarketingIcon_svg__paint1_linear",
      x1: 26.6669,
      y1: 9,
      x2: 27.45,
      y2: 29.4883,
      gradientUnits: "userSpaceOnUse",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
        stopColor: "#5E97EE"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
        offset: 1,
        stopColor: "#897AE3"
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
      id: "MarketingIcon_svg__paint2_linear",
      x1: 32,
      y1: 0.999999,
      x2: 32.8161,
      y2: 26.6213,
      gradientUnits: "userSpaceOnUse",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
        stopColor: "#5E97EE"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
        offset: 1,
        stopColor: "#897AE3"
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
      id: "MarketingIcon_svg__paint3_linear",
      x1: 32,
      y1: 0.999999,
      x2: 32.8161,
      y2: 26.6213,
      gradientUnits: "userSpaceOnUse",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
        stopColor: "#5E97EE"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
        offset: 1,
        stopColor: "#897AE3"
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
      id: "MarketingIcon_svg__paint4_linear",
      x1: 32,
      y1: 0.999999,
      x2: 32.8161,
      y2: 26.6213,
      gradientUnits: "userSpaceOnUse",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
        stopColor: "#5E97EE"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
        offset: 1,
        stopColor: "#897AE3"
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
      id: "MarketingIcon_svg__paint5_linear",
      x1: 32,
      y1: 0.999999,
      x2: 32.8161,
      y2: 26.6213,
      gradientUnits: "userSpaceOnUse",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
        stopColor: "#5E97EE"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
        offset: 1,
        stopColor: "#897AE3"
      })]
    })]
  })]
}), 'MarketingIcon', 'Segment');
/* harmony default export */ var Segment_MarketingIcon = ((/* unused pure expression or super */ null && (MarketingIcon)));
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Segment/PrivacyIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */


var PrivacyIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.2855 2H13.6667C13.9888 2 14.25 2.26611 14.25 2.59437V12.4015C14.25 12.7298 13.9888 12.9959 13.6667 12.9959H2.58333C2.42835 12.9959 2.27975 12.933 2.17033 12.8212C2.061 12.7095 1.99972 12.5581 2 12.4003L2.014 4.32757C2.01525 3.04772 3.02945 2.00849 4.2855 2ZM2.74103 16.5622H13.6669C13.989 16.5622 14.2502 16.8283 14.2502 17.1565V29.6693C14.2502 29.7017 14.245 29.7339 14.2349 29.7646C14.1833 29.9201 14.0178 30.0036 13.8652 29.951C8.12183 27.8903 3.81591 22.9739 2.45753 16.9259C2.45266 16.9043 2.45018 16.8823 2.45012 16.8601C2.44971 16.696 2.57995 16.5626 2.74103 16.5622ZM29.2487 16.5622H18.3333C18.0112 16.5622 17.75 16.8283 17.75 17.1565V29.7026C17.7499 29.8667 17.8804 29.9999 18.0415 30C18.0733 30 18.1049 29.9947 18.135 29.9843C23.8836 27.9155 28.1876 22.9847 29.5333 16.9259C29.5694 16.7659 29.4714 16.6065 29.3144 16.5697C29.293 16.5647 29.271 16.5621 29.249 16.5622H29.2487ZM27.7145 2C28.9706 2.00851 29.9848 3.04771 29.986 4.32757L30 12.4003C30.0003 12.5581 29.939 12.7095 29.8297 12.8212C29.7202 12.933 29.5716 12.9959 29.4167 12.9959H18.3333C18.0112 12.9959 17.75 12.7298 17.75 12.4015V2.59437C17.75 2.26611 18.0112 2 18.3333 2H27.7145Z",
    fill: "#6CC9EC"
  })
}), 'PrivacyIcon', 'Segment');
/* harmony default export */ var Segment_PrivacyIcon = ((/* unused pure expression or super */ null && (PrivacyIcon)));
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Segment/ProductIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */



var ProductIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
    width: 18.6667,
    height: 32,
    rx: 2,
    fill: "url(#ProductIcon_svg__paint0_linear)"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
    opacity: 0.4,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      d: "M22.6666 2.66675H24.0001C24.7333 2.66675 25.3333 3.26675 25.3333 3.99995V27.9999C25.3333 28.7331 24.7333 29.3331 24.0001 29.3331H22.6666C21.9302 29.3331 21.3333 28.7362 21.3333 27.9998V4.00008C21.3333 3.2637 21.9302 2.66675 22.6666 2.66675Z",
      fill: "url(#ProductIcon_svg__paint1_linear)"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      d: "M29.3333 5.33341H30.6667C31.3995 5.33341 31.9999 5.93381 31.9999 6.66701V25.3334C31.9999 26.0666 31.3995 26.667 30.6667 26.667H29.3333C28.5969 26.667 27.9999 26.0701 27.9999 25.3337V6.66675C27.9999 5.93037 28.5969 5.33341 29.3333 5.33341Z",
      fill: "url(#ProductIcon_svg__paint2_linear)"
    })]
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("defs", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
      id: "ProductIcon_svg__paint0_linear",
      x1: 18.6667,
      y1: -0.00000150015,
      x2: 20.6746,
      y2: 30.6454,
      gradientUnits: "userSpaceOnUse",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
        stopColor: "#5E97EE"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
        offset: 1,
        stopColor: "#897AE3"
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
      id: "ProductIcon_svg__paint1_linear",
      x1: 31.9999,
      y1: 2.66675,
      x2: 34.4283,
      y2: 28.0819,
      gradientUnits: "userSpaceOnUse",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
        stopColor: "#5E97EE"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
        offset: 1,
        stopColor: "#897AE3"
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
      id: "ProductIcon_svg__paint2_linear",
      x1: 31.9999,
      y1: 2.66675,
      x2: 34.4283,
      y2: 28.0819,
      gradientUnits: "userSpaceOnUse",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
        stopColor: "#5E97EE"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
        offset: 1,
        stopColor: "#897AE3"
      })]
    })]
  })]
}), 'ProductIcon', 'Segment');
/* harmony default export */ var Segment_ProductIcon = ((/* unused pure expression or super */ null && (ProductIcon)));
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Segment/ProtocolsIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */


var ProtocolsIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.97 10.7789C22.1324 10.7789 27.9386 8.36595 27.9386 5.38944C27.9386 2.41294 22.1324 0 14.97 0C7.80762 0 2.00137 2.41294 2.00137 5.38944C2.00137 8.36595 7.80762 10.7789 14.97 10.7789ZM23.5133 11.1032C23.5984 11.2253 23.5927 11.3878 23.4992 11.5038C23.2006 11.8709 22.7707 12.4016 22.146 13.1728L22.1448 13.1743L22.1418 13.1779C21.4992 13.9712 20.6509 15.0184 19.5281 16.4028C19.4745 16.4691 19.3974 16.5129 19.3124 16.5254C17.8745 16.7374 16.4225 16.8432 14.9686 16.842C7.80722 16.842 2.00001 14.4303 2.00001 11.4526V9.13915C1.99987 9.00903 2.07568 8.89047 2.19473 8.8346C2.31379 8.77872 2.45481 8.79553 2.55698 8.87776C5.19984 11.0039 10.1853 12.1263 14.97 12.1263C17.7326 12.1424 20.4823 11.7537 23.1293 10.9729C23.2724 10.9283 23.4283 10.9812 23.5133 11.1032ZM2.00001 17.5157C2.00001 20.6348 8.12939 22.9052 14.9918 22.9052C15.1743 22.9046 15.3244 22.763 15.3331 22.5831C15.3555 21.8812 15.6161 21.2069 16.073 20.6685L17.7193 18.6381C17.8049 18.5332 17.819 18.3881 17.7552 18.2691C17.6913 18.1501 17.5618 18.0801 17.4258 18.091C16.6068 18.1584 15.7877 18.1948 14.9686 18.1948C10.1907 18.1948 5.20121 17.0724 2.55561 14.9476C2.45372 14.8651 2.31266 14.8481 2.19366 14.9041C2.07466 14.9601 1.99918 15.0789 2.00001 15.209V17.5157ZM14.9686 28.9683C16.3516 28.9688 17.7328 28.8734 19.1022 28.6826C19.2705 28.6586 19.3954 28.5163 19.3957 28.3485V26.2736C19.3957 26.0875 19.2429 25.9367 19.0544 25.9367H18.5466C17.4239 25.9293 16.3854 25.3479 15.8027 24.4007C15.7396 24.2994 15.627 24.2385 15.5065 24.2404C13.7591 24.2646 6.40251 24.1501 2.56243 21.0067C2.46081 20.9226 2.31889 20.9045 2.19894 20.9604C2.07899 21.0162 2.00292 21.1359 2.0041 21.2668V23.5734C2.00001 26.5565 7.80722 28.9683 14.9686 28.9683ZM26.9039 19.5368C26.9039 19.7228 27.0566 19.8736 27.2451 19.8736H29.8061C30.2717 19.8738 30.6947 20.141 30.8899 20.5582C31.0851 20.9754 31.017 21.4665 30.7153 21.8165L22.6611 31.7479C22.4798 31.9709 22.1755 32.0567 21.9022 31.9618C21.6289 31.867 21.446 31.6121 21.4461 31.3262V24.2525C21.4461 24.0665 21.2933 23.9157 21.1048 23.9157H18.5452C18.0799 23.9148 17.6574 23.6477 17.4621 23.2309C17.2667 22.8141 17.3341 22.3233 17.6347 21.9728L25.6889 12.0427C25.8679 11.8171 26.1733 11.7302 26.4465 11.8272C26.7204 11.9217 26.9039 12.1767 26.9039 12.4631V19.5368Z",
    fill: "#60CDD7"
  })
}), 'ProtocolsIcon', 'Segment');
/* harmony default export */ var Segment_ProtocolsIcon = (ProtocolsIcon);
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Segment/SegmentIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */



var SegmentIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
    clipPath: "url(#SegmentIcon_svg__clip0_13_24679)",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      d: "M23.3855 7.74414H9.67676C9.41572 7.74414 9.2041 7.94665 9.2041 8.19645V9.72444C9.2041 9.97425 9.41572 10.1768 9.67676 10.1768H23.3855C23.6466 10.1768 23.8582 9.97425 23.8582 9.72444V8.19645C23.8582 7.94665 23.6466 7.74414 23.3855 7.74414Z",
      fill: "#52BD94"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      d: "M14.3181 13.8235H0.609377C0.348335 13.8235 0.136719 14.026 0.136719 14.2758V15.8038C0.136719 16.0536 0.348335 16.2561 0.609377 16.2561H14.3181C14.5792 16.2561 14.7908 16.0536 14.7908 15.8038V14.2758C14.7908 14.026 14.5792 13.8235 14.3181 13.8235Z",
      fill: "#52BD94"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.89653 9.40928C2.01573 9.43882 2.14226 9.42306 2.24959 9.36529C2.35691 9.30753 2.43671 9.21225 2.47225 9.09943C3.22933 6.82417 4.84785 4.90192 7.01003 3.71009C9.17221 2.51825 11.7219 2.14294 14.1584 2.65783C14.2762 2.68129 14.3989 2.66051 14.5011 2.59978C14.6033 2.53906 14.6772 2.44303 14.7075 2.3316L15.1211 0.85442C15.1374 0.794993 15.141 0.733021 15.1316 0.672239C15.1222 0.611457 15.1 0.553126 15.0665 0.500762C15.0329 0.448399 14.9885 0.403088 14.9362 0.367561C14.8838 0.332035 14.8244 0.30703 14.7616 0.294053C11.6829 -0.3703 8.45567 0.100326 5.72349 1.61207C2.99131 3.12381 0.955007 5.56557 0.020701 8.45036C0.00286299 8.50821 -0.00264719 8.5689 0.00449764 8.62882C0.0116425 8.68875 0.0312966 8.74669 0.0622933 8.7992C0.0932899 8.85172 0.134997 8.89774 0.184938 8.93453C0.23488 8.97132 0.292037 8.99814 0.353017 9.01339L1.89653 9.40928Z",
      fill: "#52BD94"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22.1037 14.5907C21.9845 14.5612 21.858 14.577 21.7507 14.6347C21.6434 14.6925 21.5636 14.7877 21.5281 14.9006C20.771 17.1759 19.1525 19.0981 16.9903 20.29C14.8281 21.4818 12.2784 21.8571 9.84188 21.3422C9.7241 21.3188 9.60143 21.3396 9.49923 21.4003C9.39704 21.461 9.32315 21.557 9.29285 21.6684L8.87937 23.1456C8.86306 23.205 8.85949 23.267 8.86889 23.3278C8.87828 23.3886 8.90044 23.4469 8.93403 23.4992C8.96762 23.5516 9.01195 23.5969 9.06433 23.6325C9.11672 23.668 9.17608 23.693 9.23884 23.706C12.3175 24.3703 15.5448 23.8997 18.277 22.3879C21.0092 20.8762 23.0455 18.4344 23.9798 15.5496C23.9976 15.4918 24.0031 15.4311 23.996 15.3712C23.9889 15.3113 23.9692 15.2533 23.9382 15.2008C23.9072 15.1483 23.8655 15.1023 23.8155 15.0655C23.7656 15.0287 23.7084 15.0019 23.6475 14.9866L22.1037 14.5907Z",
      fill: "#52BD94"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      d: "M19.2434 5.07315C20.0131 5.07315 20.6371 4.47601 20.6371 3.73939C20.6371 3.00278 20.0131 2.40564 19.2434 2.40564C18.4736 2.40564 17.8496 3.00278 17.8496 3.73939C17.8496 4.47601 18.4736 5.07315 19.2434 5.07315Z",
      fill: "#52BD94"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      d: "M4.75654 21.5946C5.52628 21.5946 6.15028 20.9975 6.15028 20.2609C6.15028 19.5243 5.52628 18.9271 4.75654 18.9271C3.98679 18.9271 3.36279 19.5243 3.36279 20.2609C3.36279 20.9975 3.98679 21.5946 4.75654 21.5946Z",
      fill: "#52BD94"
    })]
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("defs", {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("clipPath", {
      id: "SegmentIcon_svg__clip0_13_24679",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
        width: 24,
        height: 24,
        fill: "white"
      })
    })
  })]
}), 'SegmentIcon', 'Segment');
/* harmony default export */ var Segment_SegmentIcon = ((/* unused pure expression or super */ null && (SegmentIcon)));
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Segment/StoriesIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */



var StoriesIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
    clipPath: "url(#StoriesIcon_svg__clip0)",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      d: "M12.6666 16.6666C12.6666 14.4575 14.4575 12.6666 16.6666 12.6666H27C27.184 12.6666 27.3333 12.5174 27.3333 12.3333V2C27.3333 0.895429 26.4379 0 25.3333 0H2H2C0.895429 4.82822e-08 0 0.895429 0 2V21.3333H0C1.66785e-07 22.4379 0.895429 23.3333 2 23.3333H5.99999V28V27.9998C5.99999 28.2696 6.16258 28.5128 6.41189 28.6159C6.49274 28.6491 6.57926 28.6663 6.66666 28.6666C6.84378 28.6666 7.01361 28.5961 7.13865 28.4706L12.276 23.3333H12.3333C12.5174 23.3333 12.6666 23.1841 12.6666 23V16.6666ZM3.95999 13.292C4.35072 12.9028 4.9826 12.9028 5.37332 13.292H5.37332C6.46275 14.3924 7.88921 15.0965 9.42532 15.292C9.97318 15.3623 10.3603 15.8634 10.29 16.4113C10.2197 16.9592 9.71852 17.3463 9.17065 17.276C7.19575 17.0249 5.36155 16.1205 3.95999 14.7066C3.56934 14.3162 3.56914 13.6831 3.95954 13.2924C3.95969 13.2923 3.95984 13.2921 3.95999 13.292H3.95999ZM10.3333 8.66665C10.3333 9.21894 9.8856 9.66665 9.33332 9.66665C8.78103 9.66665 8.33332 9.21894 8.33332 8.66665V5.99999C8.33332 5.4477 8.78103 4.99999 9.33332 4.99999C9.8856 4.99999 10.3333 5.4477 10.3333 5.99999V8.66665ZM18.3333 8.66665C18.3333 9.21894 17.8856 9.66665 17.3333 9.66665C16.781 9.66665 16.3333 9.21894 16.3333 8.66665V5.99999C16.3333 5.4477 16.781 4.99999 17.3333 4.99999C17.8856 4.99999 18.3333 5.4477 18.3333 5.99999V8.66665Z",
      fill: "url(#StoriesIcon_svg__paint0_linear)"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      opacity: 0.4,
      d: "M30 14.667H16.6667C15.5621 14.667 14.6667 15.5624 14.6667 16.667V26.0003C14.6667 27.1049 15.5621 28.0003 16.6667 28.0003H21.7773L26.9333 31.867C27.2279 32.0879 27.6457 32.0282 27.8667 31.7336C27.9532 31.6182 28 31.4779 28 31.3336V28.0003H30C31.1046 28.0003 32 27.1049 32 26.0003V16.667C32 15.5624 31.1046 14.667 30 14.667C30 14.667 30 14.667 30 14.667ZM19.3333 21.3336C19.3333 20.5973 19.9303 20.0003 20.6667 20.0003C21.4031 20.0003 22 20.5973 22 21.3336C22 22.07 21.4031 22.667 20.6667 22.667C19.9303 22.667 19.3333 22.07 19.3333 21.3336ZM26 22.667C25.2636 22.667 24.6667 22.07 24.6667 21.3336C24.6667 20.5973 25.2636 20.0003 26 20.0003C26.7364 20.0003 27.3333 20.5973 27.3333 21.3336C27.3333 22.07 26.7364 22.667 26 22.667Z",
      fill: "url(#StoriesIcon_svg__paint1_linear)"
    })]
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("defs", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
      id: "StoriesIcon_svg__paint0_linear",
      x1: 27.3333,
      y1: -0.00000134389,
      x2: 28.4367,
      y2: 27.5267,
      gradientUnits: "userSpaceOnUse",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
        stopColor: "#5E97EE"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
        offset: 1,
        stopColor: "#897AE3"
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
      id: "StoriesIcon_svg__paint1_linear",
      x1: 32,
      y1: 14.667,
      x2: 32.6362,
      y2: 31.3135,
      gradientUnits: "userSpaceOnUse",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
        stopColor: "#5E97EE"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
        offset: 1,
        stopColor: "#897AE3"
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("clipPath", {
      id: "StoriesIcon_svg__clip0",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("rect", {
        width: 32,
        height: 32,
        fill: "white"
      })
    })]
  })]
}), 'StoriesIcon', 'Segment');
/* harmony default export */ var Segment_StoriesIcon = ((/* unused pure expression or super */ null && (StoriesIcon)));
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Segment/UnifyIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */


var UnifyIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
  width: 30,
  height: 32,
  viewBox: "0 0 30 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.6675 8.66667C4.6675 3.8802 8.54839 0 13.3357 0C13.704 0 14.0025 0.298477 14.0025 0.666667V16.6667C14.0025 17.0349 13.704 17.3333 13.3357 17.3333C8.54839 17.3333 4.6675 13.4531 4.6675 8.66667ZM16.6696 12C18.5109 12 20.0036 10.5076 20.0036 8.66667C20.0036 6.82572 18.5109 5.33333 16.6696 5.33333C16.5728 5.33398 16.4762 5.34066 16.3802 5.35333C16.2849 5.36602 16.1888 5.33696 16.1165 5.27361C16.0442 5.21026 16.0028 5.11879 16.0028 5.02267V0.666667C16.0028 0.298477 16.3014 0 16.6696 0C17.1539 0.00417584 17.637 0.0487752 18.1139 0.133333C18.4355 0.184778 18.6729 0.461018 18.6753 0.786667V2.08667C18.6756 2.22735 18.7642 2.35273 18.8967 2.4C19.1147 2.4772 19.3284 2.56622 19.5368 2.66667C19.6648 2.72421 19.8152 2.69542 19.9129 2.59467L20.8304 1.67867C21.0609 1.44848 21.4241 1.4186 21.6892 1.608C22.4793 2.1693 23.1695 2.85935 23.7309 3.64933C23.92 3.91469 23.8895 4.27783 23.6589 4.508L22.7427 5.424C22.6429 5.52425 22.6172 5.67659 22.6787 5.804C22.7774 6.01333 22.8667 6.228 22.9454 6.44533C22.9927 6.57784 23.1181 6.6664 23.2588 6.66667H24.551C24.8765 6.66671 25.1544 6.90173 25.2085 7.22267C25.381 8.17761 25.381 9.15572 25.2085 10.1107C25.1544 10.4316 24.8765 10.6666 24.551 10.6667H23.2588C23.116 10.6642 22.9877 10.7534 22.9401 10.888C22.8627 11.1049 22.7738 11.3182 22.6734 11.528C22.6119 11.6554 22.6376 11.8077 22.7374 11.908L23.6562 12.8213C23.8861 13.0513 23.9165 13.4136 23.7282 13.6787C23.1668 14.469 22.4767 15.1595 21.6865 15.7213C21.4211 15.9104 21.0579 15.8799 20.8277 15.6493L19.9102 14.7333C19.8099 14.6335 19.6576 14.6079 19.5301 14.6693C19.3215 14.7692 19.1079 14.8582 18.89 14.936C18.757 14.9834 18.6684 15.1095 18.6687 15.2507V16.5427C18.6686 16.8681 18.4335 17.146 18.1126 17.2C17.6357 17.2845 17.1526 17.3291 16.6683 17.3333C16.3 17.3333 16.0015 17.0349 16.0015 16.6667V12.2573C16.0014 12.1724 16.0383 12.0915 16.1026 12.036C16.1668 11.9804 16.2522 11.9556 16.3362 11.968C16.4465 11.9861 16.5579 11.9968 16.6696 12ZM13.3357 18C5.97395 18.0081 0.0080846 23.9729 0 31.3333C0 31.7015 0.29853 32 0.666785 32H13.3357C13.704 32 14.0025 31.7015 14.0025 31.3333V18.6667C14.0025 18.2985 13.704 18 13.3357 18ZM29.1652 28.6667C29.493 28.6694 29.7715 28.9073 29.8253 29.2307C29.9393 29.933 29.9977 30.6432 30 31.3547C29.9871 31.7135 29.6923 31.9976 29.3332 31.9973H22.9321C22.7638 31.9958 22.6245 31.8663 22.6107 31.6987C22.2745 28.3625 19.6356 25.7242 16.2989 25.388C16.1312 25.3742 16.0017 25.2349 16.0002 25.0667V18.6667C16 18.3056 16.2873 18.0101 16.6483 18C17.6019 17.9998 18.5528 18.1012 19.4848 18.3027C19.7874 18.3729 20.0015 18.6427 20.0009 18.9533V20.9653C20.0008 21.1069 20.0901 21.233 20.2236 21.28C20.7279 21.4583 21.2183 21.674 21.6905 21.9253C21.8198 21.9945 21.9792 21.9706 22.0826 21.8667L23.4628 20.5013C23.6885 20.2758 24.0424 20.2417 24.307 20.42C25.865 21.508 27.1715 22.9175 28.1383 24.5533C28.2866 24.8137 28.243 25.1409 28.0317 25.3533L26.5647 26.82C26.4677 26.9158 26.4391 27.0613 26.4927 27.1867C26.6656 27.5899 26.813 28.0036 26.9341 28.4253C26.9756 28.5683 27.1066 28.6666 27.2555 28.6667H29.1652Z",
    fill: "#9173CF"
  })
}), 'UnifyIcon', 'Segment');
/* harmony default export */ var Segment_UnifyIcon = (UnifyIcon);
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Segment/WarehouseIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */


var WarehouseIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M7.8376 0H1.56752C0.731509 0 0 0.723333 0 1.55V29.45C0 30.2767 0.731509 31 1.56752 31H7.8376C8.67361 31 9.40512 30.2767 9.40512 29.45V1.55C9.40512 0.723333 8.67361 0 7.8376 0ZM4.70256 26.8667C3.86655 26.8667 3.13504 26.1433 3.13504 25.3167C3.13504 24.49 3.86655 23.7667 4.70256 23.7667C5.53857 23.7667 6.27008 24.49 6.27008 25.3167C6.27008 26.1433 5.53857 26.8667 4.70256 26.8667ZM5.74757 12.2604H3.65755C3.34404 12.2604 3.13504 11.9252 3.13504 11.4225C3.13504 10.9198 3.34404 10.5847 3.65755 10.5847H5.74757C6.06108 10.5847 6.27008 10.9198 6.27008 11.4225C6.27008 11.9252 6.06108 12.2604 5.74757 12.2604ZM5.74757 8.51802H3.65755C3.34404 8.51802 3.13504 8.18288 3.13504 7.68018C3.13504 7.17748 3.34404 6.84234 3.65755 6.84234H5.74757C6.06108 6.84234 6.27008 7.17748 6.27008 7.68018C6.27008 8.18288 6.06108 8.51802 5.74757 8.51802ZM5.74757 4.77568H3.65755C3.34404 4.77568 3.13504 4.44054 3.13504 3.93784C3.13504 3.43513 3.34404 3.1 3.65755 3.1H5.74757C6.06108 3.1 6.27008 3.43513 6.27008 3.93784C6.27008 4.44054 6.06108 4.77568 5.74757 4.77568ZM19.135 0H12.865C12.0289 0 11.2974 0.723333 11.2974 1.55V29.45C11.2974 30.2767 12.0289 31 12.865 31H19.135C19.971 31 20.7026 30.2767 20.7026 29.45V1.55C20.7026 0.723333 19.971 0 19.135 0ZM16.2824 26.8667C15.4464 26.8667 14.7149 26.1433 14.7149 25.3167C14.7149 24.49 15.4464 23.7667 16.2824 23.7667C17.1184 23.7667 17.85 24.49 17.85 25.3167C17.85 26.1433 17.1184 26.8667 16.2824 26.8667ZM17.045 12.2604H14.955C14.6415 12.2604 14.4325 11.9252 14.4325 11.4225C14.4325 10.9198 14.6415 10.5847 14.955 10.5847H17.045C17.3585 10.5847 17.5675 10.9198 17.5675 11.4225C17.5675 11.9252 17.3585 12.2604 17.045 12.2604ZM17.045 8.51802H14.955C14.6415 8.51802 14.4325 8.18288 14.4325 7.68018C14.4325 7.17748 14.6415 6.84234 14.955 6.84234H17.045C17.3585 6.84234 17.5675 7.17748 17.5675 7.68018C17.5675 8.18288 17.3585 8.51802 17.045 8.51802ZM17.045 4.77568H14.955C14.6415 4.77568 14.4325 4.44054 14.4325 3.93784C14.4325 3.43513 14.6415 3.1 14.955 3.1H17.045C17.3585 3.1 17.5675 3.43513 17.5675 3.93784C17.5675 4.44054 17.3585 4.77568 17.045 4.77568ZM30.4325 0H24.1624C23.3264 0 22.5949 0.723333 22.5949 1.55V29.45C22.5949 30.2767 23.3264 31 24.1624 31H30.4325C31.2685 31 32 30.2767 32 29.45V1.55C32 0.723333 31.2685 0 30.4325 0ZM27.2974 26.8667C26.4614 26.8667 25.7299 26.1433 25.7299 25.3167C25.7299 24.49 26.4614 23.7667 27.2974 23.7667C28.1334 23.7667 28.865 24.49 28.865 25.3167C28.865 26.1433 28.1334 26.8667 27.2974 26.8667ZM28.3425 12.2604H26.2524C25.9389 12.2604 25.7299 11.9252 25.7299 11.4225C25.7299 10.9198 25.9389 10.5847 26.2524 10.5847H28.3425C28.656 10.5847 28.865 10.9198 28.865 11.4225C28.865 11.9252 28.656 12.2604 28.3425 12.2604ZM28.3425 8.51802H26.2524C25.9389 8.51802 25.7299 8.18288 25.7299 7.68018C25.7299 7.17748 25.9389 6.84234 26.2524 6.84234H28.3425C28.656 6.84234 28.865 7.17748 28.865 7.68018C28.865 8.18288 28.656 8.51802 28.3425 8.51802ZM28.3425 4.77568H26.2524C25.9389 4.77568 25.7299 4.44054 25.7299 3.93784C25.7299 3.43513 25.9389 3.1 26.2524 3.1H28.3425C28.656 3.1 28.865 3.43513 28.865 3.93784C28.865 4.44054 28.656 4.77568 28.3425 4.77568Z",
    fill: "#67D8C8"
  })
}), 'WarehouseIcon', 'Segment');
/* harmony default export */ var Segment_WarehouseIcon = ((/* unused pure expression or super */ null && (WarehouseIcon)));
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/Segment.ts
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */














;// CONCATENATED MODULE: ../../libs/templates/Navigation/data/products.tsx


var productData = function productData(_ref) {
  var basePath = _ref.basePath;
  return {
    content: {
      title: "Products",
      links: [{
        title: "Connections",
        description: "Connect all of your customer data",
        icon: Segment_ConnectionsIcon,
        id: "connections"
      }, {
        title: "Protocols",
        description: "Take control of your data quality",
        icon: Segment_ProtocolsIcon,
        id: "protocols"
      }, {
        title: "Unify",
        description: "Unify customer data across every channel",
        icon: Segment_UnifyIcon,
        id: "unify"
      }, {
        title: "Twilio Engage",
        description: "Build personalized customer experiences",
        icon: Segment_EngageIcon,
        id: "twilio-engage"
      }]
    },
    bottomLinks: [{
      title: "Integrations",
      id: "integrations"
    }, {
      title: "Privacy & Security",
      id: "privacy-security"
    }, {
      title: "Why Twilio Segment",
      id: "why-twilio-segment"
    }],
    aside: [{
      title: "Connections Features",
      id: "connections",
      links: [{
        title: "Connections Overview",
        description: "Integrate web and mobile app data with a single API",
        url: "".concat(basePath, "/product/connections/")
      }, {
        title: "Warehouses",
        description: "Easily transform and load customer data",
        url: "".concat(basePath, "/product/warehouses/")
      }, {
        title: "Reverse ETL",
        description: "Move warehouse data to your applications",
        url: "".concat(basePath, "/product/reverse-etl/")
      }, {
        title: "Functions",
        description: "Customize your customer data pipeline",
        url: "".concat(basePath, "/product/connections/functions/")
      }, {
        title: "Developer Toolkit",
        description: "Build on Twilio Segment",
        url: "".concat(basePath, "/product/developer-toolkit/")
      }]
    }, {
      title: "Protocols Features",
      id: "protocols",
      links: [{
        title: "Protocols Product Overview",
        description: "Protect the integrity of your data",
        url: "".concat(basePath, "/product/protocols/")
      }, {
        title: "Privacy Portal",
        description: "Protect users\u2019 privacy",
        url: "".concat(basePath, "/product/privacy-portal/")
      }]
    }, {
      title: "Unify Features",
      id: "unify",
      links: [{
        title: "Unify Overview",
        description: "Get a complete view of your customer",
        url: "".concat(basePath, "/product/unify/")
      }, {
        title: "Profiles Sync",
        description: "Sync customer profiles to the warehouse",
        url: "".concat(basePath, "/product/profiles-sync/")
      }]
    }, {
      title: "Twilio Engage Features",
      id: "twilio-engage",
      links: [{
        title: "Twilio Engage Overview",
        description: "Deepen customer relationships with data-first multichannel marketing",
        url: "".concat(basePath, "/product/twilio-engage/")
      }, {
        title: "Audiences",
        description: "Build dynamic audiences from real-time, complete profiles",
        url: "".concat(basePath, "/product/twilio-engage/audiences/")
      }, {
        title: "Journeys",
        description: "Orchestrate multichannel customer journeys",
        url: "".concat(basePath, "/product/twilio-engage/journeys/")
      }, {
        title: "Channels",
        description: "Engage customers on trusted native channels",
        url: "".concat(basePath, "/product/twilio-engage/channels/")
      }]
    }, {
      title: "Integrations",
      id: "integrations",
      links: [{
        title: "Advertising",
        description: "",
        url: "".concat(basePath, "/catalog/advertising/")
      }, {
        title: "Analytics",
        description: "",
        url: "".concat(basePath, "/catalog/analytics/")
      }, {
        title: "BI Tools",
        description: "",
        url: "".concat(basePath, "/catalog/bi-tools/")
      }, {
        title: "CRM",
        description: "",
        url: "".concat(basePath, "/catalog/crm/")
      }, {
        title: "Data Warehouses",
        description: "",
        url: "".concat(basePath, "/catalog/warehouse/")
      }, {
        title: "Email Marketing",
        description: "",
        url: "".concat(basePath, "/catalog/email-marketing/")
      }, {
        title: "Marketing Automation",
        description: "",
        url: "".concat(basePath, "/catalog/marketing-automation/")
      }, {
        title: "Personalization",
        description: "",
        url: "".concat(basePath, "/catalog/personalization/")
      }, {
        title: "View All Integrations",
        description: "",
        url: "".concat(basePath, "/catalog/")
      }]
    }, {
      title: "Privacy & Security",
      id: "privacy-security",
      links: [{
        title: "Trust Center",
        description: "",
        url: "".concat(basePath, "/trust-center/")
      }, {
        title: "Privacy Portal",
        description: "",
        url: "".concat(basePath, "/product/privacy-portal/")
      }, {
        title: "Security",
        description: "",
        url: "".concat(basePath, "/security/")
      }, {
        title: "GDPR",
        description: "",
        url: "".concat(basePath, "/product/gdpr/")
      }]
    }, {
      title: "Why Twilio Segment",
      id: "why-twilio-segment",
      links: [{
        title: "Open Source",
        description: "",
        url: "".concat(basePath, "/opensource/")
      }, {
        title: "Infrastructure",
        description: "",
        url: "".concat(basePath, "/infrastructure/")
      }, {
        title: "Twilio + Segment",
        description: "",
        url: "".concat(basePath, "/twilio/")
      }]
    }]
  };
};

/* harmony default export */ var products = (productData);
;// CONCATENATED MODULE: ../../libs/templates/Navigation/MobileNavigation/Links/Products.tsx


function Products_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Products_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Products_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Products_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var Products = function Products(props) {
  var pageConfig = (0,page/* usePageConfig */.Gm)();

  var _productsData = products(pageConfig),
      content = _productsData.content,
      bottomLinks = _productsData.bottomLinks,
      aside = _productsData.aside;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_MobileNavigation/* PrimaryLink */.c2, Products_objectSpread(Products_objectSpread({
    role: "menuitem",
    title: content.title
  }, props), {}, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_MobileNavigation/* NavList */.$6, {
        children: aside.slice(0, 4).map(function (asideItem, i) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("li", {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_MobileNavigation/* Heading */.X6, {
              icon: content.links[i].icon,
              children: content.links[i].title
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_MobileNavigation/* NavList */.$6, {
              role: "menu",
              children: asideItem.links.map(function (item) {
                return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_MobileNavigation/* NavItem */.LY, {
                  title: item.title,
                  description: item === null || item === void 0 ? void 0 : item.description,
                  href: item.url
                }, item.title);
              })
            })]
          }, asideItem.id);
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_MobileNavigation/* Tray */.OE, {
        children: aside.slice(4, 7).map(function (item, i) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_MobileNavigation/* Heading */.X6, {
              children: bottomLinks[i].title
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_MobileNavigation/* NavList */.$6, {
              role: "menu",
              children: item.links.map(function (item) {
                return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_MobileNavigation/* NavItem */.LY, {
                  title: item.title,
                  href: item.url
                }, item.title);
              })
            })]
          }, item.id);
        })
      })]
    })
  }));
};

/* harmony default export */ var Links_Products = (Products);
;// CONCATENATED MODULE: ../../libs/templates/Navigation/MobileNavigation/MobileNavigation.tsx



function MobileNavigation_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function MobileNavigation_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? MobileNavigation_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MobileNavigation_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}





















var MobileNavigation = function MobileNavigation(_ref) {
  var announcement = _ref.announcement;
  var pageConfig = (0,page/* usePageConfig */.Gm)();

  var _useState = (0,react.useState)(false),
      isMenuOpen = _useState[0],
      setIsMenuOpen = _useState[1];

  var _useNavigation = Navigation_useNavigation(),
      getDropdownLinkProps = _useNavigation.getDropdownLinkProps;

  var _utilityData = utility(pageConfig),
      links = _utilityData.links,
      loginButton = _utilityData.loginButton,
      signUpButton = _utilityData.signUpButton,
      demoButton = _utilityData.demoButton;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Navigation_MobileNavigation/* default */.ZP, {
      children: [announcement && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UtilityNav/* default */.Z, {
        announcement: announcement
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Navigation_MobileNavigation/* Navbar */.wp, {
        isMenuOpen: isMenuOpen,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navbar/* Brand */.H2, {
          href: "/",
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo/* default */.Z, {
            alt: "Twilio, Inc."
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MobileNavbarButtons, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DemoButton, {
            size: "small",
            color: "primary",
            variant: "filled",
            href: demoButton.url,
            children: demoButton.text
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navbar/* Button */.zx, {
            onClick: function onClick() {
              return setIsMenuOpen(!isMenuOpen);
            },
            "aria-label": "Open menu",
            "aria-haspopup": "true",
            "aria-expanded": isMenuOpen,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
              size: "small",
              variant: "outlined",
              color: "primary",
              tag: "span",
              children: "Menu"
            })
          })]
        })]
      })]
    }), isMenuOpen ? (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_browser_esm/* Global */.xB, {
        styles: hideScroll
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Navigation_MobileNavigation/* Menu */.v2, {
        children: [announcement && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UtilityNav/* default */.Z, {
          announcement: announcement
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Navigation_MobileNavigation/* Navbar */.wp, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navbar/* Brand */.H2, {
            href: "/",
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo/* default */.Z, {
              appearance: "light",
              alt: "Twilio, Inc. "
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navbar/* Button */.zx, {
            onClick: function onClick() {
              return setIsMenuOpen(!isMenuOpen);
            },
            "aria-label": "Close menu",
            "aria-haspopup": "true",
            "aria-expanded": isMenuOpen,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Common/* CloseIcon */.Tw, {})
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Navigation_MobileNavigation/* Content */.VY, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Links_Products, MobileNavigation_objectSpread({}, getDropdownLinkProps("products"))), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Links_Solutions, MobileNavigation_objectSpread({}, getDropdownLinkProps("solutions"))), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_MobileNavigation/* PrimaryLink */.c2, {
              title: "Pricing",
              href: "/pricing/"
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Links_Docs, MobileNavigation_objectSpread({}, getDropdownLinkProps("docs"))), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Links_Resources, MobileNavigation_objectSpread({}, getDropdownLinkProps("resources")))]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            children: links.map(function (item) {
              return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_MobileNavigation/* UtilityLink */.gt, MobileNavigation_objectSpread(MobileNavigation_objectSpread({
                title: item.title
              }, getDropdownLinkProps(item.id)), {}, {
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_MobileNavigation/* NavList */.$6, {
                  children: item.links.map(function (link) {
                    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_MobileNavigation/* NavItem */.LY, {
                      title: link.title,
                      href: link.url
                    }, link.title);
                  })
                })
              }), item.id);
            })
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Navigation_MobileNavigation/* Footer */.$_, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
            color: "primary",
            size: "medium",
            variant: "filled",
            expanded: true,
            href: demoButton.url,
            children: demoButton.text
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ColumnTrack/* default */.Z, {
            columns: 2,
            gap: "small",
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
              color: "primary",
              size: "medium",
              variant: "outlined",
              href: loginButton.url,
              children: loginButton.text
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
              color: "primary",
              size: "medium",
              variant: "outlined",
              href: signUpButton.url,
              children: signUpButton.text
            })]
          })]
        })]
      })]
    }) : null]
  });
};

var DemoButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Button/* default */.Z,  true ? {
  target: "e1qxvyjb1"
} : 0)("display:none;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("sm");
}, "{display:block;}" + ( true ? "" : 0));

var MobileNavbarButtons = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1qxvyjb0"
} : 0)( true ? {
  name: "1xr3a3z",
  styles: "gap:8px;display:flex"
} : 0);

var hideScroll =  true ? {
  name: "1yurnc",
  styles: "html{overflow:hidden;}"
} : 0;
/* harmony default export */ var MobileNavigation_MobileNavigation = (MobileNavigation);
;// CONCATENATED MODULE: ../../libs/templates/Navigation/MobileNavigation/index.ts

// EXTERNAL MODULE: ../../libs/matcha/components/ButtonText/index.ts
var ButtonText = __webpack_require__(74870);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/index.ts + 24 modules
var Navigation_DesktopNavigation = __webpack_require__(82680);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/Navbar/index.ts + 14 modules
var DesktopNavigation_Navbar = __webpack_require__(77966);
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Navigation/AcademyIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */



var AcademyIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.48,
    d: "M18.5476 6.17744L10.3658 2.08652C10.1358 1.97116 9.86421 1.97116 9.63348 2.08652L1.45164 6.17744C1.28718 6.26008 1.16118 6.40245 1.08755 6.55626C1.03764 6.65608 1 6.82545 1 6.90972V11.6265C1 12.0782 1.36655 12.4447 1.81818 12.4447C2.26982 12.4447 2.63637 12.0782 2.63637 11.6265V7.86454L10.0123 10.9376L18.4862 7.66981C18.7849 7.55036 18.9861 7.26645 18.9992 6.94408C19.0131 6.62172 18.8356 6.32226 18.5476 6.17744Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.24,
    d: "M10 12.2378C10 12.2378 9.77543 12.2066 9.67 12.1453L4 10V13.6207C4 14.0748 4.18343 14.4917 4.474 14.6947C5.944 15.7254 7.45857 17 10 17C12.5397 17 14.0586 15.723 15.526 14.6947C15.8166 14.4929 16 14.076 16 13.6219V10.2571L10.3077 12.1585C10.2083 12.2114 10 12.2378 10 12.2378Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.48,
    d: "M1.81818 13.4551C1.36655 13.4551 1 13.8216 1 14.2733V15.9097C1 16.3613 1.36655 16.7278 1.81818 16.7278C2.26982 16.7278 2.63637 16.3613 2.63637 15.9097V14.2733C2.63637 13.8216 2.26982 13.4551 1.81818 13.4551Z",
    fill: "none"
  })]
}), 'AcademyIcon', 'Navigation');
/* harmony default export */ var Navigation_AcademyIcon = ((/* unused pure expression or super */ null && (AcademyIcon)));
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Navigation/ApiHttpIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */



var ApiHttpIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.48,
    d: "M12.5 7C11.6715 7 10.5 7 10.5 7H10H2.49985C1.6714 7 1 7 1 7V16.4999C1 17.3277 1.6714 18 2.49985 18H16.5C17.3276 18 17.9999 17.3293 17.9999 16.4999V7H12.5ZM7.8598 14.8296L7.06443 15.625L4.21975 12.7801C3.9268 12.4878 3.9268 12.0126 4.21975 11.7197L7.06443 8.875L7.8598 9.67037L5.28017 12.25L7.8598 14.8296ZM12.9999 14.8751H9.24985V13.7501H12.9999V14.8751Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.24,
    d: "M18 5.4017V3.7C18 2.7616 17.2375 2 16.3 2H2.7C1.76245 2 1 2.7616 1 3.7V5.4017H18ZM6.1 2.85C6.5692 2.85 6.95 3.2308 6.95 3.7C6.95 4.1692 6.5692 4.55 6.1 4.55C5.6308 4.55 5.25 4.1692 5.25 3.7C5.25 3.2308 5.6308 2.85 6.1 2.85ZM3.55 2.85C4.0192 2.85 4.4 3.2308 4.4 3.7C4.4 4.1692 4.0192 4.55 3.55 4.55C3.0808 4.55 2.7 4.1692 2.7 3.7C2.7 3.2308 3.0808 2.85 3.55 2.85Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M6.95001 3.7001C6.95001 3.2309 6.56921 2.8501 6.10001 2.8501C5.63081 2.8501 5.25001 3.2309 5.25001 3.7001C5.25001 4.1693 5.63081 4.5501 6.10001 4.5501C6.56921 4.5501 6.95001 4.1693 6.95001 3.7001Z",
    fill: "white"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M4.40001 3.7001C4.40001 3.2309 4.01921 2.8501 3.55001 2.8501C3.08081 2.8501 2.70001 3.2309 2.70001 3.7001C2.70001 4.1693 3.08081 4.5501 3.55001 4.5501C4.01921 4.5501 4.40001 4.1693 4.40001 3.7001Z",
    fill: "white"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M7.06445 15.625L7.85982 14.8296L5.28019 12.25L7.85982 9.67037L7.06445 8.875L4.21977 11.7197C3.92682 12.0126 3.92682 12.4878 4.21977 12.7801L7.06445 15.625Z",
    fill: "white"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M9.24987 14.8751H12.9999V13.7501H9.24987V14.8751Z",
    fill: "white"
  })]
}), 'ApiHttpIcon', 'Navigation');
/* harmony default export */ var Navigation_ApiHttpIcon = ((/* unused pure expression or super */ null && (ApiHttpIcon)));
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Navigation/ApiReferenceIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */



var ApiReferenceIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.48,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 0.806396H15C17.2091 0.806396 19 2.59726 19 4.8064C19 7.01554 17.2091 8.80639 15 8.80639H5C2.79086 8.80639 1 7.01554 1 4.8064C1 2.59726 2.79086 0.806396 5 0.806396ZM5.00001 6.80638C6.10458 6.80638 7.00001 5.91095 7.00001 4.80638C7.00001 3.70181 6.10458 2.80638 5.00001 2.80638C3.89544 2.80638 3.00001 3.70181 3.00001 4.80638C3.00001 5.91095 3.89544 6.80638 5.00001 6.80638Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.24,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 10.8064H15C17.2091 10.8064 19 12.5972 19 14.8064C19 17.0155 17.2091 18.8064 15 18.8064H5C2.79086 18.8064 1 17.0155 1 14.8064C1 12.5972 2.79086 10.8064 5 10.8064ZM15 16.8063C16.1046 16.8063 17 15.9109 17 14.8063C17 13.7018 16.1046 12.8063 15 12.8063C13.8954 12.8063 13 13.7018 13 14.8063C13 15.9109 13.8954 16.8063 15 16.8063Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M7 4.8064C7 5.91097 6.10457 6.8064 5 6.8064C3.89543 6.8064 3 5.91097 3 4.8064C3 3.70183 3.89543 2.8064 5 2.8064C6.10457 2.8064 7 3.70183 7 4.8064Z",
    fill: "white"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M17 14.8064C17 15.911 16.1046 16.8064 15 16.8064C13.8954 16.8064 13 15.911 13 14.8064C13 13.7019 13.8954 12.8064 15 12.8064C16.1046 12.8064 17 13.7019 17 14.8064Z",
    fill: "white"
  })]
}), 'ApiReferenceIcon', 'Navigation');
/* harmony default export */ var Navigation_ApiReferenceIcon = ((/* unused pure expression or super */ null && (ApiReferenceIcon)));
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Navigation/ApiStatusIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */



var ApiStatusIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.24,
    d: "M18.25 17.5H2.875C2.66789 17.5 2.5 17.3321 2.5 17.125V1.75C2.5 1.33579 2.16421 1 1.75 1C1.33579 1 1 1.33579 1 1.75V17.8915H1C1.00082 18.5036 1.49708 18.9996 2.10923 19H18.25C18.6642 19 19 18.6642 19 18.25C19 17.8358 18.6642 17.5 18.25 17.5Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.48,
    d: "M5.125 15.9999H16.75C17.3448 16.024 17.8474 15.5633 17.875 14.9686V13.6561C17.8474 13.0615 17.3448 12.6007 16.75 12.6249H5.125C4.5302 12.6007 4.02756 13.0615 4 13.6561V14.9686C4.02756 15.5633 4.5302 16.024 5.125 15.9999Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.48,
    d: "M4 9.71868C4.02756 10.3133 4.5302 10.7741 5.125 10.7499H12.25C12.8448 10.7741 13.3474 10.3133 13.375 9.71868V8.40618C13.3474 7.81153 12.8448 7.35078 12.25 7.37493H5.125C4.5302 7.35078 4.02756 7.81153 4 8.40618V9.71868Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.48,
    d: "M5.125 5.49993H8.5C9.0948 5.52408 9.59744 5.06333 9.625 4.46868V3.15618C9.59744 2.56153 9.0948 2.10078 8.5 2.12493H5.125C4.5302 2.10078 4.02756 2.56153 4 3.15618V4.46868C4.02756 5.06333 4.5302 5.52408 5.125 5.49993Z",
    fill: "none"
  })]
}), 'ApiStatusIcon', 'Navigation');
/* harmony default export */ var Navigation_ApiStatusIcon = ((/* unused pure expression or super */ null && (ApiStatusIcon)));
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Navigation/ArrowRight.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */


var ArrowRight = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M16.728 17.4615C16.4306 17.7498 16.4232 18.2246 16.7115 18.522C16.9998 18.8194 17.4746 18.8268 17.772 18.5385L23.6213 12.8679C23.7375 12.7595 23.8317 12.6285 23.8972 12.4818C23.9648 12.3305 24 12.1665 24 12C24 11.8335 23.9648 11.6695 23.8972 11.5182C23.8317 11.3715 23.7375 11.2405 23.6213 11.1321L17.772 5.46151C17.4746 5.1732 16.9998 5.18056 16.7115 5.47796C16.4232 5.77536 16.4306 6.25017 16.728 6.53849L21.5879 11.25H0.75C0.335786 11.25 0 11.5858 0 12C0 12.4142 0.335786 12.75 0.75 12.75H21.5879L16.728 17.4615Z",
    fill: "none"
  })
}), 'ArrowRight', 'Navigation');
/* harmony default export */ var Navigation_ArrowRight = (ArrowRight);
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Navigation/B2BIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */



var B2BIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.48,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 2H9C8.72386 2 8.5 2.22386 8.5 2.5V18C8.5 18.2762 8.72386 18.5 9 18.5H18C18.2761 18.5 18.5 18.2762 18.5 18V2.5C18.5 2.22386 18.2761 2 18 2ZM12.5 16C12.5 16.2762 12.2761 16.5 12 16.5H11C10.7239 16.5 10.5 16.2762 10.5 16V15C10.5 14.7239 10.7239 14.5 11 14.5H12C12.2761 14.5 12.5 14.7239 12.5 15V16ZM12 11.5C12.2761 11.5 12.5 11.2761 12.5 11V10C12.5 9.72386 12.2761 9.5 12 9.5H11C10.7239 9.5 10.5 9.72386 10.5 10V11C10.5 11.2761 10.7239 11.5 11 11.5H12ZM12.5 6C12.5 6.27614 12.2761 6.5 12 6.5H11C10.7239 6.5 10.5 6.27614 10.5 6V5C10.5 4.72386 10.7239 4.5 11 4.5H12C12.2761 4.5 12.5 4.72386 12.5 5V6ZM16 16.5C16.2761 16.5 16.5 16.2762 16.5 16V15C16.5 14.7239 16.2761 14.5 16 14.5H15C14.7239 14.5 14.5 14.7239 14.5 15V16C14.5 16.2762 14.7239 16.5 15 16.5H16ZM16.5 11C16.5 11.2761 16.2761 11.5 16 11.5H15C14.7239 11.5 14.5 11.2761 14.5 11V10C14.5 9.72386 14.7239 9.5 15 9.5H16C16.2761 9.5 16.5 9.72386 16.5 10V11ZM16 6.5C16.2761 6.5 16.5 6.27614 16.5 6V5C16.5 4.72386 16.2761 4.5 16 4.5H15C14.7239 4.5 14.5 4.72386 14.5 5V6C14.5 6.27614 14.7239 6.5 15 6.5H16Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.24,
    d: "M6.5 6H1.5C1.22386 6 1 6.22386 1 6.5V18C1 18.2761 1.22386 18.5 1.5 18.5H6.5C6.77614 18.5 7 18.2761 7 18V6.5C7 6.22386 6.77614 6 6.5 6Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 16C12.5 16.2762 12.2761 16.5 12 16.5H11C10.7239 16.5 10.5 16.2762 10.5 16V15C10.5 14.7239 10.7239 14.5 11 14.5H12C12.2761 14.5 12.5 14.7239 12.5 15V16ZM12 11.5C12.2761 11.5 12.5 11.2761 12.5 11V10C12.5 9.72386 12.2761 9.5 12 9.5H11C10.7239 9.5 10.5 9.72386 10.5 10V11C10.5 11.2761 10.7239 11.5 11 11.5H12ZM12.5 6C12.5 6.27614 12.2761 6.5 12 6.5H11C10.7239 6.5 10.5 6.27614 10.5 6V5C10.5 4.72386 10.7239 4.5 11 4.5H12C12.2761 4.5 12.5 4.72386 12.5 5V6ZM16 16.5C16.2761 16.5 16.5 16.2762 16.5 16V15C16.5 14.7239 16.2761 14.5 16 14.5H15C14.7239 14.5 14.5 14.7239 14.5 15V16C14.5 16.2762 14.7239 16.5 15 16.5H16ZM16.5 11C16.5 11.2761 16.2761 11.5 16 11.5H15C14.7239 11.5 14.5 11.2761 14.5 11V10C14.5 9.72386 14.7239 9.5 15 9.5H16C16.2761 9.5 16.5 9.72386 16.5 10V11ZM16 6.5C16.2761 6.5 16.5 6.27614 16.5 6V5C16.5 4.72386 16.2761 4.5 16 4.5H15C14.7239 4.5 14.5 4.72386 14.5 5V6C14.5 6.27614 14.7239 6.5 15 6.5H16Z",
    fill: "white"
  })]
}), 'B2BIcon', 'Navigation');
/* harmony default export */ var Navigation_B2BIcon = ((/* unused pure expression or super */ null && (B2BIcon)));
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Navigation/BuildIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */



var BuildIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
    opacity: 0.24,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      d: "M8.51103 5.86532L9.14863 6.50292C9.29505 6.64938 9.29505 6.8868 9.14863 7.03326L7.03028 9.15161C6.88382 9.29803 6.6464 9.29803 6.49994 9.15161L5.86084 8.51251C5.77015 8.42459 5.6413 8.38821 5.51803 8.41574C4.86862 8.55261 4.19451 8.51446 3.56469 8.3052C1.60169 7.65299 0.539088 5.53293 1.19131 3.56994C1.20948 3.51403 1.24055 3.46318 1.28199 3.42149C1.42803 3.27458 1.6655 3.27388 1.81241 3.41991L3.64947 5.25622C3.71964 5.32661 3.81487 5.36627 3.91426 5.36649H4.97494C5.18208 5.36649 5.35 5.19856 5.35 4.99142V3.93075C5.34998 3.83147 5.3106 3.73624 5.24048 3.66595L3.39818 1.82215C3.35722 1.78153 3.32619 1.73201 3.30749 1.67744C3.24033 1.48149 3.34475 1.2682 3.5407 1.20104C4.18031 0.982556 4.86713 0.941258 5.52831 1.08153C7.55138 1.51073 8.84346 3.49869 8.41426 5.52176C8.38647 5.64527 8.42286 5.77447 8.51103 5.86532Z",
      fill: "none"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      d: "M13.4985 10.853L14.1332 11.4876C14.2247 11.5734 14.3531 11.6078 14.4752 11.5791C15.1375 11.4385 15.8255 11.48 16.4661 11.6993C18.4227 12.3692 19.4658 14.4983 18.7959 16.4549C18.7774 16.5094 18.7467 16.5589 18.706 16.5996C18.5595 16.7461 18.3221 16.7462 18.1756 16.5997L16.3355 14.7597C16.2652 14.6891 16.1696 14.6494 16.07 14.6494H15.0101C14.8029 14.6494 14.635 14.8173 14.635 15.0245V16.0829C14.6348 16.1824 14.6742 16.278 14.7445 16.3484L16.5816 18.1855C16.623 18.2272 16.6541 18.278 16.6722 18.3339C16.7363 18.5309 16.6285 18.7425 16.4315 18.8066C16.0467 18.9346 15.6437 19 15.2381 19.0001C14.9819 18.9994 14.7264 18.9724 14.4757 18.9196C12.4512 18.4929 11.156 16.5058 11.5827 14.4814C11.6104 14.3582 11.5744 14.2294 11.4867 14.1386L10.8499 13.5017C10.7035 13.3552 10.7035 13.1178 10.8499 12.9714L12.9682 10.853C13.1147 10.7066 13.3521 10.7066 13.4985 10.853Z",
      fill: "none"
    })]
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
    opacity: 0.48,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      d: "M16.7061 8.20186C16.3062 8.60012 15.6596 8.60012 15.2598 8.20186L10.4493 3.39281C10.0502 2.99333 10.0502 2.34606 10.4493 1.94657L11.2406 1.15669C11.3894 1.0158 11.6223 1.0158 11.771 1.15669C12.6643 2.12954 14.1057 2.36842 15.2651 1.73578C15.4132 1.64295 15.6058 1.66473 15.7294 1.78829L18.7014 4.76029C19.1005 5.15978 19.1005 5.80704 18.7014 6.20653L16.7061 8.20186Z",
      fill: "none"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      d: "M11.7867 6.51631L13.485 8.21459C13.6314 8.36105 13.6314 8.59847 13.485 8.74493L4.04323 18.1875C3.45723 18.7732 2.50689 18.7735 1.92112 18.1875L1.81386 18.0803C1.22819 17.4944 1.22819 16.5447 1.81386 15.9589L11.2564 6.51631C11.4029 6.36989 11.6403 6.36989 11.7867 6.51631Z",
      fill: "none"
    })]
  })]
}), 'BuildIcon', 'Navigation');
/* harmony default export */ var Navigation_BuildIcon = ((/* unused pure expression or super */ null && (BuildIcon)));
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Navigation/CatalogIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */



var CatalogIcon_CatalogIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.48,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1009 14.6551C14.2867 13.4693 12.1672 12.8356 9.9997 12.8309C7.83222 12.8356 5.71273 13.4694 3.89853 14.6551C3.74992 14.7551 3.54883 14.7198 3.44321 14.5752C1.70066 12.0838 1.52234 8.81993 2.98313 6.15367C4.44391 3.4874 7.29094 1.88028 10.329 2.00698C14.5677 2.21817 17.9192 5.67413 17.9995 9.91633C18.0184 11.5821 17.5135 13.2117 16.5562 14.5752C16.4506 14.7198 16.2495 14.7551 16.1009 14.6551ZM9.99969 3.8332C9.72356 3.8332 9.49971 4.057 9.49971 4.33308V5.33283C9.49971 5.6089 9.72356 5.8327 9.99969 5.8327C10.2758 5.8327 10.4997 5.6089 10.4997 5.33283V4.33308C10.4997 4.057 10.2758 3.8332 9.99969 3.8332ZM5.33316 10.4982H4.33319C4.05705 10.4982 3.8332 10.2744 3.8332 9.99831C3.8332 9.72224 4.05705 9.49844 4.33319 9.49844H5.33316C5.6093 9.49844 5.83315 9.72224 5.83315 9.99831C5.83315 10.2744 5.6093 10.4982 5.33316 10.4982ZM6.69979 7.19917C6.83239 7.19917 6.95954 7.14636 7.05311 7.05242C7.14694 6.95867 7.19967 6.83148 7.19967 6.69885C7.19967 6.56622 7.14694 6.43902 7.05311 6.34527L6.34646 5.63944C6.15037 5.44991 5.83852 5.45247 5.64557 5.6452C5.45261 5.83793 5.44976 6.1497 5.63915 6.34593L6.34646 7.05242C6.44004 7.14636 6.56718 7.19917 6.69979 7.19917ZM9.94569 11.6286C9.3022 11.636 8.71875 11.2518 8.4714 10.6579C8.22406 10.0639 8.36243 9.37928 8.82105 8.92794C9.32504 8.42474 13.5156 5.84205 13.9916 5.54879C14.123 5.46777 14.293 5.48765 14.4022 5.59683C14.5114 5.70601 14.5313 5.8759 14.4502 6.00734C14.1569 6.48322 11.5736 10.6728 11.0697 11.176C10.7698 11.4699 10.3655 11.6326 9.94569 11.6286ZM14.1662 9.99831C14.1662 10.2744 14.3901 10.4982 14.6662 10.4982H15.6662C15.9423 10.4982 16.1662 10.2744 16.1662 9.99831C16.1662 9.72224 15.9423 9.49844 15.6662 9.49844H14.6662C14.3901 9.49844 14.1662 9.72224 14.1662 9.99831Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.24,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99969 13.8306C8.10615 13.8263 6.25003 14.3577 4.64584 15.3635C4.5587 15.4197 4.50208 15.5127 4.4922 15.6159C4.48233 15.7191 4.52027 15.8211 4.59518 15.8927C7.65024 18.7023 12.3492 18.7023 15.4042 15.8927C15.4791 15.8212 15.5171 15.7193 15.5072 15.6162C15.4973 15.5131 15.4407 15.4202 15.3535 15.3642C13.7495 14.358 11.8933 13.8263 9.99969 13.8306Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99969 3.83325C9.72356 3.83325 9.49971 4.05705 9.49971 4.33313V5.33288C9.49971 5.60895 9.72356 5.83275 9.99969 5.83275C10.2758 5.83275 10.4997 5.60895 10.4997 5.33288V4.33313C10.4997 4.05705 10.2758 3.83325 9.99969 3.83325ZM5.33317 10.4982H4.33319C4.05706 10.4982 3.83321 10.2744 3.83321 9.99836C3.83321 9.72229 4.05706 9.49848 4.33319 9.49848H5.33317C5.6093 9.49848 5.83315 9.72229 5.83315 9.99836C5.83315 10.2744 5.6093 10.4982 5.33317 10.4982ZM6.69979 7.19922C6.83239 7.19922 6.95954 7.14641 7.05311 7.05247C7.14695 6.95872 7.19967 6.83153 7.19967 6.6989C7.19967 6.56626 7.14695 6.43907 7.05311 6.34532L6.34647 5.63949C6.15037 5.44996 5.83852 5.45252 5.64557 5.64525C5.45262 5.83798 5.44976 6.14975 5.63915 6.34598L6.34647 7.05247C6.44004 7.14641 6.56718 7.19922 6.69979 7.19922ZM9.94569 11.6287C9.30221 11.6361 8.71875 11.2519 8.47141 10.6579C8.22406 10.064 8.36244 9.37933 8.82105 8.92799C9.32504 8.42479 13.5156 5.8421 13.9916 5.54884C14.1231 5.46782 14.293 5.4877 14.4022 5.59688C14.5114 5.70606 14.5313 5.87595 14.4502 6.00739C14.1569 6.48327 11.5736 10.6729 11.0697 11.1761C10.7698 11.4699 10.3655 11.6327 9.94569 11.6287ZM14.1662 9.99836C14.1662 10.2744 14.3901 10.4982 14.6662 10.4982H15.6662C15.9423 10.4982 16.1662 10.2744 16.1662 9.99836C16.1662 9.72229 15.9423 9.49848 15.6662 9.49848H14.6662C14.3901 9.49848 14.1662 9.72229 14.1662 9.99836Z",
    fill: "white"
  })]
}), 'CatalogIcon', 'Navigation');
/* harmony default export */ var Navigation_CatalogIcon = ((/* unused pure expression or super */ null && (CatalogIcon_CatalogIcon)));
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Navigation/ContactIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */



var ContactIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.48,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9925 12.9668V9.85919C12.9925 8.44144 11.8432 7.29211 10.4254 7.29211H4.57405V4.31971C4.57405 3.1258 5.54189 2.15796 6.7358 2.15796H16.824C18.0179 2.15796 18.9858 3.1258 18.9858 4.31971V10.805L19 14.811C19.0008 15.0473 18.81 15.2395 18.5737 15.2403C18.4597 15.2407 18.3502 15.1956 18.2696 15.115L16.1214 12.9668H12.9926H12.9925Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.24,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.999954 14.9933V10.7148C0.999954 9.76963 1.76617 9.00342 2.71134 9.00342H9.55688C10.5021 9.00342 11.2683 9.76963 11.2683 10.7148V14.9933C11.2683 15.9384 10.5021 16.7047 9.55688 16.7047H2.81036L1.74602 17.7234C1.57531 17.8868 1.30448 17.8808 1.14109 17.7101C1.06488 17.6305 1.02233 17.5245 1.02233 17.4143V15.2707C1.00761 15.1804 0.999956 15.0877 0.999956 14.9933H0.999954ZM4.86327 11.5705C4.62698 11.5705 4.43542 11.7621 4.43542 11.9983C4.43542 12.2347 4.62698 12.4262 4.86327 12.4262H9.14173C9.37803 12.4262 9.56958 12.2347 9.56958 11.9983C9.56958 11.7621 9.37803 11.5705 9.14173 11.5705H4.86327ZM7.43035 13.2819C7.19406 13.2819 7.0025 13.4734 7.0025 13.7097C7.0025 13.946 7.19406 14.1376 7.43035 14.1376H9.14173C9.37803 14.1376 9.56958 13.946 9.56958 13.7097C9.56958 13.4734 9.37803 13.2819 9.14173 13.2819H7.43035Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.86327 11.5706C4.62698 11.5706 4.43542 11.7621 4.43542 11.9984C4.43542 12.2347 4.62698 12.4262 4.86327 12.4262H9.14173C9.37803 12.4262 9.56958 12.2347 9.56958 11.9984C9.56958 11.7621 9.37803 11.5706 9.14173 11.5706H4.86327ZM7.43035 13.2819C7.19406 13.2819 7.0025 13.4734 7.0025 13.7097C7.0025 13.946 7.19406 14.1376 7.43035 14.1376H9.14173C9.37803 14.1376 9.56958 13.946 9.56958 13.7097C9.56958 13.4734 9.37803 13.2819 9.14173 13.2819H7.43035Z",
    fill: "white"
  })]
}), 'ContactIcon', 'Navigation');
/* harmony default export */ var Navigation_ContactIcon = ((/* unused pure expression or super */ null && (ContactIcon)));
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Navigation/CustomerStoriesIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */



var CustomerStoriesIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.48,
    d: "M8.12499 10.375C8.12499 9.13235 9.13235 8.12499 10.375 8.12499H16.1875C16.291 8.12499 16.375 8.04105 16.375 7.93749V2.125C16.375 1.50368 15.8713 1 15.25 1H2.125C1.50368 1 1 1.50368 1 2.125V12.9999C1 13.6213 1.50368 14.1249 2.125 14.1249H4.375V16.7499C4.375 16.9016 4.46646 17.0384 4.60669 17.0964C4.65217 17.1151 4.70083 17.1248 4.75 17.1249C4.84963 17.1249 4.94516 17.0853 5.0155 17.0147L7.90524 14.1249H7.93749C8.04104 14.1249 8.12499 14.041 8.12499 13.9374V10.375ZM3.2275 8.47674C3.44728 8.25781 3.80271 8.25781 4.0225 8.47674C4.6353 9.09574 5.43768 9.49179 6.30174 9.60174C6.60992 9.6413 6.82768 9.92319 6.78812 10.2314C6.74856 10.5395 6.46667 10.7573 6.15849 10.7177C5.04761 10.5765 4.01587 10.0678 3.2275 9.27249C3.00776 9.05289 3.00764 8.69674 3.22724 8.477C3.22733 8.47691 3.22741 8.47683 3.2275 8.47674ZM6.81249 5.875C6.81249 6.18566 6.56065 6.43749 6.24999 6.43749C5.93933 6.43749 5.68749 6.18566 5.68749 5.875V4.375C5.68749 4.06434 5.93933 3.8125 6.24999 3.8125C6.56065 3.8125 6.81249 4.06434 6.81249 4.375V5.875ZM11.3125 5.875C11.3125 6.18566 11.0606 6.43749 10.75 6.43749C10.4393 6.43749 10.1875 6.18566 10.1875 5.875V4.375C10.1875 4.06434 10.4393 3.8125 10.75 3.8125C11.0606 3.8125 11.3125 4.06434 11.3125 4.375V5.875Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.48,
    d: "M17.875 9.25H10.375C9.75368 9.25 9.25 9.75368 9.25 10.375V15.625C9.25 16.2463 9.75368 16.75 10.375 16.75H13.2497L16.15 18.9249C16.3157 19.0492 16.5507 19.0156 16.675 18.85C16.7237 18.785 16.75 18.7061 16.75 18.6249V16.75H17.875C18.4963 16.75 19 16.2463 19 15.625V10.375C19 9.75368 18.4963 9.25 17.875 9.25ZM11.875 13C11.875 12.5857 12.2108 12.25 12.625 12.25C13.0392 12.25 13.375 12.5857 13.375 13C13.375 13.4142 13.0392 13.75 12.625 13.75C12.2108 13.75 11.875 13.4142 11.875 13ZM15.625 13.75C15.2108 13.75 14.875 13.4142 14.875 13C14.875 12.5857 15.2108 12.25 15.625 12.25C16.0392 12.25 16.375 12.5857 16.375 13C16.375 13.4142 16.0392 13.75 15.625 13.75Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M4.0225 8.47674C3.80271 8.25781 3.44728 8.25781 3.2275 8.47674C3.0079 8.69648 3.00776 9.05289 3.2275 9.27249C4.01587 10.0678 5.04761 10.5765 6.15849 10.7177C6.46667 10.7573 6.74856 10.5395 6.78812 10.2314C6.82768 9.92319 6.60992 9.6413 6.30174 9.60174C5.43768 9.49179 4.6353 9.09574 4.0225 8.47674Z",
    fill: "white"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M6.24999 6.43749C6.56065 6.43749 6.81249 6.18566 6.81249 5.875V4.375C6.81249 4.06434 6.56065 3.8125 6.24999 3.8125C5.93933 3.8125 5.68749 4.06434 5.68749 4.375V5.875C5.68749 6.18566 5.93933 6.43749 6.24999 6.43749Z",
    fill: "white"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M10.75 6.43749C11.0606 6.43749 11.3125 6.18566 11.3125 5.875V4.375C11.3125 4.06434 11.0606 3.8125 10.75 3.8125C10.4393 3.8125 10.1875 4.06434 10.1875 4.375V5.875C10.1875 6.18566 10.4393 6.43749 10.75 6.43749Z",
    fill: "white"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M12.625 12.25C12.2108 12.25 11.875 12.5857 11.875 13C11.875 13.4142 12.2108 13.75 12.625 13.75C13.0392 13.75 13.375 13.4142 13.375 13C13.375 12.5857 13.0392 12.25 12.625 12.25Z",
    fill: "white"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M14.875 13C14.875 13.4142 15.2108 13.75 15.625 13.75C16.0392 13.75 16.375 13.4142 16.375 13C16.375 12.5857 16.0392 12.25 15.625 12.25C15.2108 12.25 14.875 12.5857 14.875 13Z",
    fill: "white"
  })]
}), 'CustomerStoriesIcon', 'Navigation');
/* harmony default export */ var Navigation_CustomerStoriesIcon = ((/* unused pure expression or super */ null && (CustomerStoriesIcon)));
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Navigation/DestinationsIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */



var DestinationsIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.48,
    d: "M8.125 10V9.99998C8.12607 9.60196 7.9678 9.22006 7.68549 8.93949L6.56049 7.81449C6.27856 7.53421 5.89754 7.37631 5.5 7.375H2.125C1.50368 7.375 1 7.87868 1 8.5V11.5C1 12.1213 1.50368 12.625 2.125 12.625H5.5C5.89803 12.6261 6.27992 12.4678 6.5605 12.1855L7.6855 11.0605C7.96781 10.7799 8.12608 10.398 8.125 10Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.48,
    d: "M17.875 7.37501H14.5C14.102 7.37393 13.7201 7.5322 13.4395 7.81451L12.3145 8.93951C11.7289 9.52526 11.7289 10.4748 12.3145 11.0605L13.4395 12.1855C13.7201 12.4678 14.102 12.6261 14.5 12.625H17.875C18.4963 12.625 19 12.1213 19 11.5V8.5C19 7.87868 18.4963 7.375 17.875 7.375V7.37501Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.24,
    d: "M11.0605 12.313C10.4748 11.7274 9.52525 11.7274 8.9395 12.313L7.8145 13.438C7.53225 13.7192 7.37402 14.1015 7.375 14.5V17.875C7.375 18.4963 7.87868 19 8.5 19H11.5C12.1213 19 12.625 18.4963 12.625 17.875V14.5C12.6257 14.1022 12.4678 13.7205 12.1862 13.4395L11.0605 12.313Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.24,
    d: "M8.9395 7.684C9.52525 8.26957 10.4748 8.26957 11.0605 7.684L12.1855 6.559C12.467 6.2785 12.6252 5.8974 12.625 5.5V2.125C12.625 1.50368 12.1213 1 11.5 1H8.50001C7.87868 1 7.375 1.50368 7.375 2.125V5.5V5.49999C7.37397 5.89823 7.53221 6.28034 7.81449 6.56124L8.9395 7.684Z",
    fill: "none"
  })]
}), 'DestinationsIcon', 'Navigation');
/* harmony default export */ var Navigation_DestinationsIcon = ((/* unused pure expression or super */ null && (DestinationsIcon)));
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Navigation/DevelopertoolkitIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */



var DevelopertoolkitIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3333 5.67067H15.6667C16.9533 5.67067 18 6.718 18 8.004V14.6707C18 15.9567 16.9533 17.004 15.6667 17H4.33333C3.04667 17.004 2 15.9567 2 14.6707V8.004C2 6.718 3.04667 5.67067 4.33333 5.67067H6.66667V5C6.66667 3.89733 7.564 3 8.66667 3H11.3333C12.436 3 13.3333 3.89733 13.3333 5V5.67067ZM8.66667 4.33333C8.29867 4.33333 8 4.63267 8 5V5.67067H12V5C12 4.63267 11.7013 4.33333 11.3333 4.33333H8.66667ZM11.3467 9.14501L9.90438 13.8875C9.86508 14.0165 9.78475 14.1295 9.67531 14.2098C9.56587 14.2901 9.43314 14.3334 9.29683 14.3333C9.23494 14.3334 9.17337 14.3246 9.11403 14.3072C8.95321 14.259 8.81835 14.1496 8.7391 14.0032C8.65985 13.8567 8.64268 13.6852 8.69139 13.5262L10.1337 8.78373C10.1572 8.7044 10.1964 8.63044 10.2489 8.56613C10.3015 8.50182 10.3664 8.44843 10.44 8.40904C10.5135 8.36964 10.5942 8.34502 10.6775 8.3366C10.7607 8.32817 10.8448 8.3361 10.9249 8.35994C11.005 8.38378 11.0795 8.42305 11.1442 8.47549C11.2089 8.52792 11.2624 8.59249 11.3017 8.66547C11.341 8.73845 11.3653 8.81839 11.3732 8.90069C11.3811 8.983 11.3725 9.06603 11.3477 9.14501H11.3467ZM7.71948 13.0205C7.68839 12.9431 7.64199 12.8726 7.58299 12.8131L6.16606 11.3283L7.58933 9.79759C7.64566 9.73699 7.68937 9.66601 7.71794 9.58871C7.74652 9.51141 7.75941 9.42931 7.75588 9.34709C7.75235 9.26487 7.73246 9.18415 7.69735 9.10952C7.66225 9.03489 7.61262 8.96783 7.55129 8.91216C7.48996 8.85649 7.41813 8.8133 7.33991 8.78506C7.26169 8.75683 7.17861 8.74409 7.09541 8.74758C7.0122 8.75107 6.93051 8.77072 6.85499 8.80541C6.77948 8.8401 6.71161 8.88914 6.65528 8.94975L4.83367 10.9117C4.72536 11.0283 4.6657 11.181 4.66668 11.3392C4.66766 11.4975 4.7292 11.6495 4.83895 11.7648L6.66056 13.6724C6.71718 13.7341 6.78568 13.784 6.86206 13.8193C6.93844 13.8545 7.02116 13.8743 7.10538 13.8776C7.18961 13.8808 7.27364 13.8675 7.35258 13.8383C7.43151 13.809 7.50376 13.7646 7.56509 13.7074C7.62642 13.6503 7.67561 13.5816 7.70977 13.5055C7.74393 13.4293 7.76239 13.3472 7.76406 13.264C7.76572 13.1807 7.75057 13.0979 7.71948 13.0205ZM15.161 10.8511C15.2708 10.9664 15.3323 11.1184 15.3333 11.2766C15.3343 11.4349 15.2746 11.5876 15.1663 11.7042L13.3405 13.6661C13.2267 13.7885 13.0684 13.8612 12.9004 13.8683C12.7323 13.8753 12.5683 13.8161 12.4445 13.7037C12.3206 13.5913 12.247 13.4348 12.2399 13.2688C12.2328 13.1027 12.2927 12.9407 12.4064 12.8183L13.8297 11.2855L12.4128 9.80177C12.3013 9.68024 12.2425 9.52034 12.249 9.35641C12.2555 9.19249 12.3268 9.03763 12.4476 8.9251C12.5684 8.81257 12.729 8.75135 12.895 8.75459C13.0609 8.75783 13.219 8.82528 13.3352 8.94244L15.161 10.8511Z",
    fill: "#8D869A"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6667 5.67066H13.3333V4.99999C13.3333 3.89899 12.4387 3.00269 11.3383 3H10V4.33333H11.3333C11.7013 4.33333 12 4.63266 12 4.99999V5.67066H10V9.22326L10.1337 8.78373C10.1572 8.70439 10.1964 8.63043 10.2489 8.56613C10.3015 8.50182 10.3664 8.44843 10.44 8.40903C10.5135 8.36964 10.5942 8.34502 10.6775 8.33659C10.7607 8.32816 10.8448 8.3361 10.9249 8.35993C11.005 8.38377 11.0795 8.42304 11.1442 8.47548C11.2089 8.52792 11.2624 8.59249 11.3017 8.66546C11.341 8.73844 11.3653 8.81839 11.3732 8.90069C11.3811 8.98299 11.3725 9.06602 11.3477 9.145H11.3467L10 13.5731V17L15.6667 17C15.6674 17 15.6681 17 15.6688 17C15.6723 17 15.6757 17 15.6792 17C16.9601 16.9972 18 15.9525 18 14.6707V8.00399C18 6.71799 16.9533 5.67066 15.6667 5.67066ZM15.3333 11.2766C15.3323 11.1184 15.2708 10.9664 15.161 10.8511L13.3352 8.94244C13.219 8.82527 13.0609 8.75783 12.895 8.75458C12.729 8.75134 12.5684 8.81256 12.4476 8.92509C12.3268 9.03762 12.2555 9.19248 12.249 9.35641C12.2425 9.52033 12.3013 9.68023 12.4128 9.80176L13.8297 11.2855L12.4064 12.8183C12.2927 12.9407 12.2328 13.1027 12.2399 13.2688C12.247 13.4348 12.3206 13.5913 12.4445 13.7037C12.5683 13.8161 12.7323 13.8753 12.9004 13.8683C13.0684 13.8612 13.2267 13.7885 13.3405 13.6661L15.1663 11.7042C15.2746 11.5876 15.3343 11.4349 15.3333 11.2766Z",
    fill: "#C2BFCB"
  })]
}), 'DevelopertoolkitIcon', 'Navigation');
/* harmony default export */ var Navigation_DevelopertoolkitIcon = ((/* unused pure expression or super */ null && (DevelopertoolkitIcon)));
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Navigation/EnterpriseIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */



var EnterpriseIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.48,
    d: "M6.14614 18.2291H13.2712C13.3761 18.2291 13.4768 18.1874 13.5511 18.1132C13.6253 18.039 13.667 17.9383 13.667 17.8333V2.39583C13.667 2.29085 13.6253 2.19017 13.5511 2.11594C13.4768 2.0417 13.3761 2 13.2712 2H6.14614C6.04116 2 5.94048 2.0417 5.86625 2.11594C5.79201 2.19017 5.75031 2.29085 5.75031 2.39583V17.8333C5.75031 17.9383 5.79201 18.039 5.86625 18.1132C5.94048 18.1874 6.04116 18.2291 6.14614 18.2291ZM10.5003 3.97917C10.5003 3.87419 10.542 3.7735 10.6163 3.69927C10.6905 3.62504 10.7912 3.58333 10.8962 3.58333H11.6878C11.7928 3.58333 11.8935 3.62504 11.9677 3.69927C12.042 3.7735 12.0837 3.87419 12.0837 3.97917V4.77083C12.0837 4.87582 12.042 4.9765 11.9677 5.05073C11.8935 5.12496 11.7928 5.16667 11.6878 5.16667H10.8962C10.7912 5.16667 10.6905 5.12496 10.6163 5.05073C10.542 4.9765 10.5003 4.87582 10.5003 4.77083V3.97917ZM10.5003 7.9375C10.5003 7.83252 10.542 7.73184 10.6163 7.6576C10.6905 7.58337 10.7912 7.54167 10.8962 7.54167H11.6878C11.7928 7.54167 11.8935 7.58337 11.9677 7.6576C12.042 7.73184 12.0837 7.83252 12.0837 7.9375V8.72917C12.0837 8.83415 12.042 8.93483 11.9677 9.00906C11.8935 9.0833 11.7928 9.125 11.6878 9.125H10.8962C10.7912 9.125 10.6905 9.0833 10.6163 9.00906C10.542 8.93483 10.5003 8.83415 10.5003 8.72917V7.9375ZM10.5003 11.8958C10.5003 11.7908 10.542 11.6902 10.6163 11.6159C10.6905 11.5417 10.7912 11.5 10.8962 11.5H11.6878C11.7928 11.5 11.8935 11.5417 11.9677 11.6159C12.042 11.6902 12.0837 11.7908 12.0837 11.8958V12.6875C12.0837 12.7924 12.042 12.8931 11.9677 12.9674C11.8935 13.0416 11.7928 13.0833 11.6878 13.0833H10.8962C10.7912 13.0833 10.6905 13.0416 10.6163 12.9674C10.542 12.8931 10.5003 12.7924 10.5003 12.6875V11.8958ZM7.33364 3.97917C7.33364 3.87419 7.37534 3.7735 7.44957 3.69927C7.5238 3.62504 7.62449 3.58333 7.72948 3.58333H8.52114C8.62612 3.58333 8.7268 3.62504 8.80103 3.69927C8.87526 3.7735 8.91698 3.87419 8.91698 3.97917V4.77083C8.91698 4.87582 8.87526 4.9765 8.80103 5.05073C8.7268 5.12496 8.62612 5.16667 8.52114 5.16667H7.72948C7.62449 5.16667 7.5238 5.12496 7.44957 5.05073C7.37534 4.9765 7.33364 4.87582 7.33364 4.77083V3.97917ZM7.33364 7.9375C7.33364 7.83252 7.37534 7.73184 7.44957 7.6576C7.5238 7.58337 7.62449 7.54167 7.72948 7.54167H8.52114C8.62612 7.54167 8.7268 7.58337 8.80103 7.6576C8.87526 7.73184 8.91698 7.83252 8.91698 7.9375V8.72917C8.91698 8.83415 8.87526 8.93483 8.80103 9.00906C8.7268 9.0833 8.62612 9.125 8.52114 9.125H7.72948C7.62449 9.125 7.5238 9.0833 7.44957 9.00906C7.37534 8.93483 7.33364 8.83415 7.33364 8.72917V7.9375ZM7.33364 11.8958C7.33364 11.7908 7.37534 11.6902 7.44957 11.6159C7.5238 11.5417 7.62449 11.5 7.72948 11.5H8.52114C8.62612 11.5 8.7268 11.5417 8.80103 11.6159C8.87526 11.6902 8.91698 11.7908 8.91698 11.8958V12.6875C8.91698 12.7924 8.87526 12.8931 8.80103 12.9674C8.7268 13.0416 8.62612 13.0833 8.52114 13.0833H7.72948C7.62449 13.0833 7.5238 13.0416 7.44957 12.9674C7.37534 12.8931 7.33364 12.7924 7.33364 12.6875V11.8958Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.24,
    d: "M4.16667 8.3335H1.39584C1.17722 8.3335 1 8.51072 1 8.72934V17.8335C1 18.0521 1.17722 18.2293 1.39584 18.2293H4.16667C4.38528 18.2293 4.5625 18.0521 4.5625 17.8335V8.72934C4.5625 8.51072 4.38528 8.3335 4.16667 8.3335Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.24,
    d: "M18.0212 8.3335H15.2503C15.0317 8.3335 14.8545 8.51072 14.8545 8.72934V17.8335C14.8545 18.0521 15.0317 18.2293 15.2503 18.2293H18.0212C18.2398 18.2293 18.417 18.0521 18.417 17.8335V8.72934C18.417 8.51072 18.2398 8.3335 18.0212 8.3335Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M10.5003 3.97909C10.5003 3.87411 10.542 3.77342 10.6163 3.69919C10.6905 3.62496 10.7912 3.58325 10.8962 3.58325H11.6878C11.7928 3.58325 11.8935 3.62496 11.9677 3.69919C12.042 3.77342 12.0837 3.87411 12.0837 3.97909V4.77075C12.0837 4.87574 12.042 4.97642 11.9677 5.05065C11.8935 5.12488 11.7928 5.16659 11.6878 5.16659H10.8962C10.7912 5.16659 10.6905 5.12488 10.6163 5.05065C10.542 4.97642 10.5003 4.87574 10.5003 4.77075V3.97909ZM10.5003 7.93742C10.5003 7.83244 10.542 7.73176 10.6163 7.65752C10.6905 7.58329 10.7912 7.54159 10.8962 7.54159H11.6878C11.7928 7.54159 11.8935 7.58329 11.9677 7.65752C12.042 7.73176 12.0837 7.83244 12.0837 7.93742V8.72909C12.0837 8.83407 12.042 8.93475 11.9677 9.00898C11.8935 9.08322 11.7928 9.12492 11.6878 9.12492H10.8962C10.7912 9.12492 10.6905 9.08322 10.6163 9.00898C10.542 8.93475 10.5003 8.83407 10.5003 8.72909V7.93742ZM10.5003 11.8958C10.5003 11.7908 10.542 11.6901 10.6163 11.6159C10.6905 11.5416 10.7912 11.4999 10.8962 11.4999H11.6878C11.7928 11.4999 11.8935 11.5416 11.9677 11.6159C12.042 11.6901 12.0837 11.7908 12.0837 11.8958V12.6875C12.0837 12.7924 12.042 12.8931 11.9677 12.9674C11.8935 13.0416 11.7928 13.0833 11.6878 13.0833H10.8962C10.7912 13.0833 10.6905 13.0416 10.6163 12.9674C10.542 12.8931 10.5003 12.7924 10.5003 12.6875V11.8958ZM7.33362 3.97909C7.33362 3.87411 7.37533 3.77342 7.44956 3.69919C7.52379 3.62496 7.62447 3.58325 7.72946 3.58325H8.52112C8.6261 3.58325 8.72679 3.62496 8.80102 3.69919C8.87525 3.77342 8.91696 3.87411 8.91696 3.97909V4.77075C8.91696 4.87574 8.87525 4.97642 8.80102 5.05065C8.72679 5.12488 8.6261 5.16659 8.52112 5.16659H7.72946C7.62447 5.16659 7.52379 5.12488 7.44956 5.05065C7.37533 4.97642 7.33362 4.87574 7.33362 4.77075V3.97909ZM7.33362 7.93742C7.33362 7.83244 7.37533 7.73176 7.44956 7.65752C7.52379 7.58329 7.62447 7.54159 7.72946 7.54159H8.52112C8.6261 7.54159 8.72679 7.58329 8.80102 7.65752C8.87525 7.73176 8.91696 7.83244 8.91696 7.93742V8.72909C8.91696 8.83407 8.87525 8.93475 8.80102 9.00898C8.72679 9.08322 8.6261 9.12492 8.52112 9.12492H7.72946C7.62447 9.12492 7.52379 9.08322 7.44956 9.00898C7.37533 8.93475 7.33362 8.83407 7.33362 8.72909V7.93742ZM7.33362 11.8958C7.33362 11.7908 7.37533 11.6901 7.44956 11.6159C7.52379 11.5416 7.62447 11.4999 7.72946 11.4999H8.52112C8.6261 11.4999 8.72679 11.5416 8.80102 11.6159C8.87525 11.6901 8.91696 11.7908 8.91696 11.8958V12.6875C8.91696 12.7924 8.87525 12.8931 8.80102 12.9674C8.72679 13.0416 8.6261 13.0833 8.52112 13.0833H7.72946C7.62447 13.0833 7.52379 13.0416 7.44956 12.9674C7.37533 12.8931 7.33362 12.7924 7.33362 12.6875V11.8958Z",
    fill: "white"
  })]
}), 'EnterpriseIcon', 'Navigation');
/* harmony default export */ var Navigation_EnterpriseIcon = ((/* unused pure expression or super */ null && (EnterpriseIcon)));
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Navigation/FinanceIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */



var FinanceIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M8.03424 10.5557H2V14.1112C2 14.6021 2.35815 15.0001 2.80005 15.0001H17.2C17.6418 15.0001 18 14.6021 18 14.1112V10.5557H11.9658C11.792 11.947 10.978 13 10 13C9.022 13 8.20796 11.947 8.03424 10.5557Z",
    fill: "#92889D"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M2.80005 5C2.35815 5 2 5.39798 2 5.88888V9.44444H8.03423C8.20792 8.05302 9.02198 7 10 7C10.978 7 11.7921 8.05302 11.9658 9.44444H18V5.88888C18 5.39798 17.6418 5 17.2 5H2.80005Z",
    fill: "#C9C3CE"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ellipse", {
    cx: 10,
    cy: 10,
    rx: 2,
    ry: 3,
    fill: "white"
  })]
}), 'FinanceIcon', 'Navigation');
/* harmony default export */ var Navigation_FinanceIcon = ((/* unused pure expression or super */ null && (FinanceIcon)));
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Navigation/FunctionsIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */



var FunctionsIcon_FunctionsIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.48,
    d: "M2 4C2 2.89543 2.89543 2 4 2H13V18H4C2.89543 18 2 17.1046 2 16V4Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.24,
    d: "M13 2H18V18H13V2Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M5.52775 4.42663C5.40032 4.65789 5.15723 4.80151 4.89325 4.80151C4.62927 4.80151 4.38618 4.65789 4.25875 4.42663C4.1867 4.3145 4.14675 4.18476 4.14325 4.05151C4.14664 3.91825 4.18659 3.78848 4.25875 3.6764C4.38618 3.44514 4.62927 3.30151 4.89325 3.30151C5.15723 3.30151 5.40032 3.44514 5.52775 3.6764C5.5999 3.78848 5.63986 3.91825 5.64325 4.05151C5.63975 4.18476 5.5998 4.3145 5.52775 4.42663Z",
    fill: "white"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M8.02775 4.42663C7.90032 4.65789 7.65723 4.80151 7.39325 4.80151C7.12927 4.80151 6.88618 4.65789 6.75875 4.42663C6.6867 4.3145 6.64675 4.18476 6.64325 4.05151C6.64664 3.91825 6.68659 3.78848 6.75875 3.6764C6.88618 3.44514 7.12927 3.30151 7.39325 3.30151C7.65723 3.30151 7.90032 3.44514 8.02775 3.6764C8.0999 3.78848 8.13986 3.91825 8.14325 4.05151C8.13975 4.18476 8.0998 4.3145 8.02775 4.42663Z",
    fill: "white"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M9.89325 4.80151C10.1572 4.80151 10.4003 4.65791 10.5277 4.42669C10.5998 4.31457 10.6397 4.18485 10.6432 4.05163C10.6425 3.9456 10.6189 3.84098 10.5742 3.74483C10.4539 3.47622 10.1876 3.30285 9.89325 3.30151C9.62996 3.30424 9.38811 3.4472 9.25875 3.67657C9.18659 3.78863 9.14664 3.91838 9.14325 4.05163C9.14675 4.18485 9.1867 4.31457 9.25875 4.42669C9.38618 4.65791 9.62927 4.80151 9.89325 4.80151Z",
    fill: "white"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M6.9952 11.4975C7.25556 11.7489 7.6776 11.7489 7.93795 11.4975L9.60478 9.88746C9.86506 9.63598 9.86506 9.22832 9.60478 8.97683L7.93795 7.36682C7.67634 7.12275 7.2605 7.12625 7.00332 7.37466C6.74614 7.62308 6.74253 8.02475 6.9952 8.27744L8.07263 9.31816C8.10398 9.34836 8.1216 9.38938 8.1216 9.43215C8.1216 9.47492 8.10398 9.51593 8.07263 9.54614L6.9952 10.5869C6.73492 10.8383 6.73492 11.246 6.9952 11.4975Z",
    fill: "white"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M14.1333 12.186H11.4667C11.0985 12.186 10.8 11.9622 10.8 11.686C10.8 11.4099 11.0985 11.186 11.4667 11.186H14.1333C14.5015 11.186 14.8 11.4099 14.8 11.686C14.8 11.9622 14.5015 12.186 14.1333 12.186Z",
    fill: "white"
  })]
}), 'FunctionsIcon', 'Navigation');
/* harmony default export */ var Navigation_FunctionsIcon = ((/* unused pure expression or super */ null && (FunctionsIcon_FunctionsIcon)));
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Navigation/GdprIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */



var GdprIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.24,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 17.554L12.0337 16.52C12.2929 16.261 12.8051 16.049 13.1717 16.049H14.7153C15.4492 16.049 16.0488 15.4486 16.0488 14.7153V13.1723C16.0488 12.8051 16.2612 12.2933 16.52 12.0345L17.6112 10.9435C18.1292 10.4243 18.1292 9.57545 17.6112 9.05704L16.52 7.96602C16.261 7.70701 16.0488 7.1952 16.0488 6.8282V5.28517C16.0488 4.55115 15.4492 3.95154 14.7153 3.95114H13.1717C12.8051 3.95114 12.2927 3.73854 12.0337 3.47973L11 2.44604V9.05661L13.0571 7L13.9997 7.94262L11 10.9419V17.554Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.48,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 2.44614L10.9427 2.38881C10.4243 1.8704 9.57544 1.8704 9.05703 2.38881L7.96601 3.48063C7.70681 3.73963 7.1938 3.95164 6.82799 3.95164H5.28496C4.55195 3.95164 3.95154 4.55125 3.95154 5.28526V6.82829C3.95154 7.1939 3.73933 7.70731 3.48033 7.96611L2.38911 9.05713C1.8703 9.57554 1.8703 10.4244 2.38911 10.9436L3.48033 12.0346C3.73953 12.2936 3.95154 12.8068 3.95154 13.1724V14.7154C3.95154 15.4487 4.55195 16.0491 5.28496 16.0491H6.82799C7.1946 16.0491 7.70701 16.2613 7.96601 16.5201L9.05703 17.6115C9.57544 18.1295 10.4243 18.1295 10.9427 17.6115L11 17.5541V10.942L8.94143 13.0002L5.99958 10.058L6.94239 9.11533L8.94163 11.1146L11 9.0567V2.44614Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M8.94143 13.0001L5.99957 10.0579L6.94239 9.11524L8.94163 11.1145L13.0571 7L13.9997 7.94262L8.94143 13.0001Z",
    fill: "white"
  })]
}), 'GdprIcon', 'Navigation');
/* harmony default export */ var Navigation_GdprIcon = ((/* unused pure expression or super */ null && (GdprIcon)));
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Navigation/HealthcareIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */



var HealthcareIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
  width: 18,
  height: 20,
  viewBox: "0 0 18 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M5.62 3.38994V2.64994C5.62 2.45994 5.69 2.27994 5.83 2.14994C5.96 2.01994 6.14 1.93994 6.33 1.93994H11.66C11.85 1.93994 12.03 2.01994 12.16 2.14994C12.29 2.27994 12.37 2.45994 12.37 2.64994V3.38994C12.82 3.40994 13.24 3.43994 13.62 3.45994V2.63994C13.62 2.11994 13.41 1.61994 13.05 1.25994C12.68 0.899941 12.18 0.689941 11.66 0.689941H6.33C5.81 0.689941 5.31 0.899941 4.94 1.25994C4.57 1.62994 4.37 2.11994 4.37 2.63994V3.45994C4.75 3.42994 5.17 3.40994 5.62 3.38994Z",
    fill: "none",
    fillOpacity: 0.24
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M17.75 17.1301C17.87 15.9601 18 14.1301 18 11.8101C18 9.49006 17.87 7.66006 17.75 6.49006C17.66 5.60006 17.03 4.89006 16.13 4.74006C14.85 4.54006 12.62 4.31006 9 4.31006C5.38 4.31006 3.15 4.54006 1.87 4.74006C0.96 4.89006 0.34 5.60006 0.25 6.49006C0.13 7.66006 0 9.49006 0 11.8101C0 14.1301 0.13 15.9601 0.25 17.1301C0.34 18.0201 0.97 18.7301 1.87 18.8801C3.15 19.0801 5.38 19.3101 9 19.3101C12.62 19.3101 14.85 19.0801 16.13 18.8801C17.04 18.7301 17.66 18.0201 17.75 17.1301ZM9.96 15.9201C9.72 15.9501 9.4 15.9801 9 15.9801C8.6 15.9801 8.28 15.9501 8.04 15.9201C7.65 15.8701 7.4 15.5301 7.38 15.1401C7.37 14.7601 7.35 14.2101 7.34 13.4701C6.6 13.4601 6.05 13.4401 5.67 13.4301C5.27 13.4201 4.94 13.1601 4.89 12.7701C4.86 12.5301 4.83 12.2101 4.83 11.8101C4.83 11.4101 4.86 11.0901 4.89 10.8501C4.94 10.4601 5.28 10.2101 5.67 10.1901C6.05 10.1801 6.6 10.1601 7.34 10.1501C7.34 9.41006 7.37 8.86006 7.38 8.48006C7.39 8.08006 7.65 7.75006 8.04 7.70006C8.28 7.67006 8.6 7.64006 9 7.64006C9.4 7.64006 9.72 7.67006 9.96 7.70006C10.35 7.75006 10.6 8.09006 10.62 8.48006C10.63 8.86006 10.65 9.41006 10.66 10.1501C11.4 10.1501 11.95 10.1801 12.33 10.1901C12.73 10.2001 13.06 10.4601 13.11 10.8501C13.14 11.0901 13.17 11.4101 13.17 11.8101C13.17 12.2101 13.14 12.5301 13.11 12.7701C13.06 13.1601 12.72 13.4101 12.33 13.4301C11.95 13.4401 11.4 13.4601 10.66 13.4701C10.65 14.2101 10.63 14.7601 10.62 15.1401C10.61 15.5401 10.35 15.8701 9.96 15.9201Z",
    fill: "none",
    fillOpacity: 0.48
  })]
}), 'HealthcareIcon', 'Navigation');
/* harmony default export */ var Navigation_HealthcareIcon = ((/* unused pure expression or super */ null && (HealthcareIcon)));
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Navigation/HelpIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */



var HelpIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.48,
    d: "M10.0001 5.45313C10.6769 5.45313 11.3176 5.60073 11.8936 5.86713C12.1708 5.99313 12.4948 5.93913 12.7108 5.72673L14.7952 3.64233C15.1228 3.31473 15.058 2.76753 14.6656 2.52273C13.3156 1.66953 11.7136 1.17993 10.0001 1.17993C8.28645 1.17993 6.68445 1.66953 5.33085 2.51553C4.93845 2.76033 4.87365 3.30753 5.20125 3.63513L7.28565 5.71953C7.50165 5.93553 7.82565 5.98953 8.10285 5.85993C8.68245 5.60073 9.32325 5.45313 10.0001 5.45313Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.48,
    d: "M14.5468 9.99987C14.5468 10.6767 14.3992 11.3175 14.1328 11.8935C14.0068 12.1707 14.0608 12.4947 14.2732 12.7107L16.3576 14.7951C16.6852 15.1227 17.2324 15.0579 17.4772 14.6655C18.3304 13.3155 18.82 11.7135 18.82 9.99987C18.82 8.28627 18.3304 6.68427 17.4844 5.33067C17.2396 4.93827 16.6924 4.87347 16.3648 5.20107L14.2804 7.28547C14.0644 7.50147 14.0104 7.82547 14.14 8.10267C14.3992 8.68227 14.5468 9.32307 14.5468 9.99987Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.48,
    d: "M9.99999 14.5468C9.32319 14.5468 8.68239 14.3992 8.10639 14.1328C7.82919 14.0068 7.50519 14.0608 7.28919 14.2732L5.20479 16.3576C4.87719 16.6852 4.94199 17.2324 5.33439 17.4772C6.68439 18.3304 8.28639 18.82 9.99999 18.82C11.7136 18.82 13.3156 18.3304 14.6692 17.4844C15.0616 17.2396 15.1264 16.6924 14.7988 16.3648L12.7144 14.2804C12.4984 14.0644 12.1744 14.0104 11.8972 14.14C11.3176 14.3992 10.6768 14.5468 9.99999 14.5468Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.48,
    d: "M5.45319 9.99993C5.45319 9.32313 5.60079 8.68233 5.86719 8.10633C5.99319 7.82913 5.93919 7.50513 5.72679 7.28913L3.64239 5.20473C3.31479 4.87713 2.76759 4.94193 2.52279 5.33433C1.66959 6.68433 1.17999 8.28633 1.17999 9.99993C1.17999 11.7135 1.66959 13.3155 2.51559 14.6691C2.76039 15.0615 3.30759 15.1263 3.63519 14.7987L5.71959 12.7143C5.93559 12.4983 5.98959 12.1743 5.85999 11.8971C5.60079 11.3175 5.45319 10.6767 5.45319 9.99993Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.24,
    d: "M9.99994 13C11.6568 13 12.9999 11.6569 12.9999 10C12.9999 8.34315 11.6568 7 9.99994 7C8.34308 7 6.99994 8.34315 6.99994 10C6.99994 11.6569 8.34308 13 9.99994 13Z",
    fill: "none"
  })]
}), 'HelpIcon', 'Navigation');
/* harmony default export */ var Navigation_HelpIcon = ((/* unused pure expression or super */ null && (HelpIcon)));
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Navigation/IosIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */



var IosIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.48,
    d: "M14 0C14 2.76114 11.7605 4.99836 9 5C9 2.23722 11.2386 0 14 0Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.48,
    d: "M13.7074 10.875C13.7074 9.46732 14.6923 8.27088 16.0684 7.81957C15.1969 6.70525 13.9317 6 12.5179 6C11.6025 6 10.6426 6.546 10.6426 6.546C10.3652 6.70395 9.91138 6.70395 9.63355 6.546C9.63355 6.546 8.67384 6 7.75844 6C5.13068 6 2.99916 8.42472 3 11.4167C3 15.6018 4.86335 19 7.16371 19C8.26496 19 9.61444 18.3426 9.61444 18.3426C9.90298 18.2018 10.3746 18.2018 10.6624 18.3426C10.6624 18.3426 12.0112 19 13.1124 19C14.8905 19 16.4025 16.9672 17 14.1122C15.1581 13.984 13.7074 12.5847 13.7074 10.875Z",
    fill: "none"
  })]
}), 'IosIcon', 'Navigation');
/* harmony default export */ var Navigation_IosIcon = ((/* unused pure expression or super */ null && (IosIcon)));
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Navigation/JavascriptIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */



var JavascriptIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.48,
    d: "M11.9165 6.66674C11.1341 6.66674 10.5 6.03179 10.5 5.25V1H3.41653C2.6341 1 2 1.63346 2 2.41674V16.5833C2 17.3651 2.6341 18 3.41653 18H14.75C15.5316 18 16.1665 17.3665 16.1665 16.5833V6.66674H11.9165ZM8.4787 14.0613L7.72751 14.8125L5.04087 12.1257C4.7642 11.8496 4.7642 11.4008 5.04087 11.1241L7.72751 8.4375L8.4787 9.18869L6.04239 11.625L8.4787 14.0613ZM13.3333 14.1042H9.79153V13.0417H13.3333V14.1042Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M8.47871 14.0613L7.72752 14.8125L5.04088 12.1257C4.76421 11.8496 4.76421 11.4008 5.04088 11.1241L7.72752 8.4375L8.47871 9.18869L6.0424 11.625L8.47871 14.0613ZM13.3333 14.1042H9.79154V13.0417H13.3333V14.1042Z",
    fill: "white"
  })]
}), 'JavascriptIcon', 'Navigation');
/* harmony default export */ var Navigation_JavascriptIcon = ((/* unused pure expression or super */ null && (JavascriptIcon)));
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Navigation/JourneysIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */


var JourneysIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
  width: 25,
  height: 24,
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.48,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.333 5a3 3 0 114 2.83V17a3 3 0 106 0v-2.17a3.001 3.001 0 010-5.66V7a5 5 0 1110 0v9.17a3.001 3.001 0 01-1 5.83 3 3 0 01-1-5.83V7a3 3 0 00-6 0v2.17a3.001 3.001 0 010 5.66V17a5 5 0 01-10 0V7.83a3.001 3.001 0 01-2-2.83zm3-1a1 1 0 100 2 1 1 0 000-2zm15 15a1 1 0 112 0 1 1 0 01-2 0z"
  })
}), 'JourneysIcon', 'Navigation');
/* harmony default export */ var Navigation_JourneysIcon = ((/* unused pure expression or super */ null && (JourneysIcon)));
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Navigation/LibraryIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */



var LibraryIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.48,
    d: "M17.3333 2C17.1565 2 16.9869 2.07024 16.8619 2.19526C16.7369 2.32029 16.6667 2.48986 16.6667 2.66667V6C16.6667 6.26522 16.5613 6.51957 16.3738 6.70711C16.1862 6.89464 15.9319 7 15.6667 7C15.4014 7 15.1471 6.89464 14.9596 6.70711C14.772 6.51957 14.6667 6.26522 14.6667 6V2.66667C14.6667 2.48986 14.5964 2.32029 14.4714 2.19526C14.3464 2.07024 14.1768 2 14 2C13.8232 2 13.6536 2.07024 13.5286 2.19526C13.4036 2.32029 13.3333 2.48986 13.3333 2.66667V12.54C13.3336 12.576 13.3452 12.611 13.3667 12.64C13.6523 12.9962 14.0161 13.2818 14.4298 13.4749C14.8436 13.6679 15.2962 13.7632 15.7527 13.7533C16.1606 13.7595 16.5657 13.6835 16.9437 13.5298C17.3216 13.3761 17.6648 13.1478 17.9527 12.8587C17.9827 12.8278 17.9995 12.7864 17.9993 12.7433V2.66667C17.9993 2.48997 17.9292 2.3205 17.8043 2.1955C17.6794 2.07049 17.51 2.00018 17.3333 2V2Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.24,
    d: "M17.7533 14.2527C17.1092 14.5966 16.3874 14.7687 15.6574 14.7524C14.9275 14.736 14.214 14.5318 13.586 14.1594C13.5607 14.1442 13.5318 14.1359 13.5023 14.1355C13.4728 14.1351 13.4437 14.1425 13.418 14.157C13.3924 14.1715 13.371 14.1926 13.3561 14.2181C13.3412 14.2436 13.3333 14.2726 13.3333 14.3021V15.6667C13.3333 16.2856 13.5792 16.8791 14.0167 17.3166C14.4543 17.7542 15.0478 18.0001 15.6667 18.0001C16.2855 18.0001 16.879 17.7542 17.3166 17.3166C17.7542 16.8791 18 16.2856 18 15.6667V14.4001C18.0001 14.3711 17.9926 14.3426 17.9783 14.3174C17.964 14.2922 17.9434 14.2712 17.9185 14.2564C17.8936 14.2415 17.8653 14.2335 17.8363 14.233C17.8073 14.2325 17.7787 14.2395 17.7533 14.2534V14.2527Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.48,
    d: "M11.6667 2C11.4899 2 11.3203 2.07024 11.1953 2.19526C11.0702 2.32029 11 2.48986 11 2.66667V6C11 6.26522 10.8946 6.51957 10.7071 6.70711C10.5196 6.89464 10.2652 7 10 7C9.73479 7 9.48043 6.89464 9.2929 6.70711C9.10536 6.51957 9.00001 6.26522 9.00001 6V2.66667C9.00001 2.48986 8.92977 2.32029 8.80474 2.19526C8.67972 2.07024 8.51015 2 8.33334 2C8.15653 2 7.98696 2.07024 7.86193 2.19526C7.73691 2.32029 7.66667 2.48986 7.66667 2.66667V12.54C7.66691 12.576 7.67858 12.611 7.70001 12.64C7.98566 12.9962 8.34944 13.2818 8.76318 13.4749C9.17693 13.6679 9.62954 13.7632 10.086 13.7533C10.494 13.7595 10.899 13.6835 11.277 13.5298C11.655 13.3761 11.9981 13.1478 12.286 12.8587C12.316 12.8278 12.3328 12.7864 12.3327 12.7433V2.66667C12.3327 2.48997 12.2625 2.3205 12.1376 2.1955C12.0128 2.07049 11.8434 2.00018 11.6667 2V2Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.24,
    d: "M12.0867 14.2527C11.4426 14.5966 10.7207 14.7687 9.99077 14.7524C9.26081 14.736 8.54738 14.5318 7.91934 14.1594C7.89406 14.1442 7.86519 14.1359 7.83569 14.1355C7.80618 14.1351 7.77709 14.1425 7.75139 14.157C7.72569 14.1715 7.70431 14.1926 7.68943 14.2181C7.67454 14.2436 7.66669 14.2726 7.66667 14.3021V15.6667C7.66667 16.2856 7.9125 16.8791 8.35009 17.3166C8.78767 17.7542 9.38117 18.0001 10 18.0001C10.6188 18.0001 11.2123 17.7542 11.6499 17.3166C12.0875 16.8791 12.3333 16.2856 12.3333 15.6667V14.4001C12.3334 14.3711 12.3259 14.3426 12.3117 14.3174C12.2974 14.2922 12.2768 14.2712 12.2519 14.2564C12.227 14.2415 12.1986 14.2335 12.1697 14.233C12.1407 14.2325 12.1121 14.2395 12.0867 14.2534V14.2527Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.48,
    d: "M6 2C5.82319 2 5.65362 2.07024 5.5286 2.19526C5.40357 2.32029 5.33333 2.48986 5.33333 2.66667V6C5.33333 6.26522 5.22798 6.51957 5.04044 6.70711C4.8529 6.89464 4.59855 7 4.33333 7C4.06812 7 3.81376 6.89464 3.62623 6.70711C3.43869 6.51957 3.33333 6.26522 3.33333 6V2.66667C3.33333 2.48986 3.2631 2.32029 3.13807 2.19526C3.01305 2.07024 2.84348 2 2.66667 2C2.48986 2 2.32029 2.07024 2.19526 2.19526C2.07024 2.32029 2 2.48986 2 2.66667V12.54C2.00014 12.5761 2.01208 12.6113 2.034 12.64C2.31959 12.9962 2.68335 13.282 3.09711 13.475C3.51087 13.6681 3.96352 13.7633 4.42 13.7533C4.82797 13.7594 5.23298 13.6833 5.61094 13.5296C5.98889 13.3759 6.33206 13.1477 6.62 12.8587C6.64986 12.8277 6.66658 12.7864 6.66667 12.7433V2.66667C6.66667 2.48986 6.59643 2.32029 6.4714 2.19526C6.34638 2.07024 6.17681 2 6 2V2Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.24,
    d: "M6.42067 14.2526C5.80596 14.5831 5.11858 14.7552 4.42067 14.7533C3.65775 14.7569 2.90841 14.5515 2.254 14.1593C2.22867 14.1441 2.19978 14.1359 2.17025 14.1355C2.14073 14.1351 2.11162 14.1425 2.08589 14.157C2.06016 14.1715 2.03873 14.1926 2.02376 14.218C2.00879 14.2435 2.00083 14.2724 2.00067 14.302V15.6666C2.00067 16.2855 2.2465 16.879 2.68409 17.3165C3.12167 17.7541 3.71517 18 4.334 18C4.95284 18 5.54634 17.7541 5.98392 17.3165C6.42151 16.879 6.66734 16.2855 6.66734 15.6666V14.4C6.66735 14.3711 6.65987 14.3427 6.64561 14.3176C6.63136 14.2925 6.61082 14.2715 6.58602 14.2567C6.56122 14.2419 6.533 14.2338 6.50413 14.2332C6.47526 14.2326 6.44673 14.2395 6.42134 14.2533L6.42067 14.2526Z",
    fill: "none"
  })]
}), 'LibraryIcon', 'Navigation');
/* harmony default export */ var Navigation_LibraryIcon = ((/* unused pure expression or super */ null && (LibraryIcon)));
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Navigation/LockIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */



var LockIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.48,
    d: "M15.625 8.125H15.0625V6.0625C15.0625 3.26656 12.7959 1 10 1C7.20406 1 4.9375 3.26656 4.9375 6.0625V8.125H4.375C3.54657 8.125 2.875 8.79657 2.875 9.625V17.5C2.875 18.3284 3.54657 19 4.375 19H15.625C16.4534 19 17.125 18.3284 17.125 17.5V9.625C17.125 8.79657 16.4534 8.125 15.625 8.125ZM8.5 12.625C8.49626 11.7966 9.16479 11.122 9.99321 11.1182C10.8216 11.1145 11.4962 11.783 11.5 12.6114C11.5024 13.1498 11.2162 13.6481 10.75 13.9173V15.625C10.75 16.0392 10.4142 16.375 9.99999 16.375C9.58578 16.375 9.24999 16.0392 9.24999 15.625V13.9173V13.9172C8.78731 13.6512 8.5015 13.1587 8.5 12.625ZM6.8125 6.0625C6.8125 4.30209 8.23959 2.875 10 2.875C11.7604 2.875 13.1875 4.30209 13.1875 6.0625V7.75C13.1875 7.95711 13.0196 8.125 12.8125 8.125H7.1875C6.98039 8.125 6.8125 7.95711 6.8125 7.75V6.0625Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M8.5 12.625C8.49626 11.7966 9.16479 11.122 9.99321 11.1182C10.8216 11.1145 11.4962 11.783 11.5 12.6114C11.5024 13.1498 11.2162 13.6481 10.75 13.9173V15.625C10.75 16.0392 10.4142 16.375 9.99999 16.375C9.58578 16.375 9.24999 16.0392 9.24999 15.625V13.9173C8.78731 13.6513 8.5015 13.1587 8.5 12.625Z",
    fill: "white"
  })]
}), 'LockIcon', 'Navigation');
/* harmony default export */ var Navigation_LockIcon = ((/* unused pure expression or super */ null && (LockIcon)));
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Navigation/MarketplacesIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */



var MarketplacesIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.24,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9066 6.4184L16.6882 4.1224C16.6597 4.09283 16.6258 3.68052 16.5892 3.16341C16.4979 1.87034 15.5235 1 14.2272 1C10.833 1 8.29122 1 4.88138 1C3.63035 1 2.6021 1.80957 2.56424 3.06002C2.547 3.62963 2.54554 4.0878 2.51218 4.1224L0.271381 6.4424C-0.148355 6.95528 -0.0728462 7.71132 0.440036 8.13106C0.654488 8.30656 0.92307 8.40244 1.20018 8.4024H18.0002C18.6629 8.40204 19.1999 7.86449 19.1995 7.20175C19.1994 6.92491 19.1035 6.65664 18.9282 6.4424C18.9218 6.4344 18.9138 6.4264 18.9066 6.4184Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.48,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4004 9.60229H2.80039C2.57948 9.60229 2.40039 9.78138 2.40039 10.0023V16.8023C2.40039 17.465 2.93765 18.0023 3.60039 18.0023H7.20039C7.42131 18.0023 7.60039 17.8232 7.60039 17.6023V13.6023C7.60039 12.4977 8.49583 11.6023 9.60039 11.6023C10.705 11.6023 11.6004 12.4977 11.6004 13.6023V17.6023C11.6004 17.8232 11.7795 18.0023 12.0004 18.0023H15.6004C16.2631 18.0023 16.8004 17.465 16.8004 16.8023V10.0023C16.8004 9.78139 16.6213 9.60231 16.4004 9.60231V9.60229Z",
    fill: "none"
  })]
}), 'MarketplacesIcon', 'Navigation');
/* harmony default export */ var Navigation_MarketplacesIcon = ((/* unused pure expression or super */ null && (MarketplacesIcon)));
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Navigation/MediaIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */



var MediaIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.14,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4857 4.08571C17.5993 4.08571 17.6914 3.99361 17.6914 3.88V3.26286C17.6914 2.92202 17.4151 2.64571 17.0743 2.64571H6.37715L6.22903 2.58318L5.12476 1.44023C4.85321 1.15888 4.47898 0.999978 4.08796 1H1.67534C0.750265 1.00045 0.000452811 1.75026 2.39123e-07 2.67534V13.1372L1.75254e-07 13.1373C-0.000387859 13.9321 0.643639 14.5768 1.43848 14.5772C1.43903 14.5772 1.43958 14.5772 1.44012 14.5772H1.64584C1.75945 14.5772 1.85155 14.4851 1.85155 14.3715V6.55428C1.85155 5.19093 2.95677 4.08571 4.32013 4.08571H17.4857Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.48,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.7315 5.52563H17.8972C18.6921 5.52654 19.3363 6.17071 19.3372 6.96563V16.8399C19.3363 17.6348 18.6921 18.279 17.8972 18.2799H4.73151C3.9366 18.279 3.29241 17.6348 3.2915 16.8399V6.96564C3.29241 6.17072 3.93659 5.52654 4.7315 5.52563ZM10.2611 15.0658L13.964 12.9026H13.9631C14.1022 12.8222 14.2177 12.7067 14.2981 12.5676C14.5514 12.1293 14.4015 11.5686 13.9631 11.3153L10.2603 9.15197C9.97174 8.98427 9.61645 8.9799 9.32387 9.14046C9.03038 9.30219 8.84745 9.61011 8.84579 9.9452V14.2718C8.84777 14.6075 9.03177 14.9156 9.32634 15.0765C9.61823 15.2372 9.97297 15.2332 10.2611 15.0658Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2611 15.0657L13.964 12.9025C14.1031 12.8221 14.2177 12.7066 14.2981 12.5675C14.5514 12.1292 14.4015 11.5685 13.9631 11.3152L10.2603 9.15188C9.97174 8.98418 9.61645 8.9798 9.32387 9.14036C9.03038 9.30209 8.84745 9.61002 8.84579 9.94511V14.2717C8.84777 14.6074 9.03177 14.9155 9.32634 15.0764C9.61823 15.2371 9.97297 15.2331 10.2611 15.0657Z",
    fill: "white"
  })]
}), 'MediaIcon', 'Navigation');
/* harmony default export */ var Navigation_MediaIcon = ((/* unused pure expression or super */ null && (MediaIcon)));
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Navigation/MobileIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */



var MobileIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.48,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.55563 1H13.4444C14.2998 1 15 1.67455 15 2.50007V5.5H13.4444C11.7284 5.5 10.3333 6.84527 10.3333 8.49992V19H2.55563C1.70023 19 1 18.3248 1 17.5V2.50007C1 1.67455 1.70023 1 2.55563 1ZM6.44437 17.5H8C8.43003 17.5 8.7777 17.1647 8.7777 16.75C8.7777 16.3354 8.43003 16.0001 8 16.0001H6.44437C6.01457 16.0001 5.66667 16.3354 5.66667 16.75C5.66667 17.1647 6.01457 17.5 6.44437 17.5Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.24,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3999 7H17.5999C18.3698 7 19 7.67523 19 8.49986V17.5C19 18.3248 18.3698 19 17.5999 19H13.3999C12.6302 19 12 18.3248 12 17.5V8.49986C12 7.67523 12.6302 7 13.3999 7ZM14.8 16.75C14.8 17.1647 15.1131 17.5 15.4999 17.5C15.8869 17.5 16.2 17.1647 16.2 16.75C16.2 16.3353 15.8869 16.0001 15.4999 16.0001C15.1131 16.0001 14.8 16.3353 14.8 16.75Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M8.00002 17.4999H6.44439C6.01459 17.4999 5.66669 17.1646 5.66669 16.7499C5.66669 16.3353 6.01459 16 6.44439 16H8.00002C8.43005 16 8.77772 16.3353 8.77772 16.7499C8.77772 17.1646 8.43005 17.4999 8.00002 17.4999Z",
    fill: "white"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M15.4999 17.4999C15.1131 17.4999 14.8 17.1646 14.8 16.7499C14.8 16.3352 15.1131 16 15.4999 16C15.8869 16 16.2 16.3352 16.2 16.7499C16.2 17.1646 15.8869 17.4999 15.4999 17.4999Z",
    fill: "white"
  })]
}), 'MobileIcon', 'Navigation');
/* harmony default export */ var Navigation_MobileIcon = ((/* unused pure expression or super */ null && (MobileIcon)));
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Navigation/OpenSourceIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */



var OpenSourceIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.24,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6741 5.65701C20.0807 5.25068 20.0809 4.59167 19.6746 4.18505C19.6744 4.18487 19.6742 4.18469 19.6741 4.18451L16.3407 0.851178C15.9412 0.437263 15.2817 0.425615 14.8678 0.825165C14.4539 1.22471 14.4423 1.88415 14.8418 2.29807C14.8502 2.30675 14.8587 2.31529 14.8674 2.32367L17.1666 4.62617C17.3292 4.78888 17.3292 5.05263 17.1666 5.21534L14.8674 7.51784C14.4679 7.93175 14.4795 8.5912 14.8934 8.99075C15.2972 9.38051 15.9372 9.38033 16.3407 8.99034L19.6741 5.65701Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.24,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.84086 0.851195C8.43477 0.444344 7.77575 0.44373 7.3689 0.849822C7.36844 0.850278 7.36798 0.850736 7.36753 0.851195L4.03419 4.18453C3.62757 4.59085 3.62733 5.24987 4.03366 5.65648C4.03384 5.65666 4.03401 5.65684 4.03419 5.65702L7.36753 8.99035C7.76708 9.40427 8.42652 9.41592 8.84043 9.01637C9.25435 8.61682 9.266 7.95738 8.86645 7.54346C8.85807 7.53478 8.84954 7.52624 8.84086 7.51786L6.53836 5.21536C6.3757 5.05265 6.3757 4.7889 6.53836 4.62619L8.84086 2.32369C9.24748 1.91737 9.24772 1.25835 8.8414 0.851736C8.84122 0.851556 8.84104 0.851376 8.84086 0.851196V0.851195Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.24,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.795 9.68775C10.8695 9.70398 10.9455 9.71208 11.0217 9.71191C11.5094 9.71127 11.9316 9.37282 12.0383 8.89691L13.705 1.39692C13.83 0.834046 13.475 0.276457 12.9121 0.151499C12.3492 0.0265453 11.7916 0.381546 11.6667 0.944415L10 8.44441C9.87613 9.00716 10.2319 9.56378 10.7946 9.68766C10.7948 9.68769 10.7949 9.68772 10.795 9.68775Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.48,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.14081 13.2512C3.62324 13.2514 3.11282 13.3721 2.64998 13.6037L0.135813 14.8629C0.0651914 14.8983 0.0206584 14.9705 0.0208134 15.0495V19.5445H0.0208134C0.0209566 19.6596 0.114347 19.7528 0.229406 19.7526C0.268197 19.7526 0.306204 19.7417 0.339147 19.7212L3.18748 17.9412C3.29311 17.8752 3.42272 17.8599 3.54081 17.8995C12.0841 20.7629 9.18497 20.812 18.6241 16.0362C18.8345 15.928 18.9173 15.6697 18.8091 15.4594C18.7812 15.4051 18.742 15.3574 18.6941 15.3195C18.1421 14.8406 17.3782 14.6888 16.685 14.9204L13.8333 15.867C13.728 15.9021 13.641 15.9777 13.5916 16.077C13.3117 16.6427 12.7353 17.0008 12.1041 17.0012H8.77081C8.54069 17.0012 8.35414 16.8147 8.35414 16.5845C8.35414 16.3544 8.54069 16.1679 8.77081 16.1679H12.1041C12.5644 16.1679 12.9375 15.7948 12.9375 15.3345C12.9375 14.8743 12.5644 14.5012 12.1041 14.5012H9.33331C9.24315 14.5012 9.15543 14.472 9.08331 14.4179C8.14977 13.7129 7.02514 13.3063 5.85664 13.2512H4.14081Z",
    fill: "none"
  })]
}), 'OpenSourceIcon', 'Navigation');
/* harmony default export */ var Navigation_OpenSourceIcon = ((/* unused pure expression or super */ null && (OpenSourceIcon)));
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Navigation/PartnerFinderIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */



var PartnerFinderIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
  width: 20,
  height: 10,
  viewBox: "0 0 20 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.24,
    d: "M10.0274 7.51897L10.4836 7.09926C11.6515 6.03174 11.5785 5.9405 11.3595 5.65765C11.3595 5.64852 11.2866 5.56641 11.1953 5.44779C11.0402 5.46604 10.8851 5.47517 10.73 5.47517C9.5621 5.47517 8.60407 4.89122 8.15699 3.90582C7.73728 2.98428 7.85589 1.9715 8.46721 1.19595C8.47633 1.18683 8.49458 1.16858 8.5037 1.15946C8.37597 1.06821 8.26648 0.986097 8.16611 0.940476C7.60042 0.685001 6.97998 0.666753 6.38692 0.885732L3.65881 2.0445V8.01167H5.0548L6.58765 9.2708C7.07122 9.67226 7.49093 9.86387 7.91976 9.86387C8.48546 9.86387 9.0694 9.52628 9.85407 8.86022C9.67159 8.30365 9.60772 7.87481 10.0092 7.50072L10.0274 7.51897Z",
    fill: "#1C0732"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.48,
    d: "M13.4307 0.283615C12.8559 0.0646363 12.2172 0.0920087 11.6606 0.347484L10.1552 1.04092L10.1095 1.05917C9.89969 1.15041 9.73546 1.2599 9.58035 1.36939C9.5621 1.38763 9.54385 1.39676 9.5256 1.41501C9.38874 1.5245 9.27013 1.63399 9.17889 1.76172C8.73181 2.32742 8.74093 2.99348 8.98728 3.52268C9.334 4.28911 10.0639 4.55371 10.73 4.55371C10.8486 4.55371 10.9581 4.55371 11.0767 4.52633C11.2318 4.50808 11.396 4.46246 11.5603 4.42597C11.8705 4.80918 12.0803 5.06466 12.0895 5.07378C12.8194 6.03181 12.2263 6.71612 11.3687 7.50992C11.2683 7.60116 11.1497 7.71065 11.0311 7.82014C10.7847 8.04824 10.9763 8.26722 11.2866 8.20335C11.5968 8.13949 12.7647 7.90226 12.7647 7.90226L16.3595 7.17233V1.38763L13.4307 0.283615Z",
    fill: "#1C0732"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.48,
    d: "M2.74635 1.84379C2.74635 1.4332 2.41788 1.10474 2.0073 1.10474H0.456204C0.209854 1.10474 0 1.30547 0 1.56094V8.34017C0 8.58652 0.20073 8.79637 0.456204 8.79637H2.0073C2.41788 8.79637 2.74635 8.4679 2.74635 8.05732V1.84379Z",
    fill: "#1C0732"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.24,
    d: "M19.5438 0.457031H17.9927C17.5821 0.457031 17.2537 0.7855 17.2537 1.19609V7.40961C17.2537 7.8202 17.5821 8.14867 17.9927 8.14867H19.5438C19.7902 8.14867 20 7.94794 20 7.69246V0.913237C20 0.666886 19.7993 0.457031 19.5438 0.457031Z",
    fill: "#1C0732"
  })]
}), 'PartnerFinderIcon', 'Navigation');
/* harmony default export */ var Navigation_PartnerFinderIcon = ((/* unused pure expression or super */ null && (PartnerFinderIcon)));
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Navigation/PartnersIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */



var PartnersIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.48,
    d: "M18.9336 6.26719C18.7802 5.85309 18.386 5.57755 17.9444 5.57569H14.3766C14.2179 5.5756 14.0764 5.47557 14.0234 5.32594L12.7371 1.68469C12.5326 1.13897 11.9244 0.862381 11.3786 1.06692C11.0931 1.17393 10.8679 1.39919 10.7609 1.68469L10.7572 1.69894L9.47466 5.32894C9.42155 5.47883 9.27968 5.57892 9.12066 5.57869H5.55366C4.97086 5.57944 4.49902 6.0525 4.49976 6.63529C4.50016 6.94763 4.63891 7.24375 4.87866 7.44394L7.93266 9.97519C8.0517 10.074 8.09786 10.2357 8.04891 10.3824L7.74966 11.2757C7.68822 11.4593 7.77661 11.6594 7.95366 11.7377C8.60379 12.024 9.12072 12.5469 9.39966 13.2002C9.47861 13.3827 9.52774 13.5766 9.54516 13.7747C9.5635 13.981 9.7456 14.1334 9.95189 14.115C10.0152 14.1094 10.076 14.0878 10.1287 14.0522L11.5311 13.1042C11.6622 13.0157 11.8347 13.019 11.9624 13.1124L15.1124 15.4194C15.5814 15.7654 16.2421 15.6655 16.588 15.1965C16.7917 14.9203 16.8483 14.5623 16.7399 14.2367L15.4551 10.3824C15.4062 10.2357 15.4523 10.074 15.5714 9.97519L18.6344 7.43719C18.9687 7.14798 19.088 6.68142 18.9336 6.26719Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
    opacity: 0.24,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      d: "M1.74963 12.063C2.16049 12.071 2.49165 12.4021 2.49963 12.813V18.2505C2.48281 18.6575 2.15667 18.9837 1.74963 19.0005C1.33542 19.0005 0.999634 18.6647 0.999634 18.2505V12.813C0.999634 12.3988 1.33542 12.063 1.74963 12.063Z",
      fill: "none"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      d: "M5.31213 15.1568C5.31213 15.4156 5.522 15.6255 5.78088 15.6255H12.6246C13.0388 15.6255 13.3746 15.9613 13.3746 16.3755V16.5735C13.3738 17.4993 12.6234 18.2497 11.6976 18.2505H3.62463C3.41752 18.2505 3.24963 18.0826 3.24963 17.8755V13.0005C3.24963 12.7934 3.41752 12.6255 3.62463 12.6255H6.82263C7.49375 12.6251 8.1003 13.0253 8.36388 13.6425C8.4039 13.7359 8.42454 13.8364 8.42455 13.9379C8.42459 14.3521 8.08884 14.688 7.67463 14.688H5.78088C5.522 14.688 5.31213 14.8979 5.31213 15.1568Z",
      fill: "none"
    })]
  })]
}), 'PartnersIcon', 'Navigation');
/* harmony default export */ var Navigation_PartnersIcon = ((/* unused pure expression or super */ null && (PartnersIcon)));
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Navigation/PersonasIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */



var PersonasIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.24,
    d: "M13.5 11.625C12.819 11.6251 12.1471 11.7811 11.5358 12.081C11.3497 12.1721 11.2728 12.3967 11.3639 12.5827C11.3692 12.5935 11.375 12.604 11.3813 12.6143C12.0309 13.67 12.3749 14.8854 12.375 16.125C12.375 16.3321 12.5429 16.5 12.75 16.5H17.625C17.8321 16.5 18 16.3321 18 16.125C18 13.6397 15.9853 11.625 13.5 11.625Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.24,
    d: "M15.4468 6.44876C16.5451 7.54712 16.5451 9.32789 15.4468 10.4262C14.3484 11.5246 12.5677 11.5246 11.4693 10.4262C10.3709 9.32789 10.3709 7.54712 11.4693 6.44876C12.5677 5.35041 14.3484 5.35041 15.4468 6.44876Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.48,
    d: "M8.14412 4.04343C9.53536 5.43467 9.53536 7.69032 8.14412 9.08156C6.75288 10.4728 4.49723 10.4728 3.10599 9.08156C1.71475 7.69032 1.71475 5.43467 3.10599 4.04343C4.49723 2.65219 6.75288 2.65219 8.14412 4.04343Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.48,
    d: "M11 16.625C11 13.5184 8.76143 11 6 11C3.23857 11 1 13.5184 1 16.625C1 16.8321 1.14924 17 1.33333 17H10.6667C10.8508 17 11 16.8321 11 16.625Z",
    fill: "none"
  })]
}), 'PersonasIcon', 'Navigation');
/* harmony default export */ var Navigation_PersonasIcon = ((/* unused pure expression or super */ null && (PersonasIcon)));
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Navigation/PressIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */



var PressIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.48,
    d: "M10.1034 12.5501L6.94889 15.7001C6.31621 16.3606 5.31069 16.4954 4.52639 16.0249C3.65814 15.4492 3.42096 14.2787 3.99662 13.4104C4.06351 13.3095 4.13995 13.2153 4.22489 13.1291L7.44989 9.8981C7.67885 8.14918 8.29368 6.47301 9.24989 4.99085C9.30664 4.90673 9.28445 4.79252 9.20033 4.73576C9.17063 4.71573 9.13571 4.70481 9.09989 4.70435H2.17139C1.55007 4.70435 1.04639 5.20803 1.04639 5.82935V17.8294C1.04639 18.4507 1.55007 18.9544 2.17139 18.9544H14.1714C14.7927 18.9544 15.2964 18.4507 15.2964 17.8294V10.9046C15.2951 10.8031 15.2118 10.7219 15.1103 10.7232C15.0745 10.7236 15.0396 10.7346 15.0099 10.7546C13.5275 11.709 11.8517 12.3223 10.1034 12.5501Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.24,
    d: "M18.5649 1.04576C16.9131 1.1063 15.296 1.53635 13.8324 2.30426C13.7613 2.3421 13.7212 2.42017 13.7319 2.50001L13.9749 4.33976C14.0025 4.54501 13.8585 4.73381 13.6533 4.76145C13.5625 4.77367 13.4704 4.75226 13.3944 4.70126L11.9926 3.76001C11.9185 3.70891 11.8184 3.71874 11.7556 3.78326C11.4879 4.05701 10.8069 4.75826 10.7604 4.81301C10.2661 5.43033 9.84666 6.10403 9.51085 6.82001C9.24037 7.39444 9.02151 7.99179 8.85685 8.60501C8.77485 8.90501 8.70585 9.21001 8.64985 9.52001C8.62285 9.67001 8.5981 9.82001 8.57485 9.97001C8.5636 10.0525 8.57485 10.3638 8.52085 10.42L5.0161 13.924C4.72331 14.2169 4.72331 14.6916 5.0161 14.9845C5.31098 15.2724 5.78172 15.2724 6.0766 14.9845L9.5836 11.4775C11.9843 11.2609 14.2375 10.225 15.9646 8.54351C17.8179 6.63293 18.8848 4.09515 18.9534 1.43426C18.9572 1.33008 18.9176 1.22899 18.8439 1.15526C18.7705 1.08101 18.6692 1.04124 18.5649 1.04576V1.04576Z",
    fill: "none"
  })]
}), 'PressIcon', 'Navigation');
/* harmony default export */ var Navigation_PressIcon = ((/* unused pure expression or super */ null && (PressIcon)));
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Navigation/PrivacyIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */



var PrivacyIcon_PrivacyIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.48,
    d: "M8.66665 2H3.306L3.306 2C2.58825 2.00485 2.00871 2.59869 2.008 3.33004L2 7.94306L2 7.94306C1.99984 8.0332 2.03486 8.1197 2.09733 8.18352C2.15986 8.24743 2.24477 8.28336 2.33333 8.28338H8.66665C8.85075 8.28338 8.99998 8.13132 8.99998 7.94374V2.33964C8.99998 2.15206 8.85075 2 8.66665 2V2Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.24,
    d: "M8.66676 10.321H2.42344V10.321C2.33139 10.3213 2.25696 10.3975 2.2572 10.4913C2.25723 10.504 2.25866 10.5166 2.26144 10.5289L2.26144 10.5289C3.03765 13.9849 5.49817 16.7943 8.78009 17.9718C8.8673 18.0018 8.96187 17.9541 8.99132 17.8653C8.99714 17.8477 9.0001 17.8293 9.00009 17.8108V10.6607C9.00009 10.4731 8.85085 10.321 8.66676 10.321L8.66676 10.321Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.48,
    d: "M17.5713 10.321H11.3333C11.1492 10.321 11 10.4731 11 10.6607V17.8299L11 17.8299C10.9999 17.9236 11.0745 17.9997 11.1665 17.9998C11.1847 17.9998 11.2028 17.9968 11.22 17.9908L11.22 17.9908C14.5049 16.8087 16.9643 13.9911 17.7333 10.5289V10.5289C17.7539 10.4375 17.6979 10.3464 17.6082 10.3254C17.5959 10.3225 17.5833 10.321 17.5706 10.321L17.5713 10.321Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.24,
    d: "M17.992 3.33004C17.9913 2.59869 17.4117 2.00486 16.694 2H11.3333C11.1492 2 11 2.15206 11 2.33964V7.94374C11 8.13132 11.1492 8.28338 11.3333 8.28338H17.6666C17.7552 8.28336 17.8401 8.24743 17.9026 8.18353C17.9651 8.11971 18.0001 8.0332 18 7.94306L17.992 3.33004Z",
    fill: "none"
  })]
}), 'PrivacyIcon', 'Navigation');
/* harmony default export */ var Navigation_PrivacyIcon = ((/* unused pure expression or super */ null && (PrivacyIcon_PrivacyIcon)));
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Navigation/PrivacyTermIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */



var PrivacyTermIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.48,
    d: "M9.2 1L2.62388 3.4233C1.94016 3.67432 1.49948 4.23601 1.5 4.85581V6.92238C1.51133 11.3855 4.00226 15.5955 8.25278 18.3355L9.2 18.9686V1Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.24,
    d: "M10.8 18.9999L11.7464 18.3673C16.0076 15.6207 18.5 11.3964 18.5 6.92229V4.85571C18.5005 4.2359 18.0598 3.67421 17.3761 3.4232L10.8 1.00317V18.9999Z",
    fill: "none"
  })]
}), 'PrivacyTermIcon', 'Navigation');
/* harmony default export */ var Navigation_PrivacyTermIcon = ((/* unused pure expression or super */ null && (PrivacyTermIcon)));
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Navigation/ProfileSyncIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */



var ProfileSyncIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M27.261 28.0458C27.261 23.3238 24.0132 19.4935 20.0206 19.4935C16.028 19.4935 12.7802 23.3238 12.7802 28.0458C12.7802 28.3701 12.987 28.6133 13.256 28.6133H26.7646C27.0335 28.6133 27.2404 28.3498 27.2404 28.0458H27.261Z",
    fill: "none",
    fillOpacity: 0.48
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M23.31 10.6979C25.1305 12.4813 25.1305 15.3591 23.31 17.1425C21.4896 18.926 18.552 18.926 16.7316 17.1425C14.9111 15.3591 14.9111 12.4813 16.7316 10.6979C18.552 8.9145 21.4896 8.9145 23.31 10.6979Z",
    fill: "none",
    fillOpacity: 0.48
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M3.1815 17.8315L9.55309 13.9201C10.0289 13.6161 9.96683 12.9271 9.44965 12.7244L7.31889 11.8935C9.98751 7.25256 14.7662 4.27344 20.0207 4.27344C27.2818 4.27344 33.4466 9.76556 34.6878 17.3248C34.8533 18.3179 35.7221 19.0272 36.7358 19.0272C36.8392 19.0272 36.9633 19.0272 37.0668 19.0069C38.1839 18.8245 38.97 17.7909 38.7838 16.6763C37.1909 7.13096 29.3092 0.199951 20.0207 0.199951C13.0492 0.199951 6.73966 4.17211 3.40905 10.3735L1.15417 9.5021C0.636999 9.29944 0.0784506 9.76556 0.22326 10.2925L2.12646 17.4262C2.25058 17.872 2.76776 18.0747 3.16081 17.8315H3.1815Z",
    fill: "none",
    fillOpacity: 0.24
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M37.8738 22.5742C37.7496 22.1283 37.2325 21.9257 36.8394 22.1689L30.4678 26.0802C29.992 26.3842 30.0541 27.0733 30.5712 27.2759L32.702 28.1069C30.0334 32.7478 25.2547 35.7472 20.0002 35.7472C12.7391 35.7472 6.57435 30.2551 5.33313 22.6958C5.14695 21.6014 4.09191 20.8313 2.95413 21.0137C1.83703 21.1961 1.05093 22.2297 1.23711 23.3443C2.80932 32.8897 10.6911 39.8004 19.9795 39.8004C26.951 39.8004 33.2606 35.8282 36.5912 29.6268L38.846 30.4983C39.3632 30.7009 39.9218 30.2348 39.777 29.7079L37.8738 22.5742Z",
    fill: "none",
    fillOpacity: 0.24
  })]
}), 'ProfileSyncIcon', 'Navigation');
/* harmony default export */ var Navigation_ProfileSyncIcon = ((/* unused pure expression or super */ null && (ProfileSyncIcon)));
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Navigation/RecipesIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */



var RecipesIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.24,
    d: "M10.5625 16.3436C10.5623 16.4472 10.6461 16.5313 10.7497 16.5314C10.7842 16.5315 10.818 16.522 10.8475 16.5041C11.8751 15.9263 12.9965 15.5341 14.1603 15.3454C14.2477 15.3272 14.3103 15.2501 14.3103 15.1609V11.8789C14.3107 11.3152 14.7673 10.8582 15.331 10.8574H17.875C18.0018 10.8574 18.2433 10.8536 18.4315 10.8574C18.5346 10.8611 18.6212 10.7805 18.6249 10.6775C18.625 10.6749 18.625 10.6724 18.625 10.6699V2.42506V2.42505C18.625 2.01083 18.2892 1.67505 17.875 1.67505C17.8735 1.67505 17.872 1.67505 17.8705 1.67506H17.8645C13.9548 1.72681 11.7603 2.55331 10.6585 3.17506C10.5993 3.20818 10.5626 3.2707 10.5625 3.33856L10.5625 16.3436Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.48,
    d: "M9.4375 3.33243C9.43755 3.26435 9.40084 3.20154 9.34149 3.16818C8.23975 2.55019 6.0445 1.72368 2.13325 1.67493C1.93139 1.65577 1.73273 1.7354 1.6 1.88868C1.4565 2.03028 1.3755 2.22333 1.375 2.42493V14.2464V14.2465C1.375 14.6566 1.70447 14.9907 2.11457 14.9964C6.15557 15.0481 8.24957 15.9549 9.15257 16.5054C9.24028 16.5597 9.35538 16.5325 9.40964 16.4448C9.42821 16.4148 9.43789 16.3802 9.43757 16.3449L9.4375 3.33243Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.48,
    d: "M15.625 11.9823C15.5214 11.9823 15.4375 12.0662 15.4375 12.1698V14.6703C15.4377 14.7738 15.5218 14.8576 15.6254 14.8574C15.6736 14.8573 15.7199 14.8386 15.7547 14.8053C16.366 14.2195 17.6792 12.9055 18.271 12.2965C18.3431 12.2216 18.3408 12.1024 18.2658 12.0303C18.2311 11.9969 18.1849 11.9781 18.1367 11.9778L15.625 11.9823Z",
    fill: "none"
  })]
}), 'RecipesIcon', 'Navigation');
/* harmony default export */ var Navigation_RecipesIcon = ((/* unused pure expression or super */ null && (RecipesIcon)));
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Navigation/ReleaseNotesIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */



var ReleaseNotesIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.033 4.12984C10.1193 4.19425 10.2066 4.25946 10.2974 4.33515H10.2902C10.4577 4.47359 10.5306 4.69217 10.4796 4.90346C10.4067 5.22404 10.2537 5.62477 10.1007 5.9235C10.006 6.11293 9.80928 6.22951 9.59798 6.22951C9.47798 6.22951 9.36827 6.22265 9.26179 6.21598C9.21311 6.21294 9.16511 6.20994 9.11711 6.20765C9.05154 6.19308 8.98596 6.19308 8.92768 6.19308H8.92767C8.91674 6.20401 8.90582 6.21676 8.89489 6.22951C8.88396 6.24226 8.87303 6.25501 8.8621 6.26594C8.86574 6.30601 8.87121 6.34608 8.87667 6.38616C8.88214 6.42623 8.8876 6.4663 8.89124 6.50637C8.89273 6.5188 8.89419 6.53092 8.89561 6.54276C8.91506 6.70446 8.92817 6.81355 8.93496 6.92896C8.95682 7.14754 8.85481 7.35155 8.66538 7.46812C8.53423 7.54827 8.35937 7.64299 8.19908 7.71585C8.04607 7.78142 7.85663 7.86157 7.71091 7.90528L7.53605 7.93443C7.38305 7.93443 7.23733 7.86885 7.12804 7.75956C7.03332 7.66484 6.95317 7.57741 6.87303 7.48998C6.85927 7.47498 6.84595 7.4604 6.83302 7.44626C6.77059 7.37797 6.71731 7.31969 6.66902 7.2714H6.56702C6.5488 7.2969 6.52877 7.3224 6.50873 7.34791C6.48869 7.37341 6.46866 7.39891 6.45044 7.42441C6.42274 7.46003 6.39611 7.49457 6.36997 7.52848C6.29987 7.61942 6.2333 7.70577 6.159 7.79599C6.04971 7.92714 5.88942 8 5.72184 8L5.58341 7.98543C5.27011 7.90528 4.86938 7.75956 4.57066 7.60656C4.54582 7.59318 4.52223 7.57818 4.5 7.56171V10H16.5L16.4999 7.22888L16.4999 7.22866L16.4999 7.18156C16.4934 6.52371 16.2158 5.91623 15.7799 5.43818L13.2085 2.7521C12.7543 2.27516 12.1382 2.00486 11.4942 2H10.0645C10.1181 2.09705 10.1719 2.20254 10.2173 2.30237C10.2254 2.3221 10.2337 2.34228 10.2421 2.36276C10.302 2.50864 10.3684 2.67004 10.4067 2.79781C10.4723 3.00182 10.4213 3.22769 10.261 3.38069L10.2609 3.38082C10.1589 3.4755 10.057 3.57017 9.96228 3.65756C9.89671 3.72313 9.83113 3.78142 9.77285 3.83242V3.93443C9.81656 3.97086 9.86756 4.00729 9.91857 4.04372C9.95664 4.07283 9.99471 4.10126 10.033 4.12984Z",
    fill: "#C9C3CE"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M9.43861 4.50555C9.33728 4.42127 9.2388 4.34686 9.14369 4.27489C9.05373 4.20685 8.96809 4.14205 8.89869 4.08225C8.90288 3.96929 8.89869 3.85552 8.88651 3.74283C8.95862 3.66883 9.04885 3.58631 9.14342 3.49959C9.22297 3.42668 9.30495 3.3516 9.3891 3.27043C9.43577 3.22538 9.45241 3.15896 9.43266 3.09727C9.39735 2.98688 9.34148 2.84416 9.28696 2.72497C9.23244 2.60579 9.16101 2.47024 9.10053 2.37121C9.07009 2.32129 9.01476 2.29018 8.95618 2.29018C8.95118 2.29018 8.94604 2.29045 8.9409 2.29085C8.82306 2.30154 8.71078 2.31466 8.60228 2.32752C8.477 2.3424 8.35673 2.35647 8.25514 2.36282C8.17789 2.2799 8.09442 2.20225 8.00607 2.13122C8.00621 2.03964 8.01324 1.93263 8.02041 1.82035C8.02813 1.70089 8.03611 1.57752 8.03868 1.44562C8.0399 1.38082 8.00486 1.3221 7.94736 1.29221C7.72644 1.1779 7.41596 1.06223 7.17474 1.0046C7.16189 1.00149 7.14863 1 7.13538 1C7.08492 1 7.03757 1.02219 7.00537 1.06101C6.92108 1.16234 6.84654 1.26096 6.7743 1.3562C6.70625 1.44602 6.64158 1.53152 6.58179 1.60106C6.55365 1.60011 6.52551 1.59957 6.49751 1.59957C6.41241 1.59957 6.32664 1.60417 6.24195 1.61337C6.16917 1.54194 6.08813 1.45333 6.00304 1.36025C5.92904 1.27936 5.8526 1.19575 5.77008 1.11039C5.73842 1.07752 5.69404 1.05871 5.64845 1.05871C5.63087 1.05871 5.61355 1.06142 5.59691 1.06683C5.48652 1.10214 5.34393 1.15801 5.2246 1.21266C5.10528 1.26718 4.96986 1.33861 4.87083 1.39908C4.8155 1.4329 4.78466 1.49405 4.79047 1.55858C4.80103 1.6756 4.81415 1.78693 4.82673 1.89462C4.84161 2.02151 4.85582 2.14191 4.86217 2.24445C4.77884 2.3221 4.70132 2.40557 4.6307 2.49351C4.53884 2.49337 4.43224 2.48647 4.31941 2.47903C4.20022 2.47132 4.07698 2.4632 3.94534 2.46077H3.9421C3.87865 2.46077 3.82115 2.49567 3.79193 2.55208C3.67816 2.77259 3.56262 3.08306 3.50472 3.32495C3.4897 3.38772 3.51108 3.45265 3.56086 3.49405C3.66355 3.57968 3.76284 3.65463 3.85903 3.72727C3.94778 3.79424 4.0322 3.85809 4.10092 3.91721C4.09673 4.03017 4.10092 4.14448 4.11323 4.25798C4.04194 4.33063 3.95319 4.4118 3.86011 4.49689C3.77935 4.57075 3.69574 4.64719 3.61038 4.72971C3.5637 4.77476 3.54706 4.84118 3.56682 4.903C3.60213 5.01339 3.658 5.15598 3.71265 5.2753C3.76717 5.39448 3.8386 5.53003 3.89908 5.62892C3.92952 5.67884 3.98485 5.70996 4.04343 5.70996C4.04843 5.70996 4.05357 5.70969 4.05871 5.70928C4.17574 5.69873 4.28721 5.68561 4.39503 5.67289C4.52153 5.65801 4.64206 5.6438 4.74448 5.63758C4.82145 5.72024 4.9052 5.79803 4.99408 5.86972C4.99408 5.96145 4.98704 6.06859 4.97974 6.18101C4.97189 6.30019 4.96391 6.4233 4.96147 6.55479C4.96026 6.61959 4.9953 6.6783 5.05279 6.70806C5.27304 6.82224 5.58325 6.93764 5.8246 6.9954C5.83745 6.99851 5.85071 7 5.86396 7C5.91429 7 5.96164 6.97781 5.99384 6.93912C6.07785 6.8382 6.15212 6.73999 6.22409 6.64489C6.29228 6.55465 6.35708 6.46902 6.41701 6.39949C6.44488 6.40043 6.47288 6.40097 6.50062 6.40097C6.58612 6.40097 6.67243 6.39624 6.75779 6.3869C6.83112 6.4586 6.91297 6.54802 6.99887 6.64191C7.07233 6.72213 7.14809 6.80492 7.22981 6.88961C7.26146 6.92248 7.30584 6.94129 7.35143 6.94129C7.36901 6.94129 7.38633 6.93858 7.40311 6.93317C7.51336 6.89786 7.65609 6.84199 7.77541 6.78747C7.89473 6.73295 8.03029 6.66153 8.12918 6.60106C8.18452 6.56723 8.21536 6.50622 8.20954 6.44156C8.19886 6.32346 8.1856 6.21104 8.17288 6.10241C8.15814 5.97687 8.14407 5.85755 8.13757 5.75582C8.22118 5.67803 8.29883 5.59429 8.36959 5.50609C8.46036 5.50622 8.56575 5.51312 8.67709 5.52043C8.79776 5.52827 8.92196 5.53639 9.05508 5.53883H9.05805C9.12164 5.53883 9.17927 5.50379 9.20836 5.44724C9.32254 5.22606 9.4378 4.91585 9.4953 4.67519C9.51031 4.61215 9.48853 4.54694 9.43861 4.50555ZM7.95737 4C7.95737 4.80492 7.30475 5.45752 6.49981 5.45752C5.69486 5.45752 5.04224 4.80492 5.04224 4C5.04224 3.19508 5.69486 2.54248 6.49981 2.54248C7.30475 2.54248 7.95737 3.19508 7.95737 4Z",
    fill: "#92889D"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0742 18C15.4208 17.9756 16.5001 16.8282 16.4999 15.4214V11H4.5V15.4214C4.5 16.8455 5.6052 18 6.96855 18H14.0742ZM6.5 13.5C6.5 13.2239 6.72386 13 7 13H13C13.2761 13 13.5 13.2239 13.5 13.5C13.5 13.7761 13.2761 14 13 14H7C6.72386 14 6.5 13.7761 6.5 13.5ZM7 15C6.72386 15 6.5 15.2239 6.5 15.5C6.5 15.7761 6.72386 16 7 16H10C10.2761 16 10.5 15.7761 10.5 15.5C10.5 15.2239 10.2761 15 10 15H7Z",
    fill: "#92889D"
  })]
}), 'ReleaseNotesIcon', 'Navigation');
/* harmony default export */ var Navigation_ReleaseNotesIcon = ((/* unused pure expression or super */ null && (ReleaseNotesIcon)));
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Navigation/ResourcesIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */



var ResourcesIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.24,
    d: "M15.1428 4.42929H7.64481C5 4.42929 4.42935 4.62416 4.42935 7.64475V15.1427C3.03796 15.0742 2.28571 14.2585 2.28571 12.8089V4.62417C2.28571 2.99993 3 2.28566 4.62423 2.28564H12.809C14.2586 2.28564 15.0743 3.03791 15.1428 4.42929Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.48,
    d: "M17 6H7C6.44772 6 6 6.44772 6 7V17C6 17.5523 6.44772 18 7 18H17C17.5523 18 18 17.5523 18 17V7C18 6.44772 17.5523 6 17 6Z",
    fill: "none"
  })]
}), 'ResourcesIcon', 'Navigation');
/* harmony default export */ var Navigation_ResourcesIcon = ((/* unused pure expression or super */ null && (ResourcesIcon)));
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Navigation/RetailIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */



var RetailIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.24,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3328 5.99995C12.9648 5.99995 12.6749 5.69692 12.5841 5.3402C12.2904 4.18667 11.2445 3.33338 9.99981 3.33338C8.75501 3.33338 7.70913 4.18657 7.41537 5.34001C7.3245 5.69682 7.03456 5.99995 6.66636 5.99995C6.29815 5.99995 5.99384 5.69922 6.0545 5.33605C6.37075 3.44259 8.01694 2 9.99961 2C11.9823 2 13.6284 3.44269 13.9445 5.33625C14.0052 5.69931 13.7009 5.99995 13.3328 5.99995Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.48,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9843 16.6848L15.8701 9.04488C15.7268 8.06219 14.8841 7.3335 13.891 7.3335H6.10887C5.11577 7.3335 4.2731 8.06221 4.1298 9.04491L3.01578 16.6848C2.9099 17.4074 3.34827 18 3.99034 18H16.0095C16.6511 18 17.0896 17.4074 16.9843 16.6848Z",
    fill: "none"
  })]
}), 'RetailIcon', 'Navigation');
/* harmony default export */ var Navigation_RetailIcon = ((/* unused pure expression or super */ null && (RetailIcon)));
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Navigation/ReverseEtlIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */



var ReverseEtlIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
  width: 40,
  height: 36,
  viewBox: "0 0 40 36",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.24,
    d: "M35.3264 22.7182C34.7266 22.7194 34.1331 22.847 33.5813 23.0932C33.0295 23.3395 32.5307 23.6994 32.1144 24.1516L27.2024 21.5752C27.2448 21.334 27.2688 21.0897 27.274 20.8445C27.2688 20.5993 27.2448 20.3549 27.2024 20.1137L32.1144 17.5374C32.8371 18.318 33.7967 18.8111 34.8286 18.9321C35.8605 19.0531 36.9005 18.7944 37.7702 18.2005C38.64 17.6065 39.2853 16.7143 39.5956 15.6767C39.9059 14.6391 39.8618 13.5208 39.4709 12.5135C39.08 11.5062 38.3667 10.6727 37.4531 10.1558C36.5396 9.63893 35.4828 9.47089 34.464 9.6805C33.4451 9.89012 32.5276 10.4643 31.8687 11.3047C31.2099 12.1451 30.8507 13.1992 30.8528 14.2865C30.8581 14.5317 30.882 14.776 30.9244 15.0172L26.0124 17.5936C25.3935 16.9213 24.5969 16.458 23.7247 16.2632C22.8525 16.0685 21.9446 16.1511 21.1176 16.5005C20.2906 16.8499 19.5822 17.4502 19.0834 18.2242C18.5845 18.9982 18.318 19.9107 18.318 20.8445C18.318 21.7783 18.5845 22.6908 19.0834 23.4648C19.5822 24.2388 20.2906 24.8391 21.1176 25.1885C21.9446 25.5379 22.8525 25.6205 23.7247 25.4257C24.5969 25.231 25.3935 24.7677 26.0124 24.0954L30.9244 26.6717C30.882 26.9129 30.8581 27.1573 30.8528 27.4025C30.8528 28.3289 31.1152 29.2346 31.6068 30.0049C32.0983 30.7753 32.797 31.3756 33.6145 31.7302C34.4319 32.0847 35.3314 32.1775 36.1992 31.9968C37.067 31.816 37.8641 31.3699 38.4897 30.7148C39.1154 30.0597 39.5414 29.225 39.714 28.3163C39.8867 27.4077 39.7981 26.4658 39.4595 25.6099C39.1209 24.7539 38.5475 24.0224 37.8118 23.5076C37.0761 22.9929 36.2112 22.7182 35.3264 22.7182Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
    opacity: 0.48,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      d: "M12.9496 13.516C19.9911 13.516 25.6993 10.5799 25.6993 6.95799C25.6993 3.33611 19.9911 0.399994 12.9496 0.399994C5.90818 0.399994 0.199951 3.33611 0.199951 6.95799C0.199951 10.5799 5.90818 13.516 12.9496 13.516Z",
      fill: "none"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20.3595 28.6364C18.0946 29.4132 15.4926 29.812 12.9496 29.812C8.25239 29.812 3.3404 28.4513 0.750201 25.8609C0.695591 25.8203 0.63292 25.7989 0.569021 25.7989C0.505123 25.7989 0.442451 25.8203 0.387842 25.8609C0.333297 25.8954 0.287197 25.947 0.254205 26.0103C0.221212 26.0737 0.202496 26.1465 0.199951 26.2215V29.0415C0.199951 32.6648 5.90376 35.5995 12.9496 35.5995C19.9955 35.5995 25.6993 32.6648 25.6993 29.0415V28.4555C25.288 28.6278 24.8616 28.764 24.4244 28.8617C23.0711 29.1639 21.6688 29.0845 20.3595 28.6364Z",
      fill: "none"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.1031 22.3898C14.3865 22.4526 13.6657 22.4842 12.9496 22.4842C8.25239 22.4842 3.3404 21.1234 0.750201 18.533C0.695591 18.4925 0.63292 18.471 0.569021 18.471C0.505123 18.471 0.442451 18.4925 0.387842 18.533C0.333297 18.5676 0.287197 18.6192 0.254205 18.6825C0.221212 18.7458 0.202496 18.8187 0.199951 18.8937V21.7136C0.199951 25.3369 5.90376 28.2716 12.9496 28.2716C14.9058 28.2716 16.7584 28.0454 18.4143 27.6411C17.5855 27.0558 16.867 26.3066 16.3021 25.4301C15.7075 24.5075 15.3015 23.4725 15.1031 22.3898Z",
      fill: "none"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.9496 15.1547C14.5088 15.1547 16.0902 15.0048 17.6024 14.7061C17.1109 15.1618 16.6734 15.6828 16.3021 16.2587C15.4349 17.6043 14.9689 19.189 14.9628 20.8118C14.3071 20.8652 13.6347 20.893 12.9496 20.893C5.90376 20.893 0.199951 17.9583 0.199951 14.335V11.4659C0.214371 11.4084 0.238565 11.3554 0.270945 11.3102C0.303325 11.265 0.343161 11.2286 0.387842 11.2035C0.442451 11.163 0.505123 11.1416 0.569021 11.1416C0.63292 11.1416 0.695591 11.163 0.750201 11.2035C3.3404 13.7939 8.25239 15.1547 12.9496 15.1547Z",
      fill: "none"
    })]
  })]
}), 'ReverseEtlIcon', 'Navigation');
/* harmony default export */ var Navigation_ReverseEtlIcon = ((/* unused pure expression or super */ null && (ReverseEtlIcon)));
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Navigation/SdksIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */



var SdksIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.24,
    d: "M12.9798 7.2032C13.074 7.16027 13.1156 7.04907 13.0726 6.95484C13.0539 6.91369 13.0209 6.8807 12.9798 6.86195L5.66198 3.52595C5.56505 3.48289 5.45442 3.48289 5.35748 3.52595L2.49473 4.76795C2.39947 4.80854 2.35514 4.91867 2.39572 5.01394C2.4147 5.05849 2.45018 5.09397 2.49473 5.11295L10.2122 8.32895C10.3085 8.36926 10.4172 8.36763 10.5122 8.32445L12.9798 7.2032Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.24,
    d: "M17.5465 5.12512C17.6409 5.08264 17.6831 4.97164 17.6406 4.8772C17.6218 4.83539 17.5883 4.80192 17.5465 4.78312L10.3 1.63537C10.1087 1.55188 9.89129 1.55188 9.7 1.63537L7.285 2.68537C7.19035 2.72738 7.14768 2.83816 7.18969 2.93281C7.20855 2.97529 7.24252 3.00926 7.285 3.02812L14.56 6.34462C14.6586 6.38948 14.7719 6.38948 14.8705 6.34462L17.5465 5.12512Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.48,
    d: "M1.6345 5.97243C1.53889 5.93267 1.42914 5.97794 1.38938 6.07356C1.37987 6.09641 1.37498 6.12093 1.375 6.14568V14.5051V14.5052C1.375 14.8079 1.55695 15.0809 1.83631 15.1974L9.54998 18.4126C9.6456 18.4524 9.75534 18.4071 9.79511 18.3115C9.80461 18.2887 9.8095 18.2641 9.80948 18.2394V9.50493V9.50494C9.80933 9.42921 9.76382 9.36095 9.69398 9.33169L1.6345 5.97243Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.48,
    d: "M10.9375 18.2079C10.938 18.3119 11.0228 18.3957 11.1267 18.3952C11.1528 18.395 11.1785 18.3895 11.2022 18.3789L18.1855 15.2049C18.4531 15.0832 18.6249 14.8164 18.625 14.5224V6.16446V6.16445C18.6251 6.0609 18.5412 5.97689 18.4376 5.97681C18.411 5.97679 18.3846 5.98247 18.3602 5.99346L11.05 9.31746C10.9828 9.34742 10.9396 9.41416 10.9397 9.48771L10.9375 18.2079Z",
    fill: "none"
  })]
}), 'SdksIcon', 'Navigation');
/* harmony default export */ var Navigation_SdksIcon = ((/* unused pure expression or super */ null && (SdksIcon)));
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Navigation/SourcesIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */



var SourcesIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.48,
    d: "M1.86627 6.55L9.10302 9.7C9.67531 9.94799 10.3247 9.94799 10.897 9.7L18.1337 6.55C18.7035 6.30216 18.9645 5.63938 18.7166 5.06963C18.6031 4.80859 18.3948 4.6003 18.1337 4.48675L10.9 1.339C10.3277 1.0911 9.67833 1.0911 9.10602 1.339L1.86777 4.4845C1.29781 4.73186 1.0363 5.39443 1.28365 5.96439C1.39724 6.22612 1.60604 6.43491 1.86777 6.5485L1.86627 6.55Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.24,
    d: "M18.133 8.98604L17.2 8.57954C17.0086 8.4966 16.7914 8.4966 16.6 8.57954L9.99998 11.4498L3.39998 8.57954C3.20858 8.4966 2.99138 8.4966 2.79998 8.57954L1.86698 8.98529C1.29702 9.23265 1.0355 9.89522 1.28286 10.4652C1.39645 10.7269 1.60524 10.9357 1.86698 11.0493L9.09998 14.1948C9.67227 14.4428 10.3217 14.4428 10.894 14.1948L18.1307 11.05C18.7007 10.8027 18.9622 10.1401 18.7149 9.57015C18.6013 9.30842 18.3925 9.09963 18.1307 8.98604H18.133Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.24,
    d: "M18.133 13.45L17.2 13.0457C17.0087 12.9623 16.7913 12.9623 16.6 13.0457L9.99998 15.916L3.39998 13.0457C3.20869 12.9623 2.99127 12.9623 2.79998 13.0457L1.86698 13.4507C1.29702 13.6981 1.0355 14.3607 1.28286 14.9306C1.39645 15.1924 1.60524 15.4011 1.86698 15.5147L9.09998 18.661C9.67227 18.909 10.3217 18.909 10.894 18.661L18.1277 15.5162C18.6979 15.2694 18.96 14.607 18.7131 14.0368C18.5995 13.7744 18.3902 13.5651 18.1277 13.4515L18.133 13.45Z",
    fill: "none"
  })]
}), 'SourcesIcon', 'Navigation');
/* harmony default export */ var Navigation_SourcesIcon = ((/* unused pure expression or super */ null && (SourcesIcon)));
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Navigation/SpecIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */



var SpecIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.48,
    d: "M17.875 1H2.125C1.50368 1 1 1.50368 1 2.125V12.4375C1 12.5411 1.08395 12.625 1.1875 12.625H18.8125C18.9161 12.625 19 12.5411 19 12.4375V2.125C19 1.50368 18.4963 1 17.875 1V1ZM4.5745 4.375H5.863C6.17366 4.375 6.4255 4.62684 6.4255 4.9375C6.4255 5.24816 6.17366 5.5 5.863 5.5H4.5745C4.26384 5.5 4.012 5.24816 4.012 4.9375C4.012 4.62684 4.26384 4.375 4.5745 4.375ZM8.512 9.625H4.5745C4.26384 9.625 4.012 9.37316 4.012 9.0625C4.012 8.75184 4.26384 8.5 4.5745 8.5H8.512C8.82266 8.5 9.0745 8.75184 9.0745 9.0625C9.0745 9.37316 8.82266 9.625 8.512 9.625ZM8.737 6.25C8.01302 6.28597 7.39696 5.72822 7.361 5.00424C7.32503 4.28025 7.88278 3.66419 8.60676 3.62823C9.33065 3.59227 9.94666 4.14987 9.98276 4.87375C10.0189 5.59643 9.46334 6.21204 8.74076 6.25H8.737ZM11.386 10.375C10.662 10.4114 10.0457 9.85398 10.0093 9.13002C9.97291 8.40606 10.5303 7.78968 11.2543 7.75331C11.9782 7.71693 12.5946 8.27432 12.631 8.99829C12.631 8.99844 12.631 8.9986 12.631 8.99875C12.6672 9.72115 12.112 10.3366 11.3898 10.375H11.386ZM15.4218 9.625H14.137C13.8263 9.625 13.5745 9.37316 13.5745 9.0625C13.5745 8.75184 13.8263 8.5 14.137 8.5H15.4255C15.7362 8.5 15.988 8.75184 15.988 9.0625C15.988 9.37316 15.7362 9.625 15.4255 9.625H15.4218ZM15.4218 5.5H11.4843C11.1736 5.5 10.9218 5.24816 10.9218 4.9375C10.9218 4.62684 11.1736 4.375 11.4843 4.375H15.4218C15.7324 4.375 15.9843 4.62684 15.9843 4.9375C15.9843 5.24816 15.7324 5.5 15.4218 5.5Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.24,
    d: "M18.8125 13.75H1.1875C1.08395 13.75 1 13.8339 1 13.9375V14.875C1 15.4963 1.50368 16 2.125 16H8.35L6.66325 18.4105C6.54478 18.5804 6.58646 18.8141 6.75634 18.9326C6.81903 18.9763 6.89358 18.9998 6.97 19H13.03C13.2371 18.9998 13.4049 18.8318 13.4047 18.6247C13.4046 18.5478 13.3809 18.4727 13.3367 18.4097L11.65 16H17.875C18.4963 16 19 15.4963 19 14.875V13.9375C19 13.8339 18.9161 13.75 18.8125 13.75Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M4.57452 4.37488H5.86302C6.17368 4.37488 6.42552 4.62672 6.42552 4.93738C6.42552 5.24804 6.17368 5.49988 5.86302 5.49988H4.57452C4.26386 5.49988 4.01202 5.24804 4.01202 4.93738C4.01202 4.62672 4.26386 4.37488 4.57452 4.37488ZM8.51202 9.62488H4.57452C4.26386 9.62488 4.01202 9.37304 4.01202 9.06238C4.01202 8.75172 4.26386 8.49988 4.57452 8.49988H8.51202C8.82268 8.49988 9.07452 8.75172 9.07452 9.06238C9.07452 9.37304 8.82268 9.62488 8.51202 9.62488ZM8.73702 6.24988C8.01304 6.28585 7.39698 5.7281 7.36102 5.00412C7.32505 4.28013 7.8828 3.66407 8.60678 3.62811C9.33067 3.59215 9.94668 4.14975 9.98278 4.87363C10.0189 5.59631 9.46336 6.21192 8.74078 6.24988H8.73702ZM11.386 10.3749C10.6621 10.4113 10.0457 9.85386 10.0093 9.1299C9.97293 8.40594 10.5303 7.78956 11.2543 7.75319C11.9782 7.71681 12.5946 8.2742 12.631 8.99817C12.6672 9.72057 12.112 10.3365 11.3898 10.3749H11.386ZM14.137 9.62488C13.8263 9.62488 13.5745 9.37304 13.5745 9.06238C13.5745 8.75172 13.8263 8.49988 14.137 8.49988H15.4255C15.7362 8.49988 15.988 8.75172 15.988 9.06238C15.988 9.37304 15.7362 9.62488 15.4255 9.62488H14.137ZM15.4218 5.49988H11.4843C11.1736 5.49988 10.9218 5.24804 10.9218 4.93738C10.9218 4.62672 11.1736 4.37488 11.4843 4.37488H15.4218C15.7324 4.37488 15.9843 4.62672 15.9843 4.93738C15.9843 5.24804 15.7324 5.49988 15.4218 5.49988Z",
    fill: "white"
  })]
}), 'SpecIcon', 'Navigation');
/* harmony default export */ var Navigation_SpecIcon = ((/* unused pure expression or super */ null && (SpecIcon)));
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Navigation/StartupIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */



var StartupIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
    opacity: 0.24,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      d: "M15.4329 10.7971L14.5493 16.1825C14.5233 16.3414 14.5753 16.5031 14.6891 16.6169L16.718 18.6463C16.9132 18.8416 17.2265 18.8397 17.4001 18.6249C17.9508 17.9437 19.0001 16.3967 19.0001 14.4999C19.0001 12.8908 16.3232 11.2863 15.4329 10.7971Z",
      fill: "none"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      d: "M2.60001 18.6252C2.77361 18.8399 3.08686 18.8419 3.28213 18.6466L5.33261 16.5961C5.44692 16.4818 5.49891 16.3193 5.47217 16.1599L4.68877 11.4894C4.63184 11.15 4.25813 10.9685 3.96465 11.1482C2.82697 11.8448 1 13.1709 1 14.5002C1 16.397 2.0494 17.944 2.60001 18.6252Z",
      fill: "none"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      d: "M7.92292 17.2942C8.01565 17.1551 8.17177 17.0715 8.33894 17.0715H11.6609C11.8281 17.0715 11.9842 17.1551 12.0769 17.2942L12.696 18.2228C12.9175 18.555 12.6793 19.0001 12.28 19.0001H7.71989C7.32055 19.0001 7.08235 18.5551 7.30387 18.2228L7.92292 17.2942Z",
      fill: "none"
    })]
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.48,
    d: "M9.99995 1C7.5 1 4.05995 3.88257 4.98373 9.37065L6.03019 15.5944C6.11116 16.076 6.52805 16.4286 7.01635 16.4286H13.0079C13.4977 16.4286 13.9153 16.0739 13.9947 15.5907L15.0162 9.37065C15.94 3.88193 12.4999 1 9.99995 1Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10C11.1046 10 12 9.10457 12 8C12 6.89543 11.1046 6 10 6C8.89543 6 8 6.89543 8 8C8 9.10457 8.89543 10 10 10Z",
    fill: "white"
  })]
}), 'StartupIcon', 'Navigation');
/* harmony default export */ var Navigation_StartupIcon = ((/* unused pure expression or super */ null && (StartupIcon)));
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Navigation/SupportIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */



var SupportIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.24,
    d: "M15.143 6.487a.806.806 0 00.557.527.788.788 0 00.87-.291.806.806 0 00.124-.716 6.981 6.981 0 00-13.393 0 .772.772 0 00.129.699.806.806 0 00.643.33.806.806 0 00.784-.544 5.344 5.344 0 0110.252 0l.034-.005z"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.48,
    d: "M4.026 8.253h-.052a1.68 1.68 0 00-1.633 1.285h-.805a.536.536 0 00-.536.536v4.072a.536.536 0 00.536.535h.805a1.68 1.68 0 001.633 1.286h.052a1.687 1.687 0 001.688-1.693V9.941a1.684 1.684 0 00-1.688-1.688zM18.464 9.538h-.805a1.68 1.68 0 00-1.633-1.285h-.052a1.685 1.685 0 00-1.688 1.688v4.333a1.688 1.688 0 001.037 1.56 1.595 1.595 0 01-1.539 1.2h-2.901a1.5 1.5 0 100 1.286h2.901a2.888 2.888 0 002.85-2.473 1.68 1.68 0 001.025-1.166h.805a.536.536 0 00.536-.535v-4.072a.536.536 0 00-.536-.536z"
  })]
}), 'SupportIcon', 'Navigation');
/* harmony default export */ var Navigation_SupportIcon = ((/* unused pure expression or super */ null && (SupportIcon)));
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Navigation/ToolBoxIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */



var ToolBoxIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.24,
    d: "M8.03125 9.43802C8.03125 9.12736 8.28309 8.87552 8.59375 8.87552H11.4062C11.7169 8.87552 11.9688 9.12736 11.9688 9.43802V9.62552C11.9688 9.83262 12.1366 10.0005 12.3438 10.0005H18.25C18.4571 10.0005 18.625 9.83262 18.625 9.62552V6.81302C18.625 6.3988 18.2892 6.06302 17.875 6.06302H13.7313C13.5244 4.0023 11.6862 2.49945 9.62547 2.70629C7.85063 2.88445 6.4469 4.28816 6.26875 6.06302H2.125C1.71079 6.06302 1.375 6.3988 1.375 6.81302V9.62552C1.375 9.83262 1.54289 10.0005 1.75 10.0005H7.65625C7.86336 10.0005 8.03125 9.83262 8.03125 9.62552V9.43802ZM10 4.18802C11.0979 4.18803 12.0355 4.98045 12.2185 6.06302H7.7815C7.96449 4.98045 8.90208 4.18803 10 4.18802Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("g", {
    opacity: 0.48,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      d: "M9.53125 10.0012H10.4688C10.6759 10.0012 10.8438 10.1691 10.8438 10.3762V11.7825C10.8438 12.2485 10.466 12.6262 10 12.6262C9.53401 12.6262 9.15625 12.2485 9.15625 11.7825V10.3762C9.15625 10.1691 9.32414 10.0012 9.53125 10.0012Z",
      fill: "none"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
      d: "M9.99475 13.752C11.0837 13.7533 11.9675 12.8715 11.9688 11.7826V11.5006C11.9687 11.4888 11.9692 11.477 11.9703 11.4653C11.9889 11.2591 12.1712 11.107 12.3775 11.1256H18.25C18.4571 11.1256 18.625 11.2935 18.625 11.5006V16.5631C18.625 16.9773 18.2892 17.3131 17.875 17.3131H2.125C1.71079 17.3131 1.375 16.9773 1.375 16.5631V11.5014C1.375 11.2942 1.54289 11.1264 1.75 11.1264H7.65704C7.86414 11.1264 8.03204 11.2942 8.03204 11.5014V11.7046C8.01592 12.6623 8.67308 13.5004 9.60704 13.7131C9.73467 13.7389 9.86454 13.7519 9.99475 13.752Z",
      fill: "none"
    })]
  })]
}), 'ToolBoxIcon', 'Navigation');
/* harmony default export */ var Navigation_ToolBoxIcon = ((/* unused pure expression or super */ null && (ToolBoxIcon)));
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Navigation/TwilioIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */


var TwilioIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.48,
    d: "M10 2.00001C8.94906 1.99869 7.90818 2.20472 6.93698 2.60629C5.96578 3.00786 5.08335 3.59709 4.34022 4.34022C3.59709 5.08335 3.00786 5.96578 2.60629 6.93698C2.20472 7.90818 1.99869 8.94906 2.00001 10C2.00001 14.427 5.57301 18 10 18C14.427 18 18 14.427 18 10C18 5.57301 14.427 2.00001 10 2.00001ZM10 15.867C9.22891 15.8693 8.46498 15.719 7.75215 15.425C7.03932 15.1309 6.39166 14.6989 5.84641 14.1536C5.30116 13.6084 4.86908 12.9607 4.57503 12.2479C4.28098 11.535 4.13076 10.7711 4.13301 10C4.13076 9.22891 4.28098 8.46498 4.57503 7.75215C4.86908 7.03932 5.30116 6.39166 5.84641 5.84641C6.39166 5.30116 7.03932 4.86908 7.75215 4.57503C8.46498 4.28098 9.22891 4.13076 10 4.13301C10.7711 4.13076 11.535 4.28098 12.2479 4.57503C12.9607 4.86908 13.6084 5.30116 14.1536 5.84641C14.6989 6.39166 15.1309 7.03932 15.425 7.75215C15.719 8.46498 15.8693 9.22891 15.867 10C15.8693 10.7711 15.719 11.535 15.425 12.2479C15.1309 12.9607 14.6989 13.6084 14.1536 14.1536C13.6084 14.6989 12.9607 15.1309 12.2479 15.425C11.535 15.719 10.7711 15.8693 10 15.867ZM13.627 8.02701C13.627 8.93301 12.88 9.68001 11.973 9.68001C11.5353 9.67764 11.1163 9.50273 10.8068 9.19324C10.4973 8.88376 10.3224 8.46468 10.32 8.02701C10.32 7.12001 11.067 6.37301 11.973 6.37301C12.88 6.37301 13.627 7.12001 13.627 8.02701ZM13.627 11.973C13.627 12.88 12.88 13.627 11.973 13.627C11.5352 13.6246 11.1159 13.4496 10.8064 13.1399C10.4969 12.8302 10.3221 12.4109 10.32 11.973C10.32 11.067 11.067 10.32 11.973 10.32C12.88 10.32 13.627 11.067 13.627 11.973ZM9.68001 11.973C9.68001 12.88 8.93301 13.627 8.02701 13.627C7.58899 13.6249 7.16951 13.45 6.85978 13.1402C6.55005 12.8305 6.37511 12.411 6.37301 11.973C6.37301 11.067 7.12001 10.32 8.02701 10.32C8.93301 10.32 9.68001 11.067 9.68001 11.973ZM9.68001 8.02701C9.68001 8.93301 8.93301 9.68001 8.02701 9.68001C7.58916 9.6779 7.16983 9.50311 6.86013 9.19359C6.55042 8.88408 6.37537 8.46485 6.37301 8.02701C6.37301 7.12001 7.12001 6.37301 8.02701 6.37301C8.93301 6.37301 9.68001 7.12001 9.68001 8.02701Z",
    fill: "none"
  })
}), 'TwilioIcon', 'Navigation');
/* harmony default export */ var Navigation_TwilioIcon = ((/* unused pure expression or super */ null && (TwilioIcon)));
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/Navigation/WarehousesIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */



var WarehousesIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.48,
    d: "M5.9188 2H2.78376C2.36575 2 2 2.37333 2 2.8V17.2C2 17.6267 2.36575 18 2.78376 18H5.9188C6.3368 18 6.70256 17.6267 6.70256 17.2V2.8C6.70256 2.37333 6.3368 2 5.9188 2ZM4.35128 15.8667C3.93327 15.8667 3.56752 15.4933 3.56752 15.0667C3.56752 14.64 3.93327 14.2667 4.35128 14.2667C4.76928 14.2667 5.13504 14.64 5.13504 15.0667C5.13504 15.4933 4.76928 15.8667 4.35128 15.8667ZM4.87379 8.32793H3.82877C3.67202 8.32793 3.56752 8.15495 3.56752 7.8955C3.56752 7.63604 3.67202 7.46306 3.82877 7.46306H4.87379C5.03054 7.46306 5.13504 7.63604 5.13504 7.8955C5.13504 8.15495 5.03054 8.32793 4.87379 8.32793ZM4.87379 6.3964H3.82877C3.67202 6.3964 3.56752 6.22342 3.56752 5.96396C3.56752 5.7045 3.67202 5.53153 3.82877 5.53153H4.87379C5.03054 5.53153 5.13504 5.7045 5.13504 5.96396C5.13504 6.22342 5.03054 6.3964 4.87379 6.3964ZM4.87379 4.46486H3.82877C3.67202 4.46486 3.56752 4.29189 3.56752 4.03243C3.56752 3.77297 3.67202 3.6 3.82877 3.6H4.87379C5.03054 3.6 5.13504 3.77297 5.13504 4.03243C5.13504 4.29189 5.03054 4.46486 4.87379 4.46486ZM17.2162 2H14.0812C13.6632 2 13.2974 2.37333 13.2974 2.8V17.2C13.2974 17.6267 13.6632 18 14.0812 18H17.2162C17.6342 18 18 17.6267 18 17.2V2.8C18 2.37333 17.6342 2 17.2162 2ZM15.6487 15.8667C15.2307 15.8667 14.865 15.4933 14.865 15.0667C14.865 14.64 15.2307 14.2667 15.6487 14.2667C16.0667 14.2667 16.4325 14.64 16.4325 15.0667C16.4325 15.4933 16.0667 15.8667 15.6487 15.8667ZM16.1712 8.32793H15.1262C14.9695 8.32793 14.865 8.15495 14.865 7.8955C14.865 7.63604 14.9695 7.46306 15.1262 7.46306H16.1712C16.328 7.46306 16.4325 7.63604 16.4325 7.8955C16.4325 8.15495 16.328 8.32793 16.1712 8.32793ZM16.1712 6.3964H15.1262C14.9695 6.3964 14.865 6.22342 14.865 5.96396C14.865 5.7045 14.9695 5.53153 15.1262 5.53153H16.1712C16.328 5.53153 16.4325 5.7045 16.4325 5.96396C16.4325 6.22342 16.328 6.3964 16.1712 6.3964ZM16.1712 4.46486H15.1262C14.9695 4.46486 14.865 4.29189 14.865 4.03243C14.865 3.77297 14.9695 3.6 15.1262 3.6H16.1712C16.328 3.6 16.4325 3.77297 16.4325 4.03243C16.4325 4.29189 16.328 4.46486 16.1712 4.46486Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    opacity: 0.24,
    d: "M11.5675 2H8.43247C8.01447 2 7.64871 2.37333 7.64871 2.8V17.2C7.64871 17.6267 8.01447 18 8.43247 18H11.5675C11.9855 18 12.3513 17.6267 12.3513 17.2V2.8C12.3513 2.37333 11.9855 2 11.5675 2ZM10.1412 15.8667C9.72321 15.8667 9.35745 15.4933 9.35745 15.0667C9.35745 14.64 9.72321 14.2667 10.1412 14.2667C10.5592 14.2667 10.925 14.64 10.925 15.0667C10.925 15.4933 10.5592 15.8667 10.1412 15.8667ZM10.5225 8.32793H9.47748C9.32073 8.32793 9.21623 8.15495 9.21623 7.8955C9.21623 7.63604 9.32073 7.46306 9.47748 7.46306H10.5225C10.6793 7.46306 10.7838 7.63604 10.7838 7.8955C10.7838 8.15495 10.6793 8.32793 10.5225 8.32793ZM10.5225 6.3964H9.47748C9.32073 6.3964 9.21623 6.22342 9.21623 5.96396C9.21623 5.7045 9.32073 5.53153 9.47748 5.53153H10.5225C10.6793 5.53153 10.7838 5.7045 10.7838 5.96396C10.7838 6.22342 10.6793 6.3964 10.5225 6.3964ZM10.5225 4.46486H9.47748C9.32073 4.46486 9.21623 4.29189 9.21623 4.03243C9.21623 3.77297 9.32073 3.6 9.47748 3.6H10.5225C10.6793 3.6 10.7838 3.77297 10.7838 4.03243C10.7838 4.29189 10.6793 4.46486 10.5225 4.46486Z",
    fill: "none"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M3.56752 15.0668C3.56752 15.4934 3.93327 15.8668 4.35128 15.8668C4.76929 15.8668 5.13504 15.4934 5.13504 15.0668C5.13504 14.6401 4.76929 14.2668 4.35128 14.2668C3.93327 14.2668 3.56752 14.6401 3.56752 15.0668Z",
    fill: "white"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M3.82877 8.32803H4.87379C5.03054 8.32803 5.13504 8.15505 5.13504 7.89559C5.13504 7.63613 5.03054 7.46316 4.87379 7.46316H3.82877C3.67202 7.46316 3.56752 7.63613 3.56752 7.89559C3.56752 8.15505 3.67202 8.32803 3.82877 8.32803Z",
    fill: "white"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M3.82877 6.39649H4.87379C5.03054 6.39649 5.13504 6.22352 5.13504 5.96406C5.13504 5.7046 5.03054 5.53163 4.87379 5.53163H3.82877C3.67202 5.53163 3.56752 5.7046 3.56752 5.96406C3.56752 6.22352 3.67202 6.39649 3.82877 6.39649Z",
    fill: "white"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M3.82877 4.46496H4.87379C5.03054 4.46496 5.13504 4.29199 5.13504 4.03253C5.13504 3.77307 5.03054 3.6001 4.87379 3.6001H3.82877C3.67202 3.6001 3.56752 3.77307 3.56752 4.03253C3.56752 4.29199 3.67202 4.46496 3.82877 4.46496Z",
    fill: "white"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M14.865 15.0668C14.865 15.4934 15.2307 15.8668 15.6487 15.8668C16.0667 15.8668 16.4325 15.4934 16.4325 15.0668C16.4325 14.6401 16.0667 14.2668 15.6487 14.2668C15.2307 14.2668 14.865 14.6401 14.865 15.0668Z",
    fill: "white"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M15.1262 8.32803H16.1712C16.328 8.32803 16.4325 8.15505 16.4325 7.89559C16.4325 7.63613 16.328 7.46316 16.1712 7.46316H15.1262C14.9695 7.46316 14.865 7.63613 14.865 7.89559C14.865 8.15505 14.9695 8.32803 15.1262 8.32803Z",
    fill: "white"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M15.1262 6.39649H16.1712C16.328 6.39649 16.4325 6.22352 16.4325 5.96406C16.4325 5.7046 16.328 5.53163 16.1712 5.53163H15.1262C14.9695 5.53163 14.865 5.7046 14.865 5.96406C14.865 6.22352 14.9695 6.39649 15.1262 6.39649Z",
    fill: "white"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M15.1262 4.46496H16.1712C16.328 4.46496 16.4325 4.29199 16.4325 4.03253C16.4325 3.77307 16.328 3.6001 16.1712 3.6001H15.1262C14.9695 3.6001 14.865 3.77307 14.865 4.03253C14.865 4.29199 14.9695 4.46496 15.1262 4.46496Z",
    fill: "white"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M9.35745 15.0668C9.35745 15.4934 9.72321 15.8668 10.1412 15.8668C10.5592 15.8668 10.925 15.4934 10.925 15.0668C10.925 14.6401 10.5592 14.2668 10.1412 14.2668C9.72321 14.2668 9.35745 14.6401 9.35745 15.0668Z",
    fill: "white"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M9.47749 8.32803H10.5225C10.6793 8.32803 10.7838 8.15505 10.7838 7.89559C10.7838 7.63613 10.6793 7.46316 10.5225 7.46316H9.47749C9.32073 7.46316 9.21623 7.63613 9.21623 7.89559C9.21623 8.15505 9.32073 8.32803 9.47749 8.32803Z",
    fill: "white"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M9.47749 6.39649H10.5225C10.6793 6.39649 10.7838 6.22352 10.7838 5.96406C10.7838 5.7046 10.6793 5.53163 10.5225 5.53163H9.47749C9.32073 5.53163 9.21623 5.7046 9.21623 5.96406C9.21623 6.22352 9.32073 6.39649 9.47749 6.39649Z",
    fill: "white"
  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M9.47749 4.46496H10.5225C10.6793 4.46496 10.7838 4.29199 10.7838 4.03253C10.7838 3.77307 10.6793 3.6001 10.5225 3.6001H9.47749C9.32073 3.6001 9.21623 3.77307 9.21623 4.03253C9.21623 4.29199 9.32073 4.46496 9.47749 4.46496Z",
    fill: "white"
  })]
}), 'WarehousesIcon', 'Navigation');
/* harmony default export */ var Navigation_WarehousesIcon = ((/* unused pure expression or super */ null && (WarehousesIcon)));
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/Navigation.ts
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */















































// EXTERNAL MODULE: ../../libs/matcha/components/Divider/index.ts + 1 modules
var Divider = __webpack_require__(76305);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../libs/matcha/components/Paper/index.ts + 2 modules
var Paper = __webpack_require__(16164);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/Dropdown/Dropdown.tsx


function Dropdown_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}




var Dropdown = function Dropdown(_ref) {
  var children = _ref.children;
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    elevation: 4,
    borderRadius: 4,
    background: theme.palette.neutrals.white[100],
    children: children
  });
};

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Paper/* default */.Z,  true ? {
  target: "e6mri240"
} : 0)( true ? {
  name: "1xsxug3",
  styles: "display:grid;grid-template-columns:320px 390px;max-width:710px;width:100%;overflow:hidden"
} : 0);

/* harmony default export */ var Dropdown_Dropdown = (Dropdown);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/Dropdown/Content/Content.views.ts

var Content = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1yl7nqm0"
} : 0)("padding:32px;background:", function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor;
}, ";" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/Dropdown/Content/Content.tsx


function Content_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Content_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Content_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Content_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var ContentBase = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      tokens = _ref.tokens;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Content, Content_objectSpread(Content_objectSpread({
    ref: ref
  }, tokens), {}, {
    children: children
  }));
});
var Content_Content = (0,useDesignTokens/* withDesignTokens */.Y)(ContentBase, function (_props, theme) {
  return {
    backgroundColor: theme.palette.neutrals.white[100]
  };
}, {
  twilioLight: function twilioLight() {
    return {};
  },
  light: function light() {
    return {};
  },
  dark: function dark() {
    return {};
  },
  twilioDark: function twilioDark() {
    return {};
  }
});
/* harmony default export */ var Dropdown_Content_Content = (Content_Content);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/Dropdown/Content/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/Dropdown/Tray/Tray.views.ts

var Tray = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e2uz82g0"
} : 0)("padding:32px;background:", function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor;
}, ";" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/Dropdown/Tray/Tray.tsx


function Tray_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Tray_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Tray_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Tray_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var TrayBase = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      tokens = _ref.tokens;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tray, Tray_objectSpread(Tray_objectSpread({
    ref: ref
  }, tokens), {}, {
    children: children
  }));
});
var Tray_Tray = (0,useDesignTokens/* withDesignTokens */.Y)(TrayBase, function () {
  return {};
}, {
  twilioLight: function twilioLight(theme) {
    return {
      backgroundColor: theme.palette.twilio.gray[10]
    };
  },
  twilioDark: function twilioDark(theme) {
    return {
      backgroundColor: theme.palette.twilio.gray[10]
    };
  },
  light: function light(theme) {
    return {
      backgroundColor: theme.palette.brand.darkAcai[200]
    };
  },
  dark: function dark(theme) {
    return {
      backgroundColor: theme.palette.brand.darkAcai[200]
    };
  }
});
/* harmony default export */ var Dropdown_Tray_Tray = (Tray_Tray);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/Dropdown/Tray/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/Dropdown/index.ts



;// CONCATENATED MODULE: ../../libs/templates/Navigation/DesktopNavigation/Dropdowns/Products.tsx










var Products_Products = function Products() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();

  var _productsData = products(pageConfig),
      content = _productsData.content,
      bottomLinks = _productsData.bottomLinks,
      aside = _productsData.aside;

  var _useNavigation = Navigation_useNavigation(content.links[0].id),
      activeDropdown = _useNavigation.activeDropdown,
      setActiveDropdown = _useNavigation.setActiveDropdown;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Dropdown_Dropdown, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Dropdown_Content_Content, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_DesktopNavigation/* Subheading */.pm, {
        children: content.title
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_DesktopNavigation/* List */.aV, {
        children: content.links.map(function (item) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
            role: "none",
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_DesktopNavigation/* Link */.rU, {
              "aria-haspopup": "true",
              "aria-expanded": activeDropdown === item.id,
              iconEnd: activeDropdown === item.id ? Navigation_ArrowRight : undefined,
              onClick: function onClick() {
                return setActiveDropdown(item.id);
              },
              title: item.title,
              description: item.description,
              iconStart: item.icon
            })
          }, item.title);
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_DesktopNavigation/* List */.aV, {
        children: bottomLinks.map(function (item) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
            role: "none",
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_DesktopNavigation/* Link */.rU, {
              "aria-haspopup": "true",
              "aria-expanded": activeDropdown === item.id,
              iconEnd: activeDropdown === item.id ? Navigation_ArrowRight : undefined,
              onClick: function onClick() {
                return setActiveDropdown(item.id);
              },
              title: item.title
            })
          }, item.title);
        })
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dropdown_Tray_Tray, {
      children: aside.map(function (_ref) {
        var title = _ref.title,
            links = _ref.links,
            id = _ref.id;
        return activeDropdown === id && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_DesktopNavigation/* Subheading */.pm, {
            children: title
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_DesktopNavigation/* List */.aV, {
            children: links.map(function (item) {
              return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                role: "none",
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_DesktopNavigation/* Link */.rU, {
                  title: item.title,
                  description: item === null || item === void 0 ? void 0 : item.description,
                  href: item.url
                }, item.title)
              }, item.title);
            })
          })]
        }, title);
      })
    })]
  });
};

/* harmony default export */ var Dropdowns_Products = (Products_Products);
;// CONCATENATED MODULE: ../../libs/templates/Navigation/DesktopNavigation/Dropdowns/Docs.tsx


function Docs_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}








var Docs_Docs = function Docs() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();

  var _docsData = docs(pageConfig),
      content = _docsData.content,
      aside = _docsData.aside;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Dropdown_Dropdown, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Dropdown_Content_Content, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_DesktopNavigation/* Subheading */.pm, {
        children: content.title
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Navigation_DesktopNavigation/* List */.aV, {
        children: [content.links.map(function (item) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
            role: "none",
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_DesktopNavigation/* Link */.rU, {
              title: item.title,
              href: item.url
            })
          }, item.title);
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
          role: "none",
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HighlightedLink, {
            title: content.highlightedLink.title,
            href: content.highlightedLink.url
          })
        })]
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Dropdown_Tray_Tray, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_DesktopNavigation/* Subheading */.pm, {
        children: aside.title
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_DesktopNavigation/* List */.aV, {
        children: aside.links.map(function (item) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
            role: "none",
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_DesktopNavigation/* Link */.rU, {
              title: item.title,
              description: item.description,
              href: item.url
            })
          }, item.title);
        })
      })]
    })]
  });
};

var HighlightedLink = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Navigation_DesktopNavigation/* LinkHighlighted */.xc,  true ? {
  target: "e10vqfck0"
} : 0)( true ? {
  name: "hkh81z",
  styles: "margin-top:8px"
} : 0);

/* harmony default export */ var Dropdowns_Docs = (Docs_Docs);
;// CONCATENATED MODULE: ../../libs/templates/Navigation/DesktopNavigation/Dropdowns/Resources.tsx









var Resources_Resources = function Resources() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();

  var _resourcesData = resources(pageConfig),
      content = _resourcesData.content,
      aside = _resourcesData.aside;

  var _useNavigation = Navigation_useNavigation(content.links[0].id),
      activeDropdown = _useNavigation.activeDropdown,
      setActiveDropdown = _useNavigation.setActiveDropdown;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Dropdown_Dropdown, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Dropdown_Content_Content, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_DesktopNavigation/* Subheading */.pm, {
        children: content.title
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_DesktopNavigation/* List */.aV, {
        children: content.links.map(function (item) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
            role: "none",
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_DesktopNavigation/* Link */.rU, {
              "aria-haspopup": "true",
              "aria-expanded": activeDropdown === item.id,
              iconEnd: activeDropdown === item.id ? Navigation_ArrowRight : undefined,
              onClick: function onClick() {
                return setActiveDropdown(item.id);
              },
              title: item.title
            })
          }, item.title);
        })
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dropdown_Tray_Tray, {
      children: aside.map(function (_ref) {
        var title = _ref.title,
            links = _ref.links,
            id = _ref.id;
        return activeDropdown === id && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_DesktopNavigation/* Subheading */.pm, {
            children: title
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_DesktopNavigation/* List */.aV, {
            children: links.map(function (item) {
              return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                role: "none",
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_DesktopNavigation/* Link */.rU, {
                  title: item.title,
                  description: item.description,
                  href: item.url
                })
              }, item.title);
            })
          })]
        }, title);
      })
    })]
  });
};

/* harmony default export */ var Dropdowns_Resources = (Resources_Resources);
;// CONCATENATED MODULE: ../../libs/templates/Navigation/DesktopNavigation/Dropdowns/Solutions.tsx











var Solutions_Solutions = function Solutions() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();

  var _solutionsData = solutions(pageConfig),
      content = _solutionsData.content,
      aside = _solutionsData.aside;

  var _useNavigation = Navigation_useNavigation(content.links[0].id),
      activeDropdown = _useNavigation.activeDropdown,
      setActiveDropdown = _useNavigation.setActiveDropdown;

  var _useState = (0,react.useState)(content.links[0].title),
      currentAsideTitle = _useState[0],
      setCurrentAsideTitle = _useState[1];

  (0,react.useEffect)(function () {
    var currentLink = content.links.find(function (link) {
      return link.id === activeDropdown;
    });

    if (currentLink) {
      setCurrentAsideTitle(currentLink.title);
    }
  }, [activeDropdown, content.links]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Dropdown_Dropdown, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Dropdown_Content_Content, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_DesktopNavigation/* Subheading */.pm, {
        children: aside[0].title
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_DesktopNavigation/* List */.aV, {
        children: content.links.map(function (item) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
            role: "none",
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_DesktopNavigation/* Link */.rU, {
              "aria-haspopup": "true",
              "aria-expanded": activeDropdown === item.id,
              iconEnd: activeDropdown === item.id ? Navigation_ArrowRight : undefined,
              onClick: function onClick() {
                setActiveDropdown(item.id);
              },
              title: item.title,
              description: item.description
            })
          }, item.title);
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_DesktopNavigation/* List */.aV, {
        children: content.additionalLinks.links.map(function (item) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
            role: "none",
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_DesktopNavigation/* Link */.rU, {
              title: item.title,
              description: item.description,
              href: item.url
            })
          }, item.title);
        })
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dropdown_Tray_Tray, {
      children: aside.map(function (_ref) {
        var title = _ref.title,
            links = _ref.links,
            id = _ref.id;
        return activeDropdown === id && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_DesktopNavigation/* Subheading */.pm, {
            children: currentAsideTitle
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_DesktopNavigation/* List */.aV, {
            children: links.map(function (item) {
              return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                role: "none",
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_DesktopNavigation/* Link */.rU, {
                  title: item.title,
                  description: item.description,
                  href: item.url
                })
              }, item.title);
            })
          })]
        }, title);
      })
    })]
  });
};

/* harmony default export */ var Dropdowns_Solutions = (Solutions_Solutions);
// EXTERNAL MODULE: ../../node_modules/@floating-ui/react/dist/floating-ui.react.mjs + 1 modules
var floating_ui_react = __webpack_require__(63607);
// EXTERNAL MODULE: ../../node_modules/@floating-ui/dom/dist/floating-ui.dom.mjs
var floating_ui_dom = __webpack_require__(75580);
// EXTERNAL MODULE: ../../node_modules/@floating-ui/react-dom/dist/floating-ui.react-dom.mjs
var floating_ui_react_dom = __webpack_require__(92416);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Navigation/DesktopNavigation/Navbar/ToggleIcon/index.ts + 3 modules
var ToggleIcon = __webpack_require__(63115);
;// CONCATENATED MODULE: ../../libs/templates/Navigation/DesktopNavigation/SupportMenu.tsx



function SupportMenu_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function SupportMenu_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? SupportMenu_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SupportMenu_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function SupportMenu_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}










var SupportMenu = function SupportMenu(_ref) {
  var links = _ref.links;
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();

  var _useState = (0,react.useState)(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var arrowRef = (0,react.useRef)(null);

  var _useFloating = (0,floating_ui_react/* useFloating */.YF)({
    open: isOpen,
    onOpenChange: setIsOpen,
    placement: "bottom",
    whileElementsMounted: floating_ui_dom/* autoUpdate */.Me,
    middleware: [(0,floating_ui_dom/* autoPlacement */.X5)(), (0,floating_ui_dom/* flip */.RR)({
      fallbackAxisSideDirection: "start"
    }), (0,floating_ui_dom/* shift */.uY)(), (0,floating_ui_react_dom/* arrow */.x7)({
      element: arrowRef
    })]
  }),
      refs = _useFloating.refs,
      floatingStyles = _useFloating.floatingStyles,
      context = _useFloating.context;

  var focus = (0,floating_ui_react/* useFocus */.KK)(context);
  var click = (0,floating_ui_react/* useClick */.eS)(context);
  var dismiss = (0,floating_ui_react/* useDismiss */.bQ)(context);
  var role = (0,floating_ui_react/* useRole */.qs)(context, {
    role: "tooltip"
  });

  var _useTransitionStyles = (0,floating_ui_react/* useTransitionStyles */.Y_)(context, {
    duration: 100
  }),
      isMounted = _useTransitionStyles.isMounted,
      styles = _useTransitionStyles.styles;

  var _useInteractions = (0,floating_ui_react/* useInteractions */.NI)([click, focus, dismiss, role]),
      getReferenceProps = _useInteractions.getReferenceProps,
      getFloatingProps = _useInteractions.getFloatingProps;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SupportMenuWrapper, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", SupportMenu_objectSpread(SupportMenu_objectSpread({
      ref: refs.setReference
    }, getReferenceProps()), {}, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ButtonTextSmall, {
        size: "small",
        role: "combobox",
        "aria-expanded": "false",
        "aria-label": links.title,
        "aria-owns": "support-menu",
        "aria-haspopup": "menu",
        id: "support-menu-button",
        variant: "mono",
        "aria-controls": "example-menu",
        hover: isOpen,
        tokens: isOpen ? {
          textColor: theme.palette.twilio.blue[60],
          hoverColor: theme.palette.twilio.blue[60]
        } : undefined,
        children: [links.title, (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToggleIcon/* default */.Z, {
          open: isOpen
        })]
      })
    })), isMounted && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Body, SupportMenu_objectSpread(SupportMenu_objectSpread({
      "aria-labelledby": "support-menu-button",
      role: "menu",
      id: "support-menu",
      ref: refs.setFloating,
      style: SupportMenu_objectSpread(SupportMenu_objectSpread({}, floatingStyles), styles)
    }, getFloatingProps()), {}, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuWrapper, {
        children: isOpen && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_DesktopNavigation/* SupportMenu */.UK, {
          children: links.links.map(function (el) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation_DesktopNavigation/* SupportLink */.Ll, {
              href: el.url,
              children: el.title
            }, el.title);
          })
        })
      })
    }))]
  });
};

var SupportMenuWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1hx0n783"
} : 0)( true ? {
  name: "179t5g5",
  styles: "position:relative;z-index:1"
} : 0);

var Body = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1hx0n782"
} : 0)( true ? {
  name: "180hzy6",
  styles: "margin-top:11px"
} : 0);

var MenuWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1hx0n781"
} : 0)( true ? {
  name: "1adi3ip",
  styles: "min-width:160px"
} : 0);

var ButtonTextSmall = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ButtonText/* default */.Z,  true ? {
  target: "e1hx0n780"
} : 0)("font-size:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.typography.buttonSmall;
}, ";" + ( true ? "" : 0));

/* harmony default export */ var DesktopNavigation_SupportMenu = (SupportMenu);
;// CONCATENATED MODULE: ../../libs/templates/Navigation/DesktopNavigation/DesktopNavigation.tsx



function DesktopNavigation_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function DesktopNavigation_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? DesktopNavigation_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : DesktopNavigation_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

















var DesktopNavigation = function DesktopNavigation(_ref) {
  var announcement = _ref.announcement;
  var pageConfig = (0,page/* usePageConfig */.Gm)();

  var _useNavigation = Navigation_useNavigation(),
      getDropdownLinkProps = _useNavigation.getDropdownLinkProps;

  var _utilityData = utility(pageConfig),
      demoButton = _utilityData.demoButton,
      loginButton = _utilityData.loginButton,
      links = _utilityData.links,
      signUpButton = _utilityData.signUpButton;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Navigation_DesktopNavigation/* default */.ZP, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Navigation_DesktopNavigation/* UtilityNav */.T8, {
      announcement: announcement,
      children: [links.map(function (el) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DesktopNavigation_SupportMenu, {
          links: el
        }, el.title);
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DesktopNavigation_ButtonTextSmall, {
        size: "small",
        variant: "mono",
        href: loginButton.url,
        children: loginButton.text
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Navigation_DesktopNavigation/* Navbar */.wp, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DesktopNavigation_Navbar/* Brand */.H2, {
        href: "/",
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo/* default */.Z, {
          alt: "Twilio, Inc."
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DesktopNavigation_Navbar/* Content */.VY, {
        role: "menubar",
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
          role: "none",
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DesktopNavigation_Navbar/* Link */.rU, DesktopNavigation_objectSpread(DesktopNavigation_objectSpread({
            role: "menuitem",
            title: "Products"
          }, getDropdownLinkProps("products")), {}, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dropdowns_Products, {})
          }))
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
          role: "none",
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DesktopNavigation_Navbar/* Link */.rU, DesktopNavigation_objectSpread(DesktopNavigation_objectSpread({
            role: "menuitem",
            title: "Solutions"
          }, getDropdownLinkProps("solutions")), {}, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dropdowns_Solutions, {})
          }))
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
          role: "none",
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DesktopNavigation_Navbar/* Link */.rU, {
            role: "menuitem",
            title: "Pricing",
            href: "/pricing/"
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
          role: "none",
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DesktopNavigation_Navbar/* Link */.rU, DesktopNavigation_objectSpread(DesktopNavigation_objectSpread({
            role: "menuitem",
            title: "Docs"
          }, getDropdownLinkProps("docs")), {}, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dropdowns_Docs, {})
          }))
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
          role: "none",
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DesktopNavigation_Navbar/* Link */.rU, DesktopNavigation_objectSpread(DesktopNavigation_objectSpread({
            role: "menuitem",
            title: "Resources"
          }, getDropdownLinkProps("resources")), {}, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dropdowns_Resources, {})
          }))
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DesktopNavigation_Navbar/* Aside */.xN, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
          href: signUpButton.url,
          size: "small",
          variant: "mono",
          children: signUpButton.text
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
          size: "medium",
          color: "primary",
          variant: "filled",
          href: demoButton.url,
          children: demoButton.text
        })]
      })]
    })]
  });
};

/* harmony default export */ var DesktopNavigation_DesktopNavigation = (DesktopNavigation);

var DesktopNavigation_ButtonTextSmall = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ButtonText/* default */.Z,  true ? {
  target: "e1uv8xvu0"
} : 0)("font-size:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.typography.buttonSmall;
}, ";" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../libs/templates/Navigation/DesktopNavigation/index.ts

;// CONCATENATED MODULE: ../../libs/templates/Navigation/Navigation.tsx






var Navigation = function Navigation(_ref) {
  var announcement = _ref.announcement,
      mobileAnnouncement = _ref.mobileAnnouncement,
      after = _ref.after;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Media/* default */.Z, {
      lessThan: "lg",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileNavigation_MobileNavigation, {
        announcement: mobileAnnouncement || announcement
      }), after]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Media/* default */.Z, {
      greaterThanOrEqual: "lg",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DesktopNavigation_DesktopNavigation, {
        announcement: announcement
      }), after]
    })]
  });
};
/* harmony default export */ var Navigation_Navigation = (Navigation);
;// CONCATENATED MODULE: ../../libs/templates/Navigation/index.ts


/***/ })

}]);